"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2073,8105],{

/***/ 29267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var UseFocusFirstInvalidField = function(param) {
    var fieldNameInputRefMap = param.fieldNameInputRefMap;
    var ref = (0,formik__WEBPACK_IMPORTED_MODULE_0__.useFormikContext)(), submitCount = ref.submitCount, errors = ref.errors;
    var _firstInvalidField = Object.keys(errors)[0];
    var firstInvalidField = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return _firstInvalidField;
    }, [
        _firstInvalidField
    ]);
    var lastSubmitCount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (lastSubmitCount.current === submitCount || !firstInvalidField) return;
        lastSubmitCount.current = submitCount;
        // TODO: remove setTimeout
        setTimeout(function() {
            var ref, ref1;
            return (ref = fieldNameInputRefMap[firstInvalidField]) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
        });
    }, [
        submitCount,
        firstInvalidField,
        fieldNameInputRefMap
    ]);
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (UseFocusFirstInvalidField);


/***/ }),

/***/ 11439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13328);


var useShopUrl = function(modelId) {
    var selectedColorCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    var selectedDetailingCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.detailing;
    }).selectedDetailingCode;
    var selectedUpholsteryCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.upholstery;
    }).selectedUpholsteryCode;
    var selectedAccessoriesCodes = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.accessories;
    }).selectedAccessoriesCodes;
    var model = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.wizard;
    }).model;
    var getShopUrl = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!model || model.id !== modelId) return "/shop/".concat(modelId);
        var url = new URLSearchParams();
        if (selectedColorCode) url.append("color", selectedColorCode);
        if (selectedDetailingCode) url.append("detailing", selectedDetailingCode);
        if (selectedUpholsteryCode) url.append("upholstery", selectedUpholsteryCode);
        if (selectedAccessoriesCodes && Array.isArray(selectedAccessoriesCodes)) {
            selectedAccessoriesCodes.forEach(function(code) {
                return url.append("accessories", code);
            });
        }
        return "/shop/".concat(modelId, "?").concat(url.toString()) || 0;
    }, [
        model,
        modelId,
        selectedColorCode,
        selectedDetailingCode,
        selectedUpholsteryCode,
        selectedAccessoriesCodes, 
    ]);
    return getShopUrl;
};
/* harmony default export */ __webpack_exports__["Z"] = (useShopUrl);


/***/ }),

/***/ 94316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89659);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        " !important;\n  text-decoration: underline;\n  cursor: pointer;\n  p {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CardRowText__StyledText",
    componentId: "sc-d731630f-0"
})(_templateObject(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$font) && "font-family: ".concat(p === null || p === void 0 ? void 0 : p.$font, ";");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$fontSize) && "font-size: ".concat(p === null || p === void 0 ? void 0 : p.$fontSize, "px;");
});
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CardRowText__StyledContent",
    componentId: "sc-d731630f-1"
})(_templateObject1());
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "CardRowText__StyledLink",
    componentId: "sc-d731630f-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.colors.saphire;
});
var CardRowText = function(param) {
    var data = param.data, iconName = param.iconName, _link = param.link, link = _link === void 0 ? "" : _link, _iconInMobile = param.iconInMobile, iconInMobile = _iconInMobile === void 0 ? false : _iconInMobile, font = param.font, fontSize = param.fontSize, imageAlt = param.imageAlt, trackEvent = param.trackEvent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContent, {
            onClick: function() {
                return trackEvent && trackEvent();
            },
            children: [
                iconName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: iconInMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .Mobile */ .ij, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .StyledSvgIcon */ .vV, {
                            src: "/icons/".concat(iconName, ".svg"),
                            alt: imageAlt
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .StyledSvgIcon */ .vV, {
                        src: "/icons/".concat(iconName, ".svg"),
                        alt: imageAlt
                    })
                }),
                link !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
                    href: link,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                        $font: font,
                        $fontSize: fontSize,
                        children: data
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                    $font: font,
                    $fontSize: fontSize,
                    children: data
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardRowText);


/***/ }),

/***/ 17946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zx": function() { return /* binding */ Font; },
  "ZP": function() { return /* binding */ showRooms_ShowRoomItem; }
});

// UNUSED EXPORTS: FontSize

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./components/mapPages/CardRowText.tsx
var CardRowText = __webpack_require__(94316);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Link/Link.js
var Link = __webpack_require__(89659);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/mapPages/showRooms/ManagerBox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  img {\n    border-radius: 50%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  text-decoration: underline;\n  cursor: pointer;\n  p {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ManagerBox__StyledContent",
    componentId: "sc-2691e267-0"
})(_templateObject());
var StyledSmallText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "ManagerBox__StyledSmallText",
    componentId: "sc-2691e267-1"
})(_templateObject1(), function(p) {
    return p.$bold ? "bold" : "300";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    displayName: "ManagerBox__StyledLink",
    componentId: "sc-2691e267-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.colors.saphire;
});
var ManagerBox = function(param) {
    var showRoom = param.showRoom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerName) && (showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerEmail) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: showRoom.managerImage ? showRoom.managerImage.imageUrl : "/img/managerPlaceholder.png",
                    alt: showRoom.managerImage ? showRoom.managerImage.alt : "manager",
                    width: 50,
                    height: 50,
                    objectFit: "cover",
                    priority: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        (showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSmallText, {
                            children: showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerName
                        }),
                        showRoom.managerEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: "mailto:".concat(showRoom.managerEmail),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSmallText, {
                                children: showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerEmail
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var showRooms_ManagerBox = (ManagerBox);

;// CONCATENATED MODULE: ./components/mapPages/showRooms/ShowRoomItem.tsx

function ShowRoomItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 0px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background-color: ",
        ";\n  padding: 20px 15px;\n  border-radius: 6px;\n  border: 1.5px solid\n    ",
        ";\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    ShowRoomItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShowRoomItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  ",
        " {\n    width: 50%;\n  }\n"
    ]);
    ShowRoomItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShowRoomItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  display: inline-block;\n"
    ]);
    ShowRoomItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  align-items: start;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: auto;\n  flex-grow: 1;\n  flex-shrink: 0;\n  background-color: ",
        ";\n  width: 0.5px;\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: -4px;\n  margin-top: -1px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledWrapper",
    componentId: "sc-4736824-0"
})(ShowRoomItem_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$selected ? p.theme.colors.saphire : p.theme.colors.transparent;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledColumn",
    componentId: "sc-4736824-1"
})(ShowRoomItem_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "ShowRoomItem__StyledHeadline",
    componentId: "sc-4736824-2"
})(ShowRoomItem_templateObject2());
var StyledContentStart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledContentStart",
    componentId: "sc-4736824-3"
})(_templateObject3());
var StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledDivider",
    componentId: "sc-4736824-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(shared/* StyledSvgIcon */.vV).withConfig({
    displayName: "ShowRoomItem__StyledIcon",
    componentId: "sc-4736824-5"
})(_templateObject5());
var StyledButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledButtonWrap",
    componentId: "sc-4736824-6"
})(_templateObject6());
var StyledMobileIcon = (0,styled_components_browser_esm/* default */.ZP)(shared/* StyledSvgIcon */.vV).withConfig({
    displayName: "ShowRoomItem__StyledMobileIcon",
    componentId: "sc-4736824-7"
})(_templateObject7(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$left) && "left: ".concat(p.$left, "px;");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$top) && "top: ".concat(p.$top, "px;");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$flip) && "transform: rotateY(180deg);";
});
var Font;
(function(Font) {
    Font["OENaPro"] = "OENaPro";
    Font["MazdaType"] = "MazdaType, OENaPro, sans serif";
})(Font || (Font = {}));
var FontSize;
(function(FontSize) {
    FontSize[FontSize["small"] = 16] = "small";
    FontSize[FontSize["large"] = 18] = "large";
})(FontSize || (FontSize = {}));
var ShowRoomItem = function(param) {
    var showRoom = param.showRoom, isShowRoomSelected = param.isShowRoomSelected;
    var ref = (0,react.useRef)(null);
    if (isShowRoomSelected) {
        var ref1;
        (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
            block: "nearest"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        $selected: isShowRoomSelected,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            src: "/icons/mazdaLocationIcon.svg",
                            w: 32,
                            h: 40
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                        children: showRoom === null || showRoom === void 0 ? void 0 : showRoom.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: showRoom.address,
                        iconName: "mazdaLocationIcon",
                        iconInMobile: true,
                        font: Font.OENaPro,
                        fontSize: FontSize.large
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: showRoom.whatsapp,
                        link: "https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0",
                        iconName: "whatsappLogo",
                        font: Font.MazdaType,
                        fontSize: FontSize.small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: showRoom.phone,
                        link: "tel:".concat(showRoom.phone),
                        iconName: "phoneCall",
                        font: Font.MazdaType,
                        fontSize: FontSize.small,
                        trackEvent: analytics/* trackPhoneShowroomPageClicks */.ib
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: showRoom.fax && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                            data: showRoom.fax,
                            iconName: "fax",
                            font: Font.MazdaType,
                            fontSize: FontSize.small
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                            src: "/icons/clock.svg",
                            w: 35,
                            h: 35
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContentStart, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                    src: "/icons/clock.svg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                                        children: "שעות פעילות"
                                    }),
                                    showRoom.stringShowRoomsSchedule.map(function(openingHour, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledRow */.N0, {
                                            $mt: "7px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                                                data: openingHour,
                                                font: Font.OENaPro,
                                                fontSize: FontSize.large
                                            })
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(showRooms_ManagerBox, {
                        showRoom: showRoom
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                    $gap: "10px",
                    $fullWidth: true,
                    children: [
                        showRoom.wazeLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: showRoom.wazeLink,
                                openInNewTab: true,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileIcon, {
                                            src: "/icons/navigationArrow.svg",
                                            w: 15,
                                            h: 15,
                                            $left: 5,
                                            $top: 1,
                                            $flip: true
                                        }),
                                        "ניווט ב-Waze"
                                    ]
                                })
                            })
                        }),
                        showRoom.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: "tel:".concat(showRoom.phone),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileIcon, {
                                            src: "/icons/phoneCall.svg",
                                            w: 18,
                                            h: 18,
                                            $left: 5
                                        }),
                                        "חיוג"
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var showRooms_ShowRoomItem = (/*#__PURE__*/(0,react.memo)(ShowRoomItem));


/***/ }),

/***/ 21933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ selectedAccessoriesSelector; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

// export const selectedAccessoriesSelector = createSelector<
//   RootState,
//   AccessoriesState["accessories"],
//   AccessoriesState["selectedAccessoriesCodes"],
//   AccessoriesState["accessories"]
// >(
//   (state) => state.accessories.accessories,
//   (state) => state.accessories.selectedAccessoriesCodes,
//   (accessories, selectedAccessoriesCodes) =>
//     accessories.filter((accessory) =>
//       selectedAccessoriesCodes.includes(accessory.details.code)
//     )
// )
var selectedAccessoriesSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.accessories.accessories;
}, function(state) {
    return state.accessories.selectedAccessoriesCodes;
}, function(accessories, selectedAccessoriesCodes) {
    return accessories.filter(function(accessory) {
        return selectedAccessoriesCodes.includes(accessory.details.code);
    });
});


/***/ }),

/***/ 75222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ selectedColorSelector; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

// export const selectedColorSelector = createSelector<
//   RootState,
//   ColorState["colors"][number] | undefined
// >(
//   (state) => state.color.colors,
//   (state) => state.color.selectedColorCode,
//   (colors, selectedColorCode) =>
//     colors.find((color): => color.details.code === selectedColorCode)
// )
var selectedColorSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.color.colors;
}, function(state) {
    return state.color.selectedColorCode;
}, function(colors, selectedColorCode) {
    return colors.find(function(color) {
        return color.details.code === selectedColorCode;
    });
});


/***/ }),

/***/ 78615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DI": function() { return /* binding */ selectedEngineSelector; },
/* harmony export */   "YF": function() { return /* binding */ selectedDetailingSelector; }
/* harmony export */ });
/* unused harmony export previousDetailingNameSelector */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

// export const selectedDetailingSelector = createSelector<
//   RootState,
//   DetailingState["detailings"],
//   DetailingState["selectedDetailingCode"],
//   DetailingState["detailings"][number] | undefined
// >(
//   (state) => state.detailing.detailings,
//   (state) => state.detailing.selectedDetailingCode,
//   (detailings, selectedDetailingCode) =>
//     detailings.find(
//       (detailing) => detailing.details.code === selectedDetailingCode
//     )
// )
// export const previousDetailingNameSelector = createSelector<
//   RootState,
//   DetailingState["detailings"],
//   DetailingState["selectedDetailingCode"],
//   DetailingState["detailings"][number]["details"]["name"] | null
// >(
//   (state) => state.detailing.detailings,
//   (state) => state.detailing.selectedDetailingCode,
//   (detailings, selectedDetailingCode) => {
//     const selectedDetailingIndex = detailings.findIndex(
//       (detailing) => detailing.details.code === selectedDetailingCode
//     )
//     if (selectedDetailingIndex <= 0) return null
//     return detailings[selectedDetailingIndex - 1].details.name
//   }
// )
var selectedDetailingSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.detailing.detailings;
}, function(state) {
    return state.detailing.selectedDetailingCode;
}, function(detailings, selectedDetailingCode) {
    return detailings.find(function(detailing) {
        return detailing.details.code === selectedDetailingCode;
    });
});
var selectedEngineSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.detailing.engines;
}, function(state) {
    return state.detailing.selectedDetailingCode;
}, function(engines, selectedDetailingCode) {
    return engines.find(function(engine) {
        return engine.finishingLevels.some(function(detailing) {
            return detailing.details.code === selectedDetailingCode;
        });
    });
});
var previousDetailingNameSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.detailing.detailings;
}, function(state) {
    return state.detailing.selectedDetailingCode;
}, function(detailings, selectedDetailingCode) {
    var selectedDetailingIndex = detailings.findIndex(function(detailing) {
        return detailing.details.code === selectedDetailingCode;
    });
    if (selectedDetailingIndex <= 0) return null;
    return detailings[selectedDetailingIndex - 1].details.name;
});


/***/ }),

/***/ 79542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J6": function() { return /* binding */ getColorImages; }
/* harmony export */ });
/* unused harmony export retrieveImages */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  /* height: ",
        "; */\n  aspect-ratio: ",
        ";\n  object-fit: cover;\n  border-radius: 2px;\n  margin-bottom: 3px;\n\n  :nth-child(3n - 1) {\n    margin-left: 10px;\n  }\n\n  ",
        " {\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var getColorImages = function(state) {
    var ref, ref1;
    var selectedColorCode = state === null || state === void 0 ? void 0 : (ref = state.color) === null || ref === void 0 ? void 0 : ref.selectedColorCode;
    var colors = state === null || state === void 0 ? void 0 : (ref1 = state.color) === null || ref1 === void 0 ? void 0 : ref1.colors;
    return colors.reduce(function(a, b) {
        var ref;
        if (a.length !== 0) return a;
        if ((b === null || b === void 0 ? void 0 : (ref = b.details) === null || ref === void 0 ? void 0 : ref.code) === selectedColorCode) {
            return b;
        }
        return a;
    }, []);
};
var retrieveImages = function(state) {
    var ref, ref1, ref2, ref3;
    var selectedColorImages = getColorImages(state);
    var outsideImages = selectedColorImages === null || selectedColorImages === void 0 ? void 0 : (ref = selectedColorImages.details) === null || ref === void 0 ? void 0 : ref.outsideImages;
    var selectedUpholsteryCode = state === null || state === void 0 ? void 0 : (ref1 = state.upholstery) === null || ref1 === void 0 ? void 0 : ref1.selectedUpholsteryCode;
    var selectedUpholsteryImages = state === null || state === void 0 ? void 0 : (ref2 = state.upholstery) === null || ref2 === void 0 ? void 0 : ref2.upholsteries.reduce(function(a, b) {
        var ref;
        if (a.length !== 0) return a;
        if ((b === null || b === void 0 ? void 0 : (ref = b.details) === null || ref === void 0 ? void 0 : ref.code) === selectedUpholsteryCode) {
            return b;
        }
        return a;
    }, []);
    var insideImages = selectedUpholsteryImages === null || selectedUpholsteryImages === void 0 ? void 0 : (ref3 = selectedUpholsteryImages.details) === null || ref3 === void 0 ? void 0 : ref3.insideImages;
    if (!insideImages || !outsideImages) return [];
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(outsideImages).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(insideImages));
};
var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SummaryGallery__StyledImageContainer",
    componentId: "sc-7c7bcca2-0"
})(_templateObject());
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    displayName: "SummaryGallery__StyledImg",
    componentId: "sc-7c7bcca2-1"
})(_templateObject1(), function(p) {
    return p.$small ? "calc(50% - 5px)" : "100%";
}, function(p) {
    return p.$small ? "320px" : "400px";
}, function(p) {
    return p.$small ? "380/320" : "770/400";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$small ? "130px" : "200px";
});
var SummaryGallery = function(param) {
    var className = param.className;
    var state = (0,store__WEBPACK_IMPORTED_MODULE_2__/* .useTypedSelector */ .ix)(function(state) {
        return state;
    });
    var images = retrieveImages(state);
    var index = 0;
    var checkIfSmall = function(i) {
        if (i === 0) {
            return false;
        }
        if (index === 2) {
            index = 0;
            return false;
        }
        index++;
        return true;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        className: className,
        children: images.map(function(image, i) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImg, {
                $small: checkIfSmall(i),
                src: image === null || image === void 0 ? void 0 : image.imageUrl,
                alt: image === null || image === void 0 ? void 0 : image.alt
            }, i + (image === null || image === void 0 ? void 0 : image.imageUrl));
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (SummaryGallery);


/***/ }),

/***/ 66402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ selectedUpholsterySelector; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

// export const selectedUpholsterySelector = createSelector<
//   RootState,
//   UpholsteryState["upholsteries"],
//   UpholsteryState["selectedUpholsteryCode"],
//   UpholsteryState["upholsteries"][number] | undefined
// >(
//   (state) => state.upholstery.upholsteries,
//   (state) => state.upholstery.selectedUpholsteryCode,
//   (upholsteries, selectedUpholsteryCode) =>
//     upholsteries.find(
//       (upholstery) => upholstery.details.code === selectedUpholsteryCode
//     )
// )
var selectedUpholsterySelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.upholstery.upholsteries;
}, function(state) {
    return state.upholstery.selectedUpholsteryCode;
}, function(upholsteries, selectedUpholsteryCode) {
    return upholsteries.find(function(upholstery) {
        return upholstery.details.code === selectedUpholsteryCode;
    });
});


/***/ }),

/***/ 64633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ wizard_Wizard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button_Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js
var ThemeProvider = __webpack_require__(97555);
// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/hooks/useShopUrl.tsx
var useShopUrl = __webpack_require__(11439);
// EXTERNAL MODULE: ./layout/oldLayout/LayoutContext.tsx
var LayoutContext = __webpack_require__(32875);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js
var react_router = __webpack_require__(16550);
// EXTERNAL MODULE: ./routes.ts
var routes_0 = __webpack_require__(59086);
// EXTERNAL MODULE: ./store.ts + 2 modules
var store = __webpack_require__(13328);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shopTheme.ts
var shopTheme = __webpack_require__(94526);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography_Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./common/useRedirectIfPreviousComponentsAreNotSelected.ts




/**
 * Redirect to the relevant step if some required component isn't selected.
 *
 * For example, if there's no selected color then redirect to the color step.
 *
 * @returns `true` if all required components are selected, otherwise `false`
 */ function useRedirectIfPreviousComponentsAreNotSelected() {
    var initialized = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).initialized;
    var selectedDetailingCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.detailing;
    }).selectedDetailingCode;
    var selectedColorCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    var selectedUpholsteryCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.upholstery;
    }).selectedUpholsteryCode;
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var history = (0,react_router/* useHistory */.k6)();
    var currentStepIsAfter = (0,react.useCallback)(function(step) {
        var currentStepIndex = routes_0/* default.array.findIndex */.Z.array.findIndex(function(r) {
            return r.path === pathname;
        });
        return currentStepIndex > routes_0/* default.array.indexOf */.Z.array.indexOf(routes_0/* default */.Z[step]);
    }, [
        pathname
    ]);
    (0,react.useEffect)(function() {
        if (!initialized) return;
        if (!selectedDetailingCode && currentStepIsAfter("detailing")) history.replace(routes_0/* default.detailing.path */.Z.detailing.path);
        else if (!selectedColorCode && currentStepIsAfter("color")) history.replace(routes_0/* default.color.path */.Z.color.path);
        else if (!selectedUpholsteryCode && currentStepIsAfter("upholstery")) history.replace(routes_0/* default.upholstery.path */.Z.upholstery.path);
    }, [
        initialized,
        currentStepIsAfter,
        selectedDetailingCode,
        selectedColorCode,
        selectedUpholsteryCode,
        history, 
    ]);
    return Boolean(selectedDetailingCode && selectedColorCode && selectedUpholsteryCode);
}

;// CONCATENATED MODULE: ./common/price.ts
/**
 * Format a number as a price, i.e: add thousand separators and prepend the ILS
 * currency symbol.
 *
 * @param price The price
 *
 * @returns A formatted price string
 */ function formatPrice(price) {
    // TODO: Remove this
    if (!price) return "₪0";
    return "₪" + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

;// CONCATENATED MODULE: ./common/Strikethrough.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: inline-block;\n  position: relative;\n\n  :before {\n    content: "";\n    position: absolute;\n    left: -0.1em;\n    right: -0.1em;\n    top: 0.38em;\n    bottom: 0.38em;\n    background: linear-gradient(\n      to left top,\n      transparent 0%,\n      transparent calc(50% - 0.07em),\n      currentColor 50.5%,\n      transparent calc(50% + 0.07em),\n      transparent 100%\n    );\n    pointer-events: none;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Strikethrough = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Strikethrough",
    componentId: "sc-4f12bd79-0"
})(_templateObject());
/* harmony default export */ var common_Strikethrough = (Strikethrough);

// EXTERNAL MODULE: ./reusable/formsComp/checkbox/CheckBoxIcon.tsx
var CheckBoxIcon = __webpack_require__(24312);
// EXTERNAL MODULE: ./reusable/formsComp/checkbox/CheckBoxSelectedIcon.tsx
var CheckBoxSelectedIcon = __webpack_require__(70612);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
;// CONCATENATED MODULE: ./components/shopFeatures/accessories/Accessory.tsx

function Accessory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n  background-color: ",
        ";\n"
    ]);
    Accessory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 0;\n  padding-bottom: ",
        "%;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 15px 10px;\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.75rem;\n  line-height: 1;\n\n  color: ",
        ";\n  margin-bottom: 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.875rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n  margin-left: 0.5em;\n  ~ ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1rem;\n  margin-bottom: 10px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.75rem;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  opacity: ",
        ";\n  visibility: ",
        ";\n  transition: all 0.3s ease-in-out;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}








var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accessory__StyledContainer",
    componentId: "sc-efabdad2-0"
})(Accessory_templateObject(), function(p) {
    return p.theme.colors.white;
});
var StyledImageWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accessory__StyledImageWrap",
    componentId: "sc-efabdad2-1"
})(_templateObject1(), 83 * 100 / 160);
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "Accessory__StyledImage",
    componentId: "sc-efabdad2-2"
})(_templateObject2());
var StyledDetailsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accessory__StyledDetailsWrap",
    componentId: "sc-efabdad2-3"
})(_templateObject3());
var StyledDiscount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accessory__StyledDiscount",
    componentId: "sc-efabdad2-4"
})(_templateObject4(), colors/* default.disable */.Z.disable);
var StyledPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accessory__StyledPrice",
    componentId: "sc-efabdad2-5"
})(_templateObject5());
var StyledActualPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Accessory__StyledActualPrice",
    componentId: "sc-efabdad2-6"
})(_templateObject6());
var StyledDiscountPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Accessory__StyledDiscountPrice",
    componentId: "sc-efabdad2-7"
})(_templateObject7(), function(p) {
    return p.theme.colors.mazdaRed;
}, StyledActualPrice, function(p) {
    return p.theme.colors.disable;
});
var StyledName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accessory__StyledName",
    componentId: "sc-efabdad2-8"
})(_templateObject8());
var StyledDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accessory__StyledDescription",
    componentId: "sc-efabdad2-9"
})(_templateObject9(), function(p) {
    return p.theme.palette.text.primary;
});
var StyledCheckboxWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Accessory__StyledCheckboxWrap",
    componentId: "sc-efabdad2-10"
})(_templateObject10(), function(p) {
    return p.$hide ? 0 : 1;
}, function(p) {
    return p.$hide ? "hidden" : "visible";
});
var Accessory = function(param) {
    var accessory = param.accessory, isSelected = param.isSelected, onSelect = param.onSelect;
    var ref;
    var onEnter = function(e) {
        if (e.key === "Enter") {
            onSelect();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        tabIndex: 0,
        role: "checkbox",
        "aria-checked": isSelected,
        onClick: onSelect,
        onKeyPress: onEnter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    src: (ref = accessory.details.image) === null || ref === void 0 ? void 0 : ref.imageUrl,
                    alt: accessory.details.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetailsWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrice, {
                        children: [
                            accessory.price.discount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                        variant: "srOnly",
                                        children: "מחיר קודם"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDiscountPrice, {
                                        "aria-label": "מחיר קודם",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Strikethrough, {
                                            children: formatPrice(accessory.price.originalPrice)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                variant: "srOnly",
                                children: "מחיר נוכחי"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActualPrice, {
                                "aria-label": "מחיר נוכחי",
                                children: formatPrice(accessory.price.totalPrice)
                            }),
                            accessory.price.discount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDiscount, {
                                children: "הטבת רכישה אונליין"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledName, {
                        children: accessory.details.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                        children: accessory.details.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckboxWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckboxWrap, {
                $hide: !isSelected,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxSelectedIcon/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var accessories_Accessory = (Accessory);

// EXTERNAL MODULE: ./components/shopFeatures/accessories/accessoriesSlice.ts
var accessoriesSlice = __webpack_require__(56189);
;// CONCATENATED MODULE: ./components/shopFeatures/accessories/AccessoriesSidebar.tsx

function AccessoriesSidebar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -7px;\n  margin-left: -7px;\n  padding: 0;\n\n  ",
        " {\n    padding-bottom: ",
        "px;\n  }\n\n  li {\n    width: 50%;\n    padding: 7px;\n    display: flex;\n  }\n"
    ]);
    AccessoriesSidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledAccessories = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "AccessoriesSidebar__StyledAccessories",
    componentId: "sc-15ded8cb-0"
})(AccessoriesSidebar_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.spacing(2);
});
var AccessoriesSidebar = function() {
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.accessories;
    }), accessories = ref.accessories, selectedAccessoriesCodes = ref.selectedAccessoriesCodes;
    var dispatch = (0,store/* useAppDispatch */.TL)();
    useRedirectIfPreviousComponentsAreNotSelected();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "srOnly",
                component: "h1",
                children: "אביזרים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccessories, {
                children: accessories.map(function(accessory) {
                    var code = accessory.details.code;
                    var isSelected = selectedAccessoriesCodes.includes(code);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        role: "presentation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accessories_Accessory, {
                            accessory: accessory,
                            isSelected: isSelected,
                            onSelect: function() {
                                return dispatch((0,accessoriesSlice/* setSelectedAccessories */.My)(isSelected ? selectedAccessoriesCodes.filter(function(c) {
                                    return c !== code;
                                }) : selectedAccessoriesCodes.concat(code)));
                            }
                        })
                    }, code);
                })
            })
        ]
    });
};
/* harmony default export */ var accessories_AccessoriesSidebar = (AccessoriesSidebar);

;// CONCATENATED MODULE: ./common/mapDataToFitCarousel.ts
// Map Colors to the shape that the ColorsCarousel expects. To retrieve colors:
var mapDataToFitCarousel = function(data, imageName) {
    return data.map(function(item) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        return {
            name: item === null || item === void 0 ? void 0 : (ref = item.details) === null || ref === void 0 ? void 0 : ref.name,
            hex: item === null || item === void 0 ? void 0 : (ref1 = item.details) === null || ref1 === void 0 ? void 0 : ref1.hexValue,
            colorImage: {
                imageUrl: item === null || item === void 0 ? void 0 : (ref2 = item.details) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[imageName]) === null || ref3 === void 0 ? void 0 : ref3.imageUrl,
                alt: item === null || item === void 0 ? void 0 : (ref4 = item.details) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.colorImage) === null || ref5 === void 0 ? void 0 : ref5.alt
            },
            hasAdditionalPrice: !!(item === null || item === void 0 ? void 0 : (ref6 = item.price) === null || ref6 === void 0 ? void 0 : ref6.totalPrice),
            images: item === null || item === void 0 ? void 0 : (ref7 = item.details) === null || ref7 === void 0 ? void 0 : ref7.images,
            code: item === null || item === void 0 ? void 0 : (ref8 = item.details) === null || ref8 === void 0 ? void 0 : ref8.code,
            additionalPrice: item === null || item === void 0 ? void 0 : (ref9 = item.price) === null || ref9 === void 0 ? void 0 : ref9.totalPrice,
            inStock: item === null || item === void 0 ? void 0 : (ref10 = item.details) === null || ref10 === void 0 ? void 0 : ref10.inStock
        };
    });
};

// EXTERNAL MODULE: ./components/carModelPage/sections/exterior/enterence/ColorsCarousel.tsx
var ColorsCarousel = __webpack_require__(40739);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
;// CONCATENATED MODULE: ./components/shopFeatures/color/Colors.tsx

function Colors_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0 0 0;\n  display: flex;\n  justify-content: center;\n  margin: 0 -6px;\n\n  ",
        " {\n    padding: 30px 15px 0 15px;\n    justify-content: flex-start;\n    margin: 0 -8px;\n    order: -1;\n    flex-direction: column;\n  }\n"
    ]);
    Colors_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Colors_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  border: 0;\n  margin: -1px;\n  padding: 0;\n  width: 1px;\n  height: 1px;\n  clip: rect(0px, 0px, 0px, 0px);\n  &:focus-visible + label {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n  :checked + label {\n    width: 80px;\n    height: 80px;\n    position: relative;\n    right: -14px;\n  }\n"
    ]);
    Colors_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Colors_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 39px;\n  height: 39px;\n  display: flex;\n  border: 2px solid ",
        ';\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  background: url("',
        '");\n  background-size: 100%;\n\n  ',
        " {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n  }\n"
    ]);
    Colors_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Colors_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  gap: 25px;\n  padding-right: 30px;\n  width: 100%;\n\n  ",
        " {\n    flex-direction: row;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    Colors_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Colors_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  cursor: pointer;\n  * {\n    text-align: center;\n  }\n  display: flex;\n  flex-grow: 1;\n"
    ]);
    Colors_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Colors_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    Colors_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Colors_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  margin: 0;\n  padding: 0;\n  line-height: 22px;\n  text-align: right;\n"
    ]);
    Colors_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Colors_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  margin: 0;\n  padding: 0;\n  color: ",
        ";\n  line-height: 20px;\n"
    ]);
    Colors_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Colors_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  color: ",
        ";\n  text-align: right;\n  margin-right: auto;\n  align-self: flex-start;\n"
    ]);
    Colors_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Colors_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Colors__StyledContainer",
    componentId: "sc-3d81d3a-0"
})(Colors_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledRadio = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "Colors__StyledRadio",
    componentId: "sc-3d81d3a-1"
})(Colors_templateObject1());
var StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "Colors__StyledLabel",
    componentId: "sc-3d81d3a-2"
})(Colors_templateObject2(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$imageUrl;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledRadioAndName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Colors__StyledRadioAndName",
    componentId: "sc-3d81d3a-3"
})(Colors_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.lightGray;
});
var ItemDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Colors__ItemDescription",
    componentId: "sc-3d81d3a-4"
})(Colors_templateObject4(), function(p) {
    return p.$selected && "margin-right: -30px;";
});
var StyledDescriptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Colors__StyledDescriptionWrapper",
    componentId: "sc-3d81d3a-5"
})(Colors_templateObject5());
var ItemName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "Colors__ItemName",
    componentId: "sc-3d81d3a-6"
})(Colors_templateObject6(), constants/* Font.OENaPro */.Zx.OENaPro);
var AdditionalCost = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "Colors__AdditionalCost",
    componentId: "sc-3d81d3a-7"
})(Colors_templateObject7(), function(p) {
    return p.theme.colors.disable;
});
var StyledNotInStock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Colors__StyledNotInStock",
    componentId: "sc-3d81d3a-8"
})(Colors_templateObject8(), function(p) {
    return p.theme.colors.mazdaRed;
});
var Colors = function(param) {
    var type = param.type, data = param.data, selectedItem = param.selectedItem, handleColorChange = param.handleColorChange;
    if (!selectedItem) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Colors_StyledContainer, {
        role: "radiogroup",
        "aria-labelledby": "colorsHeadline",
        children: data.map(function(item) {
            var itemName = item.name;
            var isSelected = item.code === selectedItem;
            var imageUrl = item === null || item === void 0 ? void 0 : item.colorImage.imageUrl;
            if (item.additionalPrice) {
                itemName += ", תוספת מחיר: ".concat(item.additionalPrice, "₪");
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRadioAndName, {
                role: "presentation",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRadio, {
                        type: "radio",
                        name: type,
                        value: item.code,
                        id: "radio_".concat(type, "_").concat(item.code),
                        checked: isSelected,
                        onChange: function() {
                            if (isSelected) return;
                            handleColorChange(item.code);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                        inputColor: (item === null || item === void 0 ? void 0 : item.hex) || "",
                        "aria-label": itemName,
                        htmlFor: "radio_".concat(type, "_").concat(item.code),
                        $imageUrl: imageUrl,
                        $checked: isSelected
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemDescription, {
                        $selected: isSelected,
                        onClick: function() {
                            if (isSelected) return;
                            handleColorChange(item.code);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDescriptionWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemName, {
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalCost, {
                                        children: item.additionalPrice > 0 && "תוספת מחיר: ".concat(item.additionalPrice)
                                    })
                                ]
                            }),
                            !item.inStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNotInStock, {
                                children: "לא במלאי"
                            })
                        ]
                    })
                ]
            }, item.code);
        })
    });
};
/* harmony default export */ var color_Colors = (Colors);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./components/shopFeatures/color/colorSelectors.ts
var colorSelectors = __webpack_require__(75222);
;// CONCATENATED MODULE: ./components/shopFeatures/color/ThreeSixtyIcon.tsx


function ThreeSixtyIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 30px;\n  position: absolute;\n  top: -25px;\n  right: 0;\n\n  ",
        " {\n    width: 50px;\n    top: auto;\n    right: auto;\n    bottom: 20px;\n    left: 20px;\n  }\n"
    ]);
    ThreeSixtyIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledThreeSixtyIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "ThreeSixtyIcon__StyledThreeSixtyIcon",
    componentId: "sc-a28a4ec0-0"
})(ThreeSixtyIcon_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ThreeSixtyIcon = function(props) {
    var selectedColor = (0,store/* useTypedSelector */.ix)(colorSelectors/* selectedColorSelector */.Q);
    if (!selectedColor || selectedColor.details.images.length <= 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledThreeSixtyIcon, (0,src_object_spread/* default */.Z)({
        src: "/spin.png",
        alt: "",
        title: "לחץ וגרור לסובב רכב"
    }, props));
};
/* harmony default export */ var color_ThreeSixtyIcon = (ThreeSixtyIcon);

// EXTERNAL MODULE: ./components/shopFeatures/color/colorSlice.ts
var colorSlice = __webpack_require__(58976);
;// CONCATENATED MODULE: ./components/shopFeatures/color/ColorSidebar.tsx

function ColorSidebar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n"
    ]);
    ColorSidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ColorSidebar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  position: relative;\n  top: -50px;\n"
    ]);
    ColorSidebar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ColorSidebar__StyledWrapper",
    componentId: "sc-251b6803-0"
})(ColorSidebar_templateObject());
var StyledIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ColorSidebar__StyledIconWrapper",
    componentId: "sc-251b6803-1"
})(ColorSidebar_templateObject1());
var ColorSidebar = function() {
    useRedirectIfPreviousComponentsAreNotSelected();
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,react.useState)(0), selectedColorIndex = ref[0], setSelectedColorIndex = ref[1];
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var showOnlyStock = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).showOnlyStock;
    var ref1 = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }), colors = ref1.colors, selectedColorCode = ref1.selectedColorCode;
    var colorsData = mapDataToFitCarousel(colors, "colorImage");
    var filteredColors = colorsData.filter(function(item) {
        return showOnlyStock ? item.inStock : true;
    });
    // Find the index of selectedColor in the colors array
    (0,react.useEffect)(function() {
        setSelectedColorIndex(colors.reduce(function(a, b, i) {
            var ref;
            if ((b === null || b === void 0 ? void 0 : (ref = b.details) === null || ref === void 0 ? void 0 : ref.code) === selectedColorCode) return i;
            return a;
        }, 0));
    }, [
        selectedColorCode,
        colors
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "srOnly",
                    component: "h1",
                    children: "צבע"
                }),
                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(color_Colors, {
                    type: "colors",
                    data: filteredColors,
                    selectedItem: selectedColorCode,
                    handleColorChange: function(code) {
                        dispatch((0,colorSlice/* setSelectedColor */.El)(code));
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_ThreeSixtyIcon, {
                                style: {
                                    position: "static",
                                    left: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorsCarousel/* default */.Z, {
                            selectedColorIndex: selectedColorIndex,
                            colorsData: filteredColors,
                            handleColorChange: function(index) {
                                var ref;
                                dispatch((0,colorSlice/* setSelectedColor */.El)((ref = filteredColors[index]) === null || ref === void 0 ? void 0 : ref.code));
                            },
                            showExtraPrice: true,
                            pathname: pathname
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var color_ColorSidebar = (/*#__PURE__*/(0,react.memo)(ColorSidebar));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/wizardSlice.ts + 1 modules
var wizardSlice = __webpack_require__(22890);
;// CONCATENATED MODULE: ./components/shopFeatures/wizard/ShowStockToggle.tsx

function ShowStockToggle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0 16px;\n  justify-content: flex-end;\n  margin-inline-start: -6px;\n\n  .MuiFormControlLabel-label {\n    font-size: 14px;\n  }\n"
    ]);
    ShowStockToggle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledFormControlLabel = (0,styled_components_browser_esm/* default */.ZP)(FormControlLabel/* default */.Z).withConfig({
    displayName: "ShowStockToggle__StyledFormControlLabel",
    componentId: "sc-977817b6-0"
})(ShowStockToggle_templateObject());
var ShowStockToggle = function(param) {
    var inverted = param.inverted;
    var showOnlyStock = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).showOnlyStock;
    var dispatch = (0,store/* useAppDispatch */.TL)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormControlLabel, {
            $inverted: inverted,
            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                id: "showStock",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxIcon/* default */.Z, {}),
                checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxSelectedIcon/* default */.Z, {}),
                name: "showStock",
                color: "primary",
                checked: showOnlyStock,
                onChange: function() {
                    dispatch((0,wizardSlice/* toggleShowOnlyStock */.sL)());
                }
            }),
            label: "הצג רק אפשרויות שזמינות במלאי"
        })
    });
};
/* harmony default export */ var wizard_ShowStockToggle = (ShowStockToggle);

// EXTERNAL MODULE: ./components/shopFeatures/detailing/detailingSlice.ts
var detailingSlice = __webpack_require__(52909);
;// CONCATENATED MODULE: ./components/shopFeatures/detailing/DetailingButtons.tsx

function DetailingButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin-bottom: 8px;\n"
    ]);
    DetailingButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin-bottom: 8px;\n"
    ]);
    DetailingButtons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n"
    ]);
    DetailingButtons_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: 0.05em;\n  text-align: center;\n"
    ]);
    DetailingButtons_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 10px;\n  text-align: center;\n"
    ]);
    DetailingButtons_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-basis: calc(100% / 3 - ",
        "px * 2);\n  flex-shrink: 0;\n  margin: 3px ",
        "px;\n  min-height: 66px;\n"
    ]);
    DetailingButtons_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-basis: calc(100% / 2 - ",
        "px * 2);\n  flex-shrink: 0;\n  margin: 3px ",
        "px;\n"
    ]);
    DetailingButtons_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  border: none;\n  margin: -1px;\n  padding: 0;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  &:focus-visible + label {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n  clip: rect(0px, 0px, 0px, 0px);\n  :checked + label {\n    border: none;\n    background-color: ",
        ";\n    color: ",
        ";\n    > div {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    DetailingButtons_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: ",
        "px;\n  cursor: pointer;\n  background: ",
        ";\n  line-height: 19px;\n  padding: 15px 0px;\n  height: 100%;\n\n  ",
        " {\n    flex-basis: auto;\n    width: calc(100% / 3 - ",
        "px * 2 - 1px);\n  }\n"
    ]);
    DetailingButtons_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DetailingButtons_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function DetailingButtons_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 0;\n"
    ]);
    DetailingButtons_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0em;\n  text-align: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  color: ",
        ";\n  text-align: center;\n  margin-top: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}









var HORIZONTAL_SPACING = 3;
var StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2",
    component: "h1",
    tabIndex: 0
}).withConfig({
    displayName: "DetailingButtons__StyledHeading",
    componentId: "sc-c210b7ac-0"
})(DetailingButtons_templateObject());
var StyledSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2",
    component: "h2"
}).withConfig({
    displayName: "DetailingButtons__StyledSubtitle",
    componentId: "sc-c210b7ac-1"
})(DetailingButtons_templateObject1());
var StyledDetailings = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailingButtons__StyledDetailings",
    componentId: "sc-c210b7ac-2"
})(DetailingButtons_templateObject2());
var StyledEngineName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "DetailingButtons__StyledEngineName",
    componentId: "sc-c210b7ac-3"
})(DetailingButtons_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro);
var DetailingButtons_StyledPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "DetailingButtons__StyledPrice",
    componentId: "sc-c210b7ac-4"
})(DetailingButtons_templateObject4());
var StyledDetailing = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailingButtons__StyledDetailing",
    componentId: "sc-c210b7ac-5"
})(DetailingButtons_templateObject5(), HORIZONTAL_SPACING, HORIZONTAL_SPACING);
var StyledEngine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailingButtons__StyledEngine",
    componentId: "sc-c210b7ac-6"
})(DetailingButtons_templateObject6(), HORIZONTAL_SPACING, HORIZONTAL_SPACING);
var DetailingButtons_StyledRadio = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "DetailingButtons__StyledRadio",
    componentId: "sc-c210b7ac-7"
})(DetailingButtons_templateObject7(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.white;
});
var DetailingButtons_StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "DetailingButtons__StyledLabel",
    componentId: "sc-c210b7ac-8"
})(DetailingButtons_templateObject8(), function(p) {
    return p.theme.shape.borderRadius;
}, function(p) {
    return p.theme.colors.white;
}, MediaQueries/* IEMediaQuery */.bD, HORIZONTAL_SPACING);
var StyledEngineLabel = (0,styled_components_browser_esm/* default */.ZP)(DetailingButtons_StyledLabel).withConfig({
    displayName: "DetailingButtons__StyledEngineLabel",
    componentId: "sc-c210b7ac-9"
})(DetailingButtons_templateObject9());
var StyledDetailLabel = (0,styled_components_browser_esm/* default */.ZP)(DetailingButtons_StyledLabel).withConfig({
    displayName: "DetailingButtons__StyledDetailLabel",
    componentId: "sc-c210b7ac-10"
})(DetailingButtons_templateObject10());
var StyledDetailName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "DetailingButtons__StyledDetailName",
    componentId: "sc-c210b7ac-11"
})(_templateObject11());
var StyledOutOfStock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailingButtons__StyledOutOfStock",
    componentId: "sc-c210b7ac-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.mazdaRed;
});
var DetailingButtons = function() {
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.detailing;
    }), engines = ref.engines, selectedDetailingCode = ref.selectedDetailingCode;
    var showOnlyStock = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).showOnlyStock;
    var ref1 = (0,react.useState)(null), selectedEngine = ref1[0], setSelectedEngine = ref1[1];
    var dispatch = (0,store/* useAppDispatch */.TL)();
    // Run this effect when the engines change
    (0,react.useEffect)(function() {
        if (!selectedDetailingCode) return;
        // Find the engine with the finishing level that matches the selected detailing
        var engine = engines.find(function(engine) {
            return engine.finishingLevels.some(function(detailing) {
                return detailing.details.code === selectedDetailingCode;
            });
        });
        // Set selected engine to the engine we found
        setSelectedEngine(engine);
    }, [
        engines,
        selectedDetailingCode
    ]);
    var enginesToDisplay = (0,react.useMemo)(function() {
        return engines === null || engines === void 0 ? void 0 : engines.filter(function(engine) {
            if (!showOnlyStock) return true;
            // Filter engines that have at least one finishing level in stock
            return engine.finishingLevels.some(function(detailing) {
                return detailing.details.inStock;
            });
        });
    }, [
        engines,
        showOnlyStock
    ]);
    (0,react.useEffect)(function() {
        if (!selectedEngine) return;
        if (showOnlyStock) {
            var selectedDetailing = selectedEngine.finishingLevels.find(function(detailing) {
                return detailing.details.code === selectedDetailingCode;
            });
            if (!(enginesToDisplay === null || enginesToDisplay === void 0 ? void 0 : enginesToDisplay.some(function(e) {
                return e.engineId === selectedEngine.engineId;
            }))) {
                // If the selected engine is not in the filtered list, reset to the first available engine
                setSelectedEngine(enginesToDisplay[0]);
            }
            // If the selected detailing is not in stock, try to select the first in-stock detailing
            if (!(selectedDetailing === null || selectedDetailing === void 0 ? void 0 : selectedDetailing.details.inStock)) {
                var firstInStock = selectedEngine.finishingLevels.find(function(detailing) {
                    return detailing.details.inStock;
                });
                if (firstInStock && firstInStock.details.code !== selectedDetailingCode) {
                    dispatch((0,detailingSlice/* setSelectedDetailing */.gD)(firstInStock.details.code));
                }
            }
        // If the selected detailing is in stock, do nothing (don't reset to first)
        }
    }, [
        showOnlyStock,
        selectedEngine,
        selectedDetailingCode,
        dispatch
    ]);
    var selectedEngineFinishingLevels = (0,react.useMemo)(function() {
        return selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.finishingLevels.filter(function(item) {
            var ref;
            return showOnlyStock ? (ref = item.details) === null || ref === void 0 ? void 0 : ref.inStock : true;
        });
    }, [
        selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.finishingLevels,
        showOnlyStock
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                id: "detailingHeadline",
                children: "בחירת מנוע"
            }),
            (selectedEngineFinishingLevels === null || selectedEngineFinishingLevels === void 0 ? void 0 : selectedEngineFinishingLevels.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailings, {
                role: "radiogroup",
                "aria-labelledby": "detailingHeadline",
                children: enginesToDisplay === null || enginesToDisplay === void 0 ? void 0 : enginesToDisplay.map(function(engine) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(StyledEngine, {
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailingButtons_StyledRadio, {
                                type: "radio",
                                name: "engine",
                                value: engine.engineId,
                                id: "radio_engine".concat(engine.engineId),
                                checked: (selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.engineId) === engine.engineId,
                                onChange: function() {
                                    if ((selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.engineId) === engine.engineId) return;
                                    setSelectedEngine(engine);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEngineLabel, {
                                htmlFor: "radio_engine".concat(engine.engineId),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEngineName, {
                                    children: [
                                        "מנוע ",
                                        engine.engineIdName
                                    ]
                                })
                            })
                        ]
                    }, engine.engineId);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubtitle, {
                children: "בחירת רמת גימור"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailings, {
                role: "radiogroup",
                "aria-labelledby": "detailingHeadline",
                children: selectedEngineFinishingLevels === null || selectedEngineFinishingLevels === void 0 ? void 0 : selectedEngineFinishingLevels.map(function(param) {
                    var details = param.details, price = param.price;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetailing, {
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailingButtons_StyledRadio, {
                                type: "radio",
                                name: "detailing",
                                value: details.code,
                                id: "radio_".concat(details.code),
                                checked: details.code === selectedDetailingCode,
                                onChange: function() {
                                    if (details.code === selectedDetailingCode) return;
                                    dispatch((0,detailingSlice/* setSelectedDetailing */.gD)(details.code));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetailLabel, {
                                htmlFor: "radio_".concat(details.code),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailName, {
                                        children: details.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailingButtons_StyledPrice, {
                                        children: formatPrice(price.originalPrice)
                                    }),
                                    !details.inStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOutOfStock, {
                                        children: "לא במלאי"
                                    })
                                ]
                            })
                        ]
                    }, details.code);
                })
            })
        ]
    });
};
/* harmony default export */ var detailing_DetailingButtons = (DetailingButtons);

;// CONCATENATED MODULE: ./common/ListCirclePicture.tsx

function ListCirclePicture_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0;\n  list-style-position: outside;\n\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    ListCirclePicture_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ListCirclePicture_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 300;\n  letter-spacing: 0em;\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n\n  :last-child {\n    margin-bottom: 8px;\n  }\n"
    ]);
    ListCirclePicture_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ListCirclePicture_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n"
    ]);
    ListCirclePicture_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ListCirclePicture_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding-right: 10px;\n"
    ]);
    ListCirclePicture_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledListCirclePicture = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "ListCirclePicture__StyledListCirclePicture",
    componentId: "sc-b62b9ee2-0"
})(ListCirclePicture_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledListItemPicture = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ListCirclePicture__StyledListItemPicture",
    componentId: "sc-b62b9ee2-1"
})(ListCirclePicture_templateObject1(), constants/* Font.OENaPro */.Zx.OENaPro);
var StyledImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "ListCirclePicture__StyledImg",
    componentId: "sc-b62b9ee2-2"
})(ListCirclePicture_templateObject2());
var StyledContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ListCirclePicture__StyledContent",
    componentId: "sc-b62b9ee2-3"
})(ListCirclePicture_templateObject3());
var ListCirclePicture = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListCirclePicture, {
        children: children
    });
};
var ListItemCirlcePicture = function(param) {
    var content = param.content, $key = param.$key, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledListItemPicture, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImg, {
                src: image,
                alt: "Thumbnail image of ".concat(content)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                children: content
            })
        ]
    }, $key);
};

;// CONCATENATED MODULE: ./common/ShopTypography.tsx

function ShopTypography_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-family: ",
        ";\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 27px;\n  letter-spacing: 0em;\n"
    ]);
    ShopTypography_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShopTypography_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-position: inside;\n  padding: 0;\n  ",
        "\n"
    ]);
    ShopTypography_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShopTypography_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 16px;\n  letter-spacing: 0em;\n\n  ::marker {\n    font-size: 18px;\n    color: ",
        ";\n  }\n"
    ]);
    ShopTypography_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ShopTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "ShopTypography__ShopTitle",
    componentId: "sc-6c8c5478-0"
})(ShopTypography_templateObject(), constants/* Font.OENaPro */.Zx.OENaPro);
var ShopList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "ShopTypography__ShopList",
    componentId: "sc-6c8c5478-1"
})(ShopTypography_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$hideBullets) && "list-style-type: none;";
});
var ShopListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ShopTypography__ShopListItem",
    componentId: "sc-6c8c5478-2"
})(ShopTypography_templateObject2(), constants/* Font.OENaPro */.Zx.OENaPro, function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.darkGrey;
});

// EXTERNAL MODULE: ./components/shopFeatures/accessories/accessoriesSelectors.ts
var accessoriesSelectors = __webpack_require__(21933);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(73727);
;// CONCATENATED MODULE: ./components/shopFeatures/summary/EditDetailingSelection.tsx

function EditDetailingSelection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid ",
        ";\n  height: 60px;\n\n  :first-child {\n    border-top: none;\n  }\n"
    ]);
    EditDetailingSelection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EditDetailingSelection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  text-underline-offset: 5px;\n  padding: 0;\n  min-width: 0;\n"
    ]);
    EditDetailingSelection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EditDetailingSelection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n"
    ]);
    EditDetailingSelection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EditDetailingSelection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    EditDetailingSelection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EditDetailingSelection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 22px;\n  letter-spacing: 0em;\n  padding-right: 13px;\n"
    ]);
    EditDetailingSelection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var StyledListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "EditDetailingSelection__StyledListItem",
    componentId: "sc-c8004d2f-0"
})(EditDetailingSelection_templateObject(), function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.lightGrey;
});
var StyledButtonLink = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).attrs({
    component: react_router_dom/* Link */.rU
}).withConfig({
    displayName: "EditDetailingSelection__StyledButtonLink",
    componentId: "sc-c8004d2f-1"
})(EditDetailingSelection_templateObject1());
var StyledCirclePicture = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "EditDetailingSelection__StyledCirclePicture",
    componentId: "sc-c8004d2f-2"
})(EditDetailingSelection_templateObject2());
var EditDetailingSelection_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EditDetailingSelection__StyledContainer",
    componentId: "sc-c8004d2f-3"
})(EditDetailingSelection_templateObject3());
var StyledText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "EditDetailingSelection__StyledText",
    componentId: "sc-c8004d2f-4"
})(EditDetailingSelection_templateObject4(), constants/* Font.OENaPro */.Zx.OENaPro);
var EditDetailingSelection = function(param) {
    var imageUrl = param.imageUrl, detailTitle = param.detailTitle, editUrl = param.editUrl;
    var focusMain = (0,LayoutContext/* useLayoutContext */.l)().focusMain;
    var itemKey = Math.random() + detailTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledListItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EditDetailingSelection_StyledContainer, {
                children: [
                    imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCirclePicture, {
                        src: imageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                        children: detailTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonLink, {
                onClick: function() {
                    focusMain();
                },
                to: editUrl,
                children: "שינוי"
            })
        ]
    }, itemKey);
};
/* harmony default export */ var summary_EditDetailingSelection = (EditDetailingSelection);

// EXTERNAL MODULE: ./components/shopFeatures/upholstery/upholsterySelectors.ts
var upholsterySelectors = __webpack_require__(66402);
// EXTERNAL MODULE: ./components/shopFeatures/detailing/detailingSelectors.ts
var detailingSelectors = __webpack_require__(78615);
;// CONCATENATED MODULE: ./components/shopFeatures/detailing/SelectedDetailingDetails.tsx

function SelectedDetailingDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.75rem;\n  font-weight: bold;\n\n  ",
        " {\n    font-size: 0.875rem;\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    SelectedDetailingDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectedDetailingDetails_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 10px 0 20px 0;\n\n  ",
        "\n"
    ]);
    SelectedDetailingDetails_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectedDetailingDetails_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n"
    ]);
    SelectedDetailingDetails_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectedDetailingDetails_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    SelectedDetailingDetails_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SelectedDetailingDetails_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin: 10px 0;\n  font-size: 16px;\n  line-height: 20px;\n\n  :first-child,\n  :last-child {\n    margin: 0;\n  }\n"
    ]);
    SelectedDetailingDetails_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SelectedDetailingDetails_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  padding: 0;\n  margin: 10px 0 23px 0;\n\n  :last-child {\n    margin: 10px 0;\n  }\n"
    ]);
    SelectedDetailingDetails_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SelectedDetailingDetails_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 300;\n  letter-spacing: 0em;\n  display: flex;\n  align-items: center;\n  gap: 8.3px;\n  margin-bottom: 13px;\n\n  :last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    SelectedDetailingDetails_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SelectedDetailingDetails_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: ",
        ";\n"
    ]);
    SelectedDetailingDetails_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SelectedDetailingDetails_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 27px;\n  letter-spacing: 0em;\n  margin: 0;\n  padding: 0;\n"
    ]);
    SelectedDetailingDetails_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}













var SelectedDetailingDetails_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectedDetailingDetails__StyledContainer",
    componentId: "sc-107eb77d-0"
})(SelectedDetailingDetails_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.spacing(2);
});
var StyledMainDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectedDetailingDetails__StyledMainDetails",
    componentId: "sc-107eb77d-1"
})(SelectedDetailingDetails_templateObject1(), function(p) {
    var ref, ref1;
    return (p === null || p === void 0 ? void 0 : p.$hasBackground) && "\n    background: ".concat(p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.white, ";\n    padding: 20px 30px;\n  ");
});
var StyledShopTitle = (0,styled_components_browser_esm/* default */.ZP)(ShopTitle).withConfig({
    displayName: "SelectedDetailingDetails__StyledShopTitle",
    componentId: "sc-107eb77d-2"
})(SelectedDetailingDetails_templateObject2());
var StyledShopList = (0,styled_components_browser_esm/* default */.ZP)(ShopList).withConfig({
    displayName: "SelectedDetailingDetails__StyledShopList",
    componentId: "sc-107eb77d-3"
})(SelectedDetailingDetails_templateObject3());
var StyledShopListItem = (0,styled_components_browser_esm/* default */.ZP)(ShopListItem).withConfig({
    displayName: "SelectedDetailingDetails__StyledShopListItem",
    componentId: "sc-107eb77d-4"
})(SelectedDetailingDetails_templateObject4());
var ShopDetailList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "SelectedDetailingDetails__ShopDetailList",
    componentId: "sc-107eb77d-5"
})(SelectedDetailingDetails_templateObject5());
var ShopDetailListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "SelectedDetailingDetails__ShopDetailListItem",
    componentId: "sc-107eb77d-6"
})(SelectedDetailingDetails_templateObject6(), constants/* Font.OENaPro */.Zx.OENaPro);
var ShopListItemMarker = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SelectedDetailingDetails__ShopListItemMarker",
    componentId: "sc-107eb77d-7"
})(SelectedDetailingDetails_templateObject7(), function(p) {
    return p.theme.colors.darkGrey;
});
var ShopCategoryTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "SelectedDetailingDetails__ShopCategoryTitle",
    componentId: "sc-107eb77d-8"
})(SelectedDetailingDetails_templateObject8(), constants/* Font.OENaPro */.Zx.OENaPro);
var SelectedDetailingDetails = function(param) {
    var hasBackground = param.hasBackground;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react.useState)(false), isSummaryPage = ref9[0], setIsSummaryPage = ref9[1];
    var selectedDetailing = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedDetailingSelector */.YF);
    var color = (0,store/* useTypedSelector */.ix)(colorSelectors/* selectedColorSelector */.Q);
    var accessories = (0,store/* useTypedSelector */.ix)(accessoriesSelectors/* selectedAccessoriesSelector */.q);
    var upholstery = (0,store/* useTypedSelector */.ix)(upholsterySelectors/* selectedUpholsterySelector */._);
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    (0,react.useEffect)(function() {
        var ref;
        if (window && (window === null || window === void 0 ? void 0 : window.location)) setIsSummaryPage((window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href.indexOf("summary")) > 0);
    });
    if (!selectedDetailing) return null;
    var _details = selectedDetailing.details, mainFeatures = _details.mainFeatures, categories = _details.categories, techinicalFeatures = _details.techinicalFeatures, name = _details.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedDetailingDetails_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopTitle, {
                tabIndex: 0,
                children: "מאפיינים עיקריים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMainDetails, {
                $hasBackground: hasBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListCirclePicture, {
                    children: [
                        pathname !== constants/* STEPS_EN.detailing */.Ws.detailing && /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_EditDetailingSelection, {
                            detailTitle: "רמת גימור ".concat(name),
                            editUrl: "/detailing"
                        }),
                        mainFeatures.map(function(feature, i) {
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemCirlcePicture, {
                                $key: "".concat(feature === null || feature === void 0 ? void 0 : feature.name, "_").concat(i),
                                content: feature === null || feature === void 0 ? void 0 : feature.name,
                                image: feature === null || feature === void 0 ? void 0 : (ref = feature.image) === null || ref === void 0 ? void 0 : ref.imageUrl
                            }, i);
                        }),
                        isSummaryPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_EditDetailingSelection, {
                                    imageUrl: (color === null || color === void 0 ? void 0 : (ref = color.details) === null || ref === void 0 ? void 0 : (ref1 = ref.colorImage) === null || ref1 === void 0 ? void 0 : ref1.imageUrl) || "",
                                    detailTitle: color === null || color === void 0 ? void 0 : (ref2 = color.details) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colorImage) === null || ref3 === void 0 ? void 0 : ref3.alt,
                                    editUrl: "/color"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_EditDetailingSelection, {
                                    imageUrl: upholstery === null || upholstery === void 0 ? void 0 : (ref4 = upholstery.details) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.thumbnailImage) === null || ref5 === void 0 ? void 0 : ref5.imageUrl,
                                    detailTitle: upholstery === null || upholstery === void 0 ? void 0 : (ref6 = upholstery.details) === null || ref6 === void 0 ? void 0 : ref6.name,
                                    editUrl: "/upholstery"
                                }),
                                accessories.map(function(item, i) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(summary_EditDetailingSelection, {
                                        imageUrl: item === null || item === void 0 ? void 0 : item.details.image.imageUrl,
                                        detailTitle: item === null || item === void 0 ? void 0 : item.details.name,
                                        editUrl: "/accessories"
                                    }, i);
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShopTitle, {
                tabIndex: 0,
                children: "מאפיינים נוספים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMainDetails, {
                $hasBackground: hasBackground,
                children: categories.map(function(category, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopCategoryTitle, {
                                children: category === null || category === void 0 ? void 0 : category.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopDetailList, {
                                children: category === null || category === void 0 ? void 0 : category.items.map(function(item, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopDetailListItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopListItemMarker, {}),
                                            item.name,
                                            " ",
                                            item.description
                                        ]
                                    }, item.name + i);
                                })
                            })
                        ]
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShopTitle, {
                tabIndex: 0,
                children: "מפרט טכני"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMainDetails, {
                $hasBackground: hasBackground,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShopList, {
                    $hideBullets: true,
                    children: (ref7 = techinicalFeatures[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.items) === null || ref8 === void 0 ? void 0 : ref8.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShopListItem, {
                            children: [
                                item.name,
                                ": ",
                                item.description
                            ]
                        }, i);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var detailing_SelectedDetailingDetails = (SelectedDetailingDetails);

;// CONCATENATED MODULE: ./components/shopFeatures/detailing/DetailingSidebar.tsx

function DetailingSidebar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    DetailingSidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledDetailingButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DetailingSidebar__StyledDetailingButtonsContainer",
    componentId: "sc-b189b66e-0"
})(DetailingSidebar_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var DetailingSidebar = function() {
    useRedirectIfPreviousComponentsAreNotSelected();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDetailingButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(wizard_ShowStockToggle, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(detailing_DetailingButtons, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailing_SelectedDetailingDetails, {
                hasBackground: true
            })
        ]
    });
};
/* harmony default export */ var detailing_DetailingSidebar = (DetailingSidebar);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Link/Link.js
var Link_Link = __webpack_require__(89659);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(71537);
// EXTERNAL MODULE: ./common/FormikCheckboxField.tsx
var common_FormikCheckboxField = __webpack_require__(57123);
// EXTERNAL MODULE: ./common/UseFocusFirstInvalidField.tsx
var common_UseFocusFirstInvalidField = __webpack_require__(29267);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(85161);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
;// CONCATENATED MODULE: ./components/shopFeatures/auth/register/ShowRoomSelect.tsx

function ShowRoomSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    ShowRoomSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShowRoomSelect_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0;\n"
    ]);
    ShowRoomSelect_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShowRoomSelect_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n"
    ]);
    ShowRoomSelect_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShowRoomSelect_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: 30px;\n  select {\n    padding-left: 20px !important;\n  }\n"
    ]);
    ShowRoomSelect_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ShowRoomSelect_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 16px;\n  letter-spacing: 0em;\n"
    ]);
    ShowRoomSelect_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var ShowRoomSelect_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomSelect__StyledContainer",
    componentId: "sc-ac41ff38-0"
})(ShowRoomSelect_templateObject(), function(p) {
    return p.theme.spacing(2);
}, function(p) {
    return p.theme.spacing(0.5);
});
var StyledFormControl = (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
    displayName: "ShowRoomSelect__StyledFormControl",
    componentId: "sc-ac41ff38-1"
})(ShowRoomSelect_templateObject1());
var StyledError = (0,styled_components_browser_esm/* default */.ZP)(FormHelperText/* default */.Z).attrs({
    error: true
}).withConfig({
    displayName: "ShowRoomSelect__StyledError",
    componentId: "sc-ac41ff38-2"
})(ShowRoomSelect_templateObject2());
var StyledField = (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
    displayName: "ShowRoomSelect__StyledField",
    componentId: "sc-ac41ff38-3"
})(ShowRoomSelect_templateObject3(), function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.disable;
});
var StyledInputLabel = (0,styled_components_browser_esm/* default */.ZP)(InputLabel/* default */.Z).withConfig({
    displayName: "ShowRoomSelect__StyledInputLabel",
    componentId: "sc-ac41ff38-4"
})(ShowRoomSelect_templateObject4(), constants/* Font.OENaPro */.Zx.OENaPro);
var ShowRoomSelect_ShowRoomSelect = function(param) {
    var inputRef = param.inputRef, showLabel = param.showLabel;
    var showRooms = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.showRooms;
    }).showRooms;
    var ref = (0,formik_esm.useFormikContext)(), errors = ref.errors, touched = ref.touched;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShowRoomSelect_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormControl, {
                children: [
                    showLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputLabel, {
                        id: "showRoom",
                        children: " *אולם תצוגה מועדף"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledField, {
                        component: formik_material_ui_es6/* Select */.Ph,
                        name: "showRoom",
                        id: "showRoom",
                        native: true,
                        inputRef: inputRef,
                        "aria-describedby": "showRoom-helper-text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: 0,
                                disabled: true,
                                hidden: true,
                                children: "*אולם תצוגה מועדף"
                            }),
                            showRooms.map(function(showRoom) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: showRoom.id,
                                    children: showRoom.name
                                }, showRoom.id);
                            })
                        ]
                    })
                ]
            }),
            errors.showRoom && touched.showRoom && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledError, {
                id: "showRoom-helper-text",
                children: errors.showRoom
            })
        ]
    });
};
/* harmony default export */ var register_ShowRoomSelect = (ShowRoomSelect_ShowRoomSelect);

// EXTERNAL MODULE: ./components/shopFeatures/payment/paymentSlice.ts
var paymentSlice = __webpack_require__(63782);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/shopFeatures/wizard/useInStock.ts




var useInStock = function() {
    var ref, ref1, ref2;
    var selectedColor = (0,store/* useTypedSelector */.ix)(colorSelectors/* selectedColorSelector */.Q);
    var selectedUpholstery = (0,store/* useTypedSelector */.ix)(upholsterySelectors/* selectedUpholsterySelector */._);
    var selectedDetailing = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedDetailingSelector */.YF);
    var inStock = (!(selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.details) || (selectedColor === null || selectedColor === void 0 ? void 0 : (ref = selectedColor.details) === null || ref === void 0 ? void 0 : ref.inStock)) && (!(selectedUpholstery === null || selectedUpholstery === void 0 ? void 0 : selectedUpholstery.details) || (selectedUpholstery === null || selectedUpholstery === void 0 ? void 0 : (ref1 = selectedUpholstery.details) === null || ref1 === void 0 ? void 0 : ref1.inStock)) && (!(selectedDetailing === null || selectedDetailing === void 0 ? void 0 : selectedDetailing.details) || (selectedDetailing === null || selectedDetailing === void 0 ? void 0 : (ref2 = selectedDetailing.details) === null || ref2 === void 0 ? void 0 : ref2.inStock));
    return inStock;
};
/* harmony default export */ var wizard_useInStock = (useInStock);

// EXTERNAL MODULE: ./components/shopFeatures/order/orderRepository.ts
var orderRepository = __webpack_require__(33566);
;// CONCATENATED MODULE: ./components/shopFeatures/order/OrderPage.tsx



function OrderPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 24px;\n  ",
        " {\n    margin-top: 30px;\n  }\n"
    ]);
    OrderPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OrderPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-top: 30px;\n    margin-bottom: 30px;\n  }\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 75vh;\n"
    ]);
    OrderPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OrderPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 30px;\n  background: black;\n  color: white;\n  cursor: pointer;\n\n  :hover,\n  :focus {\n    background: ",
        ";\n    border: none;\n    color: white;\n    outline: none;\n  }\n\n  ",
        "\n"
    ]);
    OrderPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OrderPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  label {\n    font-family: ",
        ";\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 16px;\n    letter-spacing: 0em;\n  }\n\n  ",
        "\n"
    ]);
    OrderPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OrderPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 10px;\n  > * {\n    width: 50%;\n  }\n"
    ]);
    OrderPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function OrderPage_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  position: relative;\n"
    ]);
    OrderPage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function OrderPage_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0px;\n  top: 24px;\n  padding: 0;\n  margin: 0;\n  min-width: 13px;\n\n  ",
        " {\n    top: 38px;\n  }\n"
    ]);
    OrderPage_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function OrderPage_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    OrderPage_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function OrderPage_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 20px;\n"
    ]);
    OrderPage_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function OrderPage_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    OrderPage_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function OrderPage_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 16px;\n  letter-spacing: 0em;\n  text-align: right;\n  color: ",
        ";\n  margin: 10px 0;\n"
    ]);
    OrderPage_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}





















var OrderPage_StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "OrderPage__StyledHeading",
    componentId: "sc-3ad182b8-0"
})(OrderPage_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledForm = (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Form).withConfig({
    displayName: "OrderPage__StyledForm",
    componentId: "sc-3ad182b8-1"
})(OrderPage_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "OrderPage__StyledButton",
    componentId: "sc-3ad182b8-2"
})(OrderPage_templateObject2(), function(p) {
    return p.theme.colors.steel;
}, function(p) {
    return p.$disabled && "\n    background: ".concat(p.theme.colors.darkGrey, ";\n  ");
});
var OrderPage_StyledField = (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
    displayName: "OrderPage__StyledField",
    componentId: "sc-3ad182b8-3"
})(OrderPage_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$email) && "\n  input {\n    font-family: ".concat(constants/* Font.MazdaType */.Zx.MazdaType, ";\n    letter-spacing: 0;\n    font-size: 14px;\n  }\n  ");
});
var StyledRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderPage__StyledRow",
    componentId: "sc-3ad182b8-4"
})(OrderPage_templateObject4());
var StyledHeadingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderPage__StyledHeadingContainer",
    componentId: "sc-3ad182b8-5"
})(OrderPage_templateObject5());
var StyledImageButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "OrderPage__StyledImageButton",
    componentId: "sc-3ad182b8-6"
})(OrderPage_templateObject6(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderPage__StyledFormContainer",
    componentId: "sc-3ad182b8-7"
})(OrderPage_templateObject7());
var StyledInnerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderPage__StyledInnerContainer",
    componentId: "sc-3ad182b8-8"
})(OrderPage_templateObject8());
var OrderPage_StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "OrderPage__StyledImage",
    componentId: "sc-3ad182b8-9"
})(OrderPage_templateObject9());
var StyledInfo = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "OrderPage__StyledInfo",
    componentId: "sc-3ad182b8-10"
})(OrderPage_templateObject10(), constants/* Font.OENaPro */.Zx.OENaPro, function(p) {
    return p.theme.colors.mazdaRed;
});
var schema = es/* object */.Ry({
    firstName: es/* string */.Z_().required("שדה חובה").max(50, "ניתן להזין עד 50 תווים").matches(/^[a-zA-Zא-ת ]+$/, "שם פרטי בבקשה"),
    lastName: es/* string */.Z_().required("שדה חובה").max(50, "ניתן להזין עד 50 תווים").matches(/^[a-zA-Zא-ת ]+$/, "שם משפחה בבקשה"),
    mobilePhone: es/* string */.Z_().matches(/^05\d-?\d{7}$/, "מספר נייד שגוי").required("שדה חובה"),
    emailAddress: es/* string */.Z_().email('דוא"ל שגוי').required("שדה חובה"),
    showRoom: es/* number */.Rx().positive("יש לבחור אולם תצוגה").defined(),
    terms: es/* mixed */.nK().oneOf([
        true
    ], "יש לאשר את התקנון"),
    approveMailingList: es/* boolean */.O7().notRequired()
}).defined();
var initialValues = {
    firstName: "",
    lastName: "",
    mobilePhone: "",
    emailAddress: "",
    showRoom: 0,
    terms: false,
    approveMailingList: false
};
var OrderPage = function() {
    var bagRef = (0,react.useRef)();
    var ref = (0,react.useState)(""), errorMessage = ref[0], setErrorMessage = ref[1];
    var ref1 = (0,react.useState)(true), pageInStock = ref1[0], setPageInStock = ref1[1];
    var ref2 = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }), registeredUserInfo = ref2.userInfo;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var history = (0,react_router/* useHistory */.k6)();
    var flowInStock = wizard_useInStock();
    var isInStock = pageInStock && flowInStock;
    var authenticated = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }).authenticated;
    var initialized = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).initialized;
    var selectedDetailingCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.detailing;
    }).selectedDetailingCode;
    var selectedColorCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    var selectedUpholsteryCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.upholstery;
    }).selectedUpholsteryCode;
    var selectedAccessoriesCodes = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.accessories;
    }).selectedAccessoriesCodes;
    var firstNameRef = (0,react.useRef)(null);
    var lastNameRef = (0,react.useRef)(null);
    var mobilePhoneRef = (0,react.useRef)(null);
    var emailAddressRef = (0,react.useRef)(null);
    var termsRef = (0,react.useRef)(null);
    var fieldNameInputRefMap = (0,react.useMemo)(function() {
        return {
            firstName: firstNameRef,
            lastName: lastNameRef,
            mobilePhone: mobilePhoneRef,
            emailAddress: emailAddressRef,
            terms: termsRef
        };
    }, []);
    var createOrder = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, data, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,api/* postEcommOrders */.wm)({
                            finishingLevelCode: selectedDetailingCode,
                            colorCode: selectedColorCode,
                            upholsteryCode: selectedUpholsteryCode,
                            carExtraCodes: selectedAccessoriesCodes
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    if ((data === null || data === void 0 ? void 0 : data.errorCode) === 90002) {
                        dispatch((0,paymentSlice/* setOutOfStockComplete */.p3)(true));
                        router.push("/shop/success");
                        // orderRepository.clearOrderId()
                        return [
                            2
                        ];
                    }
                    if (data === null || data === void 0 ? void 0 : (ref = data.body) === null || ref === void 0 ? void 0 : ref.orderId) {
                        ;
                        // 2. Store the order id
                        orderRepository/* storeOrderId */.VI(data === null || data === void 0 ? void 0 : (ref2 = data.body) === null || ref2 === void 0 ? void 0 : ref2.orderId);
                    } else {
                        orderRepository/* clearOrderId */.fe();
                        setPageInStock(false);
                    }
                    // 3. Return the order id
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : (ref1 = data.body) === null || ref1 === void 0 ? void 0 : ref1.orderId
                    ];
            }
        });
    }), [
        selectedDetailingCode,
        selectedColorCode,
        selectedUpholsteryCode,
        selectedAccessoriesCodes,
        dispatch,
        router, 
    ]);
    var areAllComponentsSelected = useRedirectIfPreviousComponentsAreNotSelected();
    /**
   * 1. If we have an order id, we already have an order and we don't need to do anything.
   * 2. If we haven't initialized the app, there is nothing to do.
   * 3. If we haven't selected all the components, we can't create an order.
   *
   * If we have an order id or we haven't initialized the app, we don't need to
   * do anything. If we haven't selected all the components, we can't create an
   * order.
   */ (0,react.useEffect)(function() {
        // 1
        if (// 2
        orderRepository/* getOrderId */.NO() || // 3
        !initialized || !areAllComponentsSelected) return;
        createOrder();
    }, [
        initialized,
        areAllComponentsSelected,
        createOrder
    ]);
    // when the component renders for the first time, check if there is a registered user info
    (0,react.useEffect)(function() {
        var // if there is a registered user info, set the values of the form fields to the user info
        ref, ref1, ref2, ref3, ref4;
        console.log(registeredUserInfo);
        if (!registeredUserInfo) return;
        (ref = bagRef.current) === null || ref === void 0 ? void 0 : ref.setFieldValue("firstName", "".concat(registeredUserInfo.firstName));
        (ref1 = bagRef.current) === null || ref1 === void 0 ? void 0 : ref1.setFieldValue("lastName", "".concat(registeredUserInfo.lastName));
        (ref2 = bagRef.current) === null || ref2 === void 0 ? void 0 : ref2.setFieldValue("mobilePhone", registeredUserInfo.mobilePhone);
        (ref3 = bagRef.current) === null || ref3 === void 0 ? void 0 : ref3.setFieldValue("showRoom", registeredUserInfo.showRoom);
        registeredUserInfo.emailAddress && ((ref4 = bagRef.current) === null || ref4 === void 0 ? void 0 : ref4.setFieldValue("emailAddress", registeredUserInfo.emailAddress));
    }, [
        registeredUserInfo
    ]);
    (0,react.useEffect)(function() {
        // Do nothing if the component is not initialized yet
        if (!initialized) return;
        // If the user is authenticated, track the checkout step
        if (authenticated) {
            (0,analytics/* trackCheckoutStep */.rT)("4");
        } else {
            // If the user is not authenticated, redirect them to the summary page
            history.replace(routes_0/* default.summary.path */.Z.summary.path);
        }
    }, [
        initialized,
        authenticated,
        history
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeadingContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageButton, {
                        onClick: function() {
                            history.push(routes_0/* default.summary.path */.Z.summary.path);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPage_StyledImage, {
                            src: "/icons/forward-arrow.svg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPage_StyledHeading, {
                        children: isInStock ? routes_0/* default.order.title */.Z.order.title : "השארת פרטים"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.Formik, {
                innerRef: bagRef,
                validationSchema: schema,
                enableReinitialize: true,
                initialValues: initialValues,
                onSubmit: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(param, param1) {
                        var firstName, lastName, mobilePhone, emailAddress, showRoom, approveMailingList, setSubmitting, userInfo, ref, orderId, _tmp, data, error;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    firstName = param.firstName, lastName = param.lastName, mobilePhone = param.mobilePhone, emailAddress = param.emailAddress, showRoom = param.showRoom, approveMailingList = param.approveMailingList, setSubmitting = param1.setSubmitting;
                                    userInfo = {
                                        firstName: firstName,
                                        lastName: lastName,
                                        mobilePhone: mobilePhone,
                                        emailAddress: emailAddress,
                                        showRoom: showRoom,
                                        approveMailingList: approveMailingList
                                    };
                                    if (!((ref = orderRepository/* getOrderId */.NO()) !== null && ref !== void 0)) return [
                                        3,
                                        1
                                    ];
                                    _tmp = ref;
                                    return [
                                        3,
                                        3
                                    ];
                                case 1:
                                    return [
                                        4,
                                        createOrder()
                                    ];
                                case 2:
                                    _tmp = _state.sent();
                                    _state.label = 3;
                                case 3:
                                    orderId = _tmp;
                                    _state.label = 4;
                                case 4:
                                    _state.trys.push([
                                        4,
                                        7,
                                        8,
                                        9
                                    ]);
                                    return [
                                        4,
                                        (0,api/* putEcommOrders */.M)({
                                            orderId: orderId,
                                            finishingLevelCode: selectedDetailingCode,
                                            colorCode: selectedColorCode,
                                            upholsteryCode: selectedUpholsteryCode,
                                            extrasCodes: selectedAccessoriesCodes,
                                            userInfo: userInfo
                                        })
                                    ];
                                case 5:
                                    data = _state.sent().data;
                                    if ((data === null || data === void 0 ? void 0 : data.errorCode) === 90002 || !isInStock) {
                                        dispatch((0,paymentSlice/* setOutOfStockComplete */.p3)(true));
                                        (0,analytics/* trackPersonalDetails */.AB)("Purchase_leed", userInfo.emailAddress, userInfo.mobilePhone, false);
                                        router.push("/shop/success");
                                        return [
                                            2
                                        ];
                                    }
                                    return [
                                        4,
                                        dispatch((0,paymentSlice/* fetchPaymentUrl */.g3)(orderId))
                                    ];
                                case 6:
                                    _state.sent();
                                    history.push(routes_0/* default.payment.path */.Z.payment.path);
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    error = _state.sent();
                                    console.error("Error processing order:", error);
                                    setErrorMessage("אירעה שגיאה בעת עיבוד ההזמנה. אנא נסה שנית.");
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    setSubmitting(false);
                                    return [
                                        7
                                    ];
                                case 9:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(_, _1) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: function(param) {
                    var isSubmitting = param.isSubmitting, isValid = param.isValid;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInfo, {
                                children: "*שדות חובה"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_UseFocusFirstInvalidField/* default */.Z, {
                                fieldNameInputRefMap: fieldNameInputRefMap
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledForm, {
                                noValidate: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPage_StyledField, {
                                                        name: "firstName",
                                                        id: "firstName",
                                                        component: formik_material_ui_es6/* TextField */.nv,
                                                        label: "שם פרטי",
                                                        autoComplete: "given-name",
                                                        required: true,
                                                        helperText: " " // prevent a "jump" when an error appears
                                                        ,
                                                        inputRef: firstNameRef,
                                                        autoFocus: true,
                                                        placeholder: "שם פרטי"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(register_ShowRoomSelect, {
                                                        showLabel: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPage_StyledField, {
                                                        name: "lastName",
                                                        id: "lastName",
                                                        component: formik_material_ui_es6/* TextField */.nv,
                                                        label: "שם משפחה",
                                                        autoComplete: "family-name",
                                                        required: true,
                                                        helperText: " " // prevent a "jump" when an error appears
                                                        ,
                                                        inputRef: lastNameRef,
                                                        autoFocus: true,
                                                        placeholder: "שם משפחה"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPage_StyledField, {
                                                        name: "emailAddress",
                                                        id: "emailAddress",
                                                        $email: true,
                                                        component: formik_material_ui_es6/* TextField */.nv,
                                                        type: "email",
                                                        label: 'דוא"ל',
                                                        autoComplete: "email",
                                                        required: true,
                                                        inputProps: {
                                                            style: {
                                                                direction: "ltr"
                                                            }
                                                        },
                                                        inputRef: emailAddressRef,
                                                        placeholder: "*מייל",
                                                        classes: {
                                                            root: "orderField"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPage_StyledField, {
                                                name: "mobilePhone",
                                                id: "mobilePhone",
                                                component: formik_material_ui_es6/* TextField */.nv,
                                                type: "tel",
                                                label: "מספר נייד",
                                                autoComplete: "tel-national",
                                                required: true,
                                                helperText: " " // prevent a "jump" when an error appears
                                                ,
                                                inputProps: {
                                                    maxLength: 11,
                                                    style: {
                                                        direction: "ltr"
                                                    }
                                                },
                                                inputRef: mobilePhoneRef,
                                                classes: {
                                                    root: "orderField"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_FormikCheckboxField/* default */.Z, {
                                                name: "terms",
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        "הנני מאשר כי קראתי את",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                                                            href: "/מאזדה_אתר_הזמנות_אוןליין_תקנון_2209_G3693-V001.pdf",
                                                            target: "_blank",
                                                            children: "תקנון הרכישה"
                                                        })
                                                    ]
                                                }),
                                                required: true,
                                                inputRef: termsRef,
                                                classes: {
                                                    root: "orderCheckbox"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_FormikCheckboxField/* default */.Z, {
                                                name: "approveMailingList",
                                                label: "אני רוצה לקבל פניות ועדכונים במייל ו/או בווטסאפ ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד. ולהיכלל במאגר המידע של הקבוצה.",
                                                classes: {
                                                    root: "orderCheckbox"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                type: "submit",
                                                variant: "contained",
                                                color: "primary",
                                                disabled: isSubmitting || !isValid,
                                                $disabled: isSubmitting || !isValid,
                                                fullWidth: true,
                                                children: isInStock ? "שליחת הזמנה" : "שליחת פרטים"
                                            }),
                                            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInfo, {
                                                children: errorMessage
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var order_OrderPage = (OrderPage);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/shopFeatures/payment/PaymentFrame.tsx

function PaymentFrame_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 647px;\n\n  ",
        " {\n    width: auto;\n    margin: ",
        ";\n  }\n"
    ]);
    PaymentFrame_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledIFrame = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    displayName: "PaymentFrame__StyledIFrame",
    componentId: "sc-78c732ae-0"
})(PaymentFrame_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.spacing(0, -2);
});
var PaymentFrame = function(param) {
    var url = param.url;
    var iframeRef = (0,react.useRef)(null);
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var onLoad = function() {
        try {
            var ref, ref1;
            // Get the current iframe window
            var iframeWindow = (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.contentWindow;
            // If the iframe window does not exist, return
            if (!iframeWindow) return;
            // Get the query parameters from the iframe window's location
            var params = lib_default().parse(iframeWindow === null || iframeWindow === void 0 ? void 0 : (ref1 = iframeWindow.location) === null || ref1 === void 0 ? void 0 : ref1.search, {
                ignoreQueryPrefix: true
            });
            // Dispatch the action to set the transaction
            dispatch((0,paymentSlice/* setTransaction */.XT)(params));
        } catch (error) {
        //pass
        }
    };
    if (!url) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIFrame, {
        ref: iframeRef,
        src: url,
        frameBorder: "0",
        onLoad: onLoad
    });
};
/* harmony default export */ var payment_PaymentFrame = (PaymentFrame);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog_Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./common/CloseButton.tsx + 1 modules
var common_CloseButton = __webpack_require__(92217);
;// CONCATENATED MODULE: ./components/shopFeatures/payment/error/ErrorDialog.tsx

function ErrorDialog_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  text-align: center;\n  padding: 20px;\n"
    ]);
    ErrorDialog_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ErrorDialog_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 43px;\n  height: 38px;\n"
    ]);
    ErrorDialog_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ErrorDialog_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  text-align: center;\n"
    ]);
    ErrorDialog_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ErrorDialog_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 22px;\n  letter-spacing: 0em;\n  text-align: center;\n  margin-bottom: 16px;\n"
    ]);
    ErrorDialog_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ErrorDialog_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 10px;\n  right: 5px;\n"
    ]);
    ErrorDialog_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ErrorDialog_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    ErrorDialog_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ErrorDialog_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .errorPaper {\n    max-width: 328px;\n  }\n"
    ]);
    ErrorDialog_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var ErrorDialog_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorDialog__StyledContainer",
    componentId: "sc-2e6bfd8d-0"
})(ErrorDialog_templateObject(), function(p) {
    return p.theme.colors.white;
});
var ErrorDialog_StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "ErrorDialog__StyledImage",
    componentId: "sc-2e6bfd8d-1"
})(ErrorDialog_templateObject1());
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "ErrorDialog__StyledTitle",
    componentId: "sc-2e6bfd8d-2"
})(ErrorDialog_templateObject2(), constants/* Font.OENaPro */.Zx.OENaPro);
var ErrorDialog_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "ErrorDialog__StyledText",
    componentId: "sc-2e6bfd8d-3"
})(ErrorDialog_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro);
var StyledCloseButton = (0,styled_components_browser_esm/* default */.ZP)(common_CloseButton/* default */.Z).withConfig({
    displayName: "ErrorDialog__StyledCloseButton",
    componentId: "sc-2e6bfd8d-4"
})(ErrorDialog_templateObject4());
var ErrorDialog_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "ErrorDialog__StyledButton",
    componentId: "sc-2e6bfd8d-5"
})(ErrorDialog_templateObject5(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.steel;
});
var StyledDialog = (0,styled_components_browser_esm/* default */.ZP)(Dialog_Dialog/* default */.Z).withConfig({
    displayName: "ErrorDialog__StyledDialog",
    componentId: "sc-2e6bfd8d-6"
})(ErrorDialog_templateObject6());
var ErrorDialog = function(param) {
    var open = param.open, onClose = param.onClose, message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDialog, {
        open: open,
        onClose: onClose,
        "aria-labelledby": "dialog-title",
        "aria-describedby": "dialog-description",
        classes: {
            paper: "errorPaper "
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorDialog_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseButton, {
                    onClick: onClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorDialog_StyledImage, {
                    src: "/icons/Union.svg",
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                    id: "dialog-title",
                    children: "משהו השתבש בדרך"
                }),
                message && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorDialog_StyledText, {
                    children: message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorDialog_StyledText, {
                    id: "dialog-description",
                    children: "בבקשה בדקו את הפרטים שהוזנו ונסו שוב."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorDialog_StyledButton, {
                    variant: "contained",
                    color: "primary",
                    onClick: onClose,
                    children: "חזרה לסליקת כרטיס האשראי"
                })
            ]
        })
    });
};
/* harmony default export */ var error_ErrorDialog = (ErrorDialog);

;// CONCATENATED MODULE: ./components/shopFeatures/payment/PaymentPage.tsx



function PaymentPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    text-align: center;\n    margin-top: 40px;\n  }\n"
    ]);
    PaymentPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PaymentPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    PaymentPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PaymentPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 5px;\n  top: 15px;\n"
    ]);
    PaymentPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PaymentPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 22px;\n  letter-spacing: 0em;\n  text-align: center;\n  margin-bottom: 20px;\n"
    ]);
    PaymentPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















var ENV = "production";
var PaymentPage_StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "PaymentPage__StyledHeading",
    componentId: "sc-261ec045-0"
})(PaymentPage_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var PaymentPage_StyledHeadingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PaymentPage__StyledHeadingContainer",
    componentId: "sc-261ec045-1"
})(PaymentPage_templateObject1());
var PaymentPage_StyledImageButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "PaymentPage__StyledImageButton",
    componentId: "sc-261ec045-2"
})(PaymentPage_templateObject2());
var PaymentPage_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "PaymentPage__StyledText",
    componentId: "sc-261ec045-3"
})(PaymentPage_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro);
var PaymentPage = function() {
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.payment;
    }), creditGuardUrl = ref.creditGuardUrl, transactionComplete = ref.transactionComplete;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref1 = (0,react.useState)(false), openModal = ref1[0], setOpenModal = ref1[1];
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var history = (0,react_router/* useHistory */.k6)();
    var router = (0,next_router.useRouter)();
    var updatePaymentUrl = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var orderId;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    orderId = orderRepository/* getOrderId */.NO();
                    if (!orderId) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        dispatch((0,paymentSlice/* fetchPaymentUrl */.g3)(orderId))
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    // If there isn't an order ID, throw an error.
                    throw new Error("No order ID");
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        dispatch
    ]);
    // When the transaction is complete...
    (0,react.useEffect)(function() {
        if (!transactionComplete) return;
        // If the transaction was successful...
        if (transactionComplete.succeed) {
            // Clear the order ID
            orderRepository/* clearOrderId */.fe();
            // Redirect to the success page
            router.replace("/shop/success");
        } else {
            // Otherwise, open the modal
            setOpenModal(true);
        }
    }, [
        transactionComplete,
        router
    ]);
    // On first mount, check if we have a payment URL
    (0,react.useEffect)(function() {
        if (creditGuardUrl) {
            // If we have a payment URL, track the checkout step
            (0,analytics/* trackCheckoutStep */.rT)("5");
        } else {
            // If we don't have a payment URL, get one from the API
            updatePaymentUrl().catch(function() {
                return history.replace(routes_0/* default.order.path */.Z.order.path);
            });
        }
    }, [
        creditGuardUrl,
        updatePaymentUrl,
        history
    ]);
    // split useEffect so return function wont jump on creditGuardUrl value change
    (0,react.useEffect)(function() {
        return function() {
            dispatch((0,paymentSlice/* clearCreditGuardUrl */.kh)());
        };
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: ENV !== "production" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        src: "https://ppsuat.creditguard.co.il/plugins/applePayOnIframe.js"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    src: "https://pps.creditguard.co.il/plugins/applePayOnIframe.js"
                })
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentPage_StyledHeadingContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentPage_StyledImageButton, {
                                onClick: function() {
                                    history.push(routes_0/* default.order.path */.Z.order.path);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/forward-arrow.svg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentPage_StyledHeading, {
                                children: routes_0/* default.payment.title */.Z.payment.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentPage_StyledText, {
                        children: [
                            "אל דאגה, המקדמה תוחזר לך במלואה אם בסופו של דבר לא תושלם הרכישה.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "התשלום כעת מבטיח שנשמור לך את ההטבה ואת ההצעה"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_PaymentFrame, {
                url: creditGuardUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorDialog, {
                open: openModal,
                message: (transactionComplete === null || transactionComplete === void 0 ? void 0 : transactionComplete.message) || null,
                onClose: function() {
                    setOpenModal(false);
                    dispatch((0,paymentSlice/* resetTransactionComplete */.Tu)());
                    updatePaymentUrl();
                }
            })
        ]
    });
};
/* harmony default export */ var payment_PaymentPage = (PaymentPage);

// EXTERNAL MODULE: ./components/shopFeatures/upholstery/upholsterySlice.ts
var upholsterySlice = __webpack_require__(24546);
;// CONCATENATED MODULE: ./components/shopFeatures/upholstery/UpholsterySidebar.tsx

function UpholsterySidebar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);\n  }\n"
    ]);
    UpholsterySidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UpholsterySidebar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    margin-bottom: 30px;\n  }\n"
    ]);
    UpholsterySidebar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UpholsterySidebar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    UpholsterySidebar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2",
    component: "h1",
    tabIndex: 0
}).withConfig({
    displayName: "UpholsterySidebar__StyledHeadline",
    componentId: "sc-6281463d-0"
})(UpholsterySidebar_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var UpholsterySidebar_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UpholsterySidebar__StyledWrapper",
    componentId: "sc-6281463d-1"
})(UpholsterySidebar_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledMobileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UpholsterySidebar__StyledMobileWrapper",
    componentId: "sc-6281463d-2"
})(UpholsterySidebar_templateObject2());
var UpholsterySidebar = function() {
    useRedirectIfPreviousComponentsAreNotSelected();
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.upholstery;
    }), upholsteries = ref.upholsteries, selectedUpholsteryCode = ref.selectedUpholsteryCode;
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var upholsteriesData = mapDataToFitCarousel(upholsteries, "thumbnailImage");
    var selectedUpholsteryIndex = upholsteries.reduce(function(a, b, i) {
        var ref;
        if ((b === null || b === void 0 ? void 0 : (ref = b.details) === null || ref === void 0 ? void 0 : ref.code) === selectedUpholsteryCode) return i;
        return a;
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                    id: "upholsteriesHeadline",
                    children: "בחירת ריפוד"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UpholsterySidebar_StyledWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_Colors, {
                        type: "upholstery",
                        data: upholsteriesData,
                        selectedItem: selectedUpholsteryCode,
                        handleColorChange: function(code) {
                            dispatch((0,upholsterySlice/* setSelectedUpholstery */.Bv)(code));
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorsCarousel/* default */.Z, {
                selectedColorIndex: selectedUpholsteryIndex,
                colorsData: upholsteriesData,
                handleColorChange: function(index) {
                    var ref;
                    dispatch((0,upholsterySlice/* setSelectedUpholstery */.Bv)((ref = upholsteriesData[index]) === null || ref === void 0 ? void 0 : ref.code));
                },
                loop: false,
                textPosition: "bottom",
                showExtraPrice: true,
                pathname: pathname
            })
        })
    });
};
/* harmony default export */ var upholstery_UpholsterySidebar = (UpholsterySidebar);

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
;// CONCATENATED MODULE: ./common/ModelAndDetailing.tsx

function ModelAndDetailing_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        ",
        " {\n          margin-top: ",
        "px;\n        }\n      }\n\n      ",
        " {\n        font-size: 1rem;\n        margin-top: ",
        "px;\n\n        ",
        " {\n          margin-top: ",
        "px;\n        }\n      }\n    "
    ]);
    ModelAndDetailing_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModelAndDetailing_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-bottom: -70px;\n\n  ",
        " {\n    margin-bottom: -100px;\n  }\n"
    ]);
    ModelAndDetailing_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModelAndDetailing_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: normal;\n  flex-shrink: 0;\n\n  ",
        " {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    ModelAndDetailing_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModelAndDetailing_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.3125rem;\n  letter-spacing: 2.1px;\n  margin: 0;\n\n  ",
        " {\n    font-family: ",
        ";\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 45px;\n    letter-spacing: 0.11em;\n  }\n"
    ]);
    ModelAndDetailing_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModelAndDetailing_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0.08em;\n  color: ",
        ";\n\n  margin-top: ",
        "px;\n\n  ",
        " {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    ModelAndDetailing_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var StyledIfPopup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelAndDetailing__StyledIfPopup",
    componentId: "sc-b99ab13-0"
})(ModelAndDetailing_templateObject1(), function(p) {
    return p.popup && (0,styled_components_browser_esm/* css */.iv)(ModelAndDetailing_templateObject(), ModelAndDetailing_StyledHeadline, function(p) {
        return p.theme.breakpoints.up("md");
    }, function(p) {
        return p.theme.spacing(1.5);
    }, ModelAndDetailing_StyledDetailing, function(p) {
        return p.theme.spacing(1.5);
    }, function(p) {
        return p.theme.breakpoints.up("md");
    }, function(p) {
        return p.theme.spacing(1.5);
    });
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var ModelAndDetailing_StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h1",
    component: "div"
}).withConfig({
    displayName: "ModelAndDetailing__StyledHeadline",
    componentId: "sc-b99ab13-1"
})(ModelAndDetailing_templateObject2(), function(p) {
    return p.theme.spacing(2, 0);
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.spacing(3.5);
});
var StyledModel = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2",
    component: "h1"
}).withConfig({
    displayName: "ModelAndDetailing__StyledModel",
    componentId: "sc-b99ab13-2"
})(ModelAndDetailing_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
}, constants/* Font.MazdaType */.Zx.MazdaType);
var ModelAndDetailing_StyledDetailing = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "ModelAndDetailing__StyledDetailing",
    componentId: "sc-b99ab13-3"
})(ModelAndDetailing_templateObject4(), constants/* Font.MazdaType */.Zx.MazdaType, function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.disable;
}, function(p) {
    return p.theme.spacing(0.5);
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.spacing(1);
});
var ModelAndDetailing = function(param) {
    var popup = param.popup;
    var selectedDetailing = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedDetailingSelector */.YF);
    var selectedEngine = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedEngineSelector */.DI);
    if (!selectedDetailing) return null;
    var _details = selectedDetailing.details, modelName = _details.modelName, name = _details.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIfPopup, {
        popup: popup,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModelAndDetailing_StyledHeadline, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModel, {
                    children: modelName.toUpperCase()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModelAndDetailing_StyledDetailing, {
                    children: [
                        name,
                        " ",
                        selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.engineIdName
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var common_ModelAndDetailing = (ModelAndDetailing);

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./common/createImageApiUrl.ts
var createImageApiUrl = __webpack_require__(12104);
;// CONCATENATED MODULE: ./common/ModelImage.tsx

function ModelImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 0;\n    "
    ]);
    ModelImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModelImage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: ",
        "px;\n  margin-bottom: 18px;\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n\n  ",
        " {\n    width: auto !important;\n    aspect-ratio: 375 / 270;\n    margin-bottom: 0;\n  }\n  ",
        "\n"
    ]);
    ModelImage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModelImage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: block;\n  object-fit: contain;\n\n  ",
        " {\n    max-height: 344px;\n  }\n"
    ]);
    ModelImage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var maxImageSize = 900;
var MODEL_IMAGE_INDEX = 3;
var StyledModelImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelImage__StyledModelImageContainer",
    componentId: "sc-21a7ef28-0"
})(ModelImage_templateObject1(), maxImageSize, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$isShowRoomsScreens && (0,styled_components_browser_esm/* css */.iv)(ModelImage_templateObject());
});
var StyledModelImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "ModelImage__StyledModelImage",
    componentId: "sc-21a7ef28-1"
})(ModelImage_templateObject2(), function(p) {
    return p.theme.breakpoints.down("lg");
});
var ModelImage = function() {
    var selectedDetailing = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedDetailingSelector */.YF);
    var selectedColor = (0,store/* useTypedSelector */.ix)(colorSelectors/* selectedColorSelector */.Q);
    var isShowRoomsScreens = (0,LayoutContext/* useLayoutContext */.l)().isShowRoomsScreens;
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var imageUrl = (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.details.images[MODEL_IMAGE_INDEX].imageUrl) || (selectedDetailing === null || selectedDetailing === void 0 ? void 0 : selectedDetailing.details.image.imageUrl);
    if (!imageUrl) return null;
    var alt = "".concat(selectedDetailing === null || selectedDetailing === void 0 ? void 0 : selectedDetailing.details.modelName, ", ").concat(selectedDetailing === null || selectedDetailing === void 0 ? void 0 : selectedDetailing.details.name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModelImageContainer, {
        $page: pathname,
        $isShowRoomsScreens: isShowRoomsScreens,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                openGraph: {
                    images: imageUrl ? [
                        {
                            url: (0,createImageApiUrl/* createImageApiUrl */.h)(imageUrl),
                            alt: alt,
                            width: 1200,
                            height: 630
                        }, 
                    ] : []
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModelImage, {
                    src: "".concat(imageUrl, "?width=375"),
                    sizes: "100vw",
                    srcSet: "".concat(imageUrl, "?width=375 1x, ").concat(imageUrl, "?width=750 2x, ").concat(imageUrl, "?width=1125 3x"),
                    alt: alt
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModelImage, {
                    src: "".concat(imageUrl, "?width=900"),
                    alt: alt
                })
            })
        ]
    });
};
/* harmony default export */ var common_ModelImage = (ModelImage);

;// CONCATENATED MODULE: ./common/ModelTitleAndImage.tsx




var ModelTitleAndImage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ModelAndDetailing, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ModelImage, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "srOnly",
                component: "h2",
                children: "גלריית תמונות רכב"
            })
        ]
    });
};
/* harmony default export */ var common_ModelTitleAndImage = (ModelTitleAndImage);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/mapPages/showRooms/ShowRoomItem.tsx + 1 modules
var ShowRoomItem = __webpack_require__(17946);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
;// CONCATENATED MODULE: ./components/shopFeatures/wizard/bottomBar/Container.tsx

function Container_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  background-color: ",
        ";\n\n  ",
        " {\n    height: 64px;\n    border-top: 1px solid ",
        ";\n    box-shadow: 0 -5px 25px 0 rgba(0, 0, 0, 0.15);\n    flex-wrap: wrap;\n  }\n\n  ",
        " {\n    width: auto;\n    min-height: 80px;\n  }\n"
    ]);
    Container_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Container_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Container_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var bottomBarContainerCss = (0,styled_components_browser_esm/* css */.iv)(Container_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var Container_StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).attrs({
    maxWidth: false
}).withConfig({
    displayName: "Container__StyledContainer",
    componentId: "sc-f46e4fc0-0"
})(Container_templateObject1(), bottomBarContainerCss);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/bottomBar/LicensingFee.tsx

function LicensingFee_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  line-height: 130%;\n  font-weight: 300;\n  font-family: ",
        ";\n  letter-spacing: inherit;\n"
    ]);
    LicensingFee_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var LicensingFee_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "LicensingFee__StyledText",
    componentId: "sc-7fa2b277-0"
})(LicensingFee_templateObject(), function(p) {
    return p.theme.colors.disable;
}, ShowRoomItem/* Font.OENaPro */.Zx.OENaPro);
var LicensingFee = function() {
    var licensingFee = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).licensingFee;
    if (!licensingFee) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LicensingFee_StyledText, {
        children: [
            'כולל מע"מ ואגרת רישוי בסך ',
            formatPrice(licensingFee.totalPrice),
            ".",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "בהתאם ל",
            licensingFee.annualPriceCatalogText.trim(),
            "."
        ]
    });
};
/* harmony default export */ var bottomBar_LicensingFee = (LicensingFee);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/wizardSelectors.ts
var wizardSelectors = __webpack_require__(31544);
;// CONCATENATED MODULE: ./components/shopFeatures/wizard/bottomBar/NextStepButton.tsx

function NextStepButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NextStepButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NextStepButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  color: ",
        ";\n  margin-left: -6px;\n  font-size: 15px;\n"
    ]);
    NextStepButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NextStepButton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n  border-radius: 3px;\n\n  :hover {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n  &.Mui-disabled {\n    color: ",
        ";\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    NextStepButton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var StyledDesktopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NextStepButton__StyledDesktopContainer",
    componentId: "sc-d207ee99-0"
})(NextStepButton_templateObject());
var StyledKeyboardArrowLeftIcon = (0,styled_components_browser_esm/* default */.ZP)(KeyboardArrowLeft/* default */.Z).withConfig({
    displayName: "NextStepButton__StyledKeyboardArrowLeftIcon",
    componentId: "sc-d207ee99-1"
})(NextStepButton_templateObject1(), function(p) {
    return p.theme.colors.white;
});
var NextStepButton_StyledButtonLink = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).attrs({
    component: react_router_dom/* Link */.rU
}).withConfig({
    displayName: "NextStepButton__StyledButtonLink",
    componentId: "sc-d207ee99-2"
})(NextStepButton_templateObject2(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.steel;
}, function(p) {
    return p.theme.colors.steel;
}, function(p) {
    return p.theme.colors.white;
});
var NextStepButton = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var activeStepIndex = routes_0/* default.array.findIndex */.Z.array.findIndex(function(r) {
        return r.path === pathname;
    });
    var nextStep = routes_0/* default.array */.Z.array[activeStepIndex + 1];
    var showOnlyStock = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).showOnlyStock;
    var inStock = wizard_useInStock();
    var selectedComponentsForAnalytics = (0,store/* useTypedSelector */.ix)(wizardSelectors/* selectedComponentsForAnalyticsSelector */.Q);
    var focusMain = (0,LayoutContext/* useLayoutContext */.l)().focusMain;
    var Container = isDesktop ? StyledDesktopContainer : react.Fragment;
    // const mounted = useMounted()
    if (!nextStep) return null;
    var sendEvent = function() {
        if (selectedComponentsForAnalytics) {
            (0,analytics/* trackAddToCart */.Kc)(selectedComponentsForAnalytics);
            (0,analytics/* trackCheckoutStepWithComponents */.El)(selectedComponentsForAnalytics);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextStepButton_StyledButtonLink, {
            onClick: function() {
                nextStep.path === routes_0/* default.summary.path */.Z.summary.path && sendEvent();
                focusMain();
            },
            variant: "outlined",
            color: "primary",
            to: nextStep.path,
            role: "link",
            disabled: !inStock && showOnlyStock,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                    variant: "srOnly",
                    children: "לשלב הבא,"
                }),
                nextStep.path === routes_0/* default.summary.path */.Z.summary.path ? "ל".concat(nextStep.title) : "לבחירת ".concat(nextStep.title),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledKeyboardArrowLeftIcon, {})
            ]
        })
    });
};
/* harmony default export */ var bottomBar_NextStepButton = (NextStepButton);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/bottomBar/totalPrice/TotalPriceDesktop.tsx



function TotalPriceDesktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  max-width: 400px;\n  border-radius: 5px;\n"
    ]);
    TotalPriceDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TotalPriceDesktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 86px;\n  text-align: left;\n  margin-left: 10px;\n"
    ]);
    TotalPriceDesktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TotalPriceDesktop_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.875rem;\n  ",
        "\n"
    ]);
    TotalPriceDesktop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TotalPriceDesktop_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: 0.08em;\n"
    ]);
    TotalPriceDesktop_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TotalPriceDesktop_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n"
    ]);
    TotalPriceDesktop_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var TotalPriceDesktop_StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container_StyledContainer).withConfig({
    displayName: "TotalPriceDesktop__StyledContainer",
    componentId: "sc-cb6166ed-0"
})(TotalPriceDesktop_templateObject());
var styledLabelCss = (0,styled_components_browser_esm/* css */.iv)(TotalPriceDesktop_templateObject1());
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var TotalPriceDesktop_StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var discount = _param.discount, props = (0,_object_without_properties/* default */.Z)(_param, [
        "discount"
    ]);
    return (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, (0,src_object_spread/* default */.Z)({}, props));
}).attrs({
    component: "h3"
}).withConfig({
    displayName: "TotalPriceDesktop__StyledHeading",
    componentId: "sc-cb6166ed-1"
})(TotalPriceDesktop_templateObject2(), function(p) {
    return p.discount && styledLabelCss;
});
var TotalPriceDesktop_StyledPrice = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "TotalPriceDesktop__StyledPrice",
    componentId: "sc-cb6166ed-2"
})(TotalPriceDesktop_templateObject3(), ShowRoomItem/* Font.MazdaType */.Zx.MazdaType);
var StyledPriceAndBtnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TotalPriceDesktop__StyledPriceAndBtnWrapper",
    componentId: "sc-cb6166ed-3"
})(TotalPriceDesktop_templateObject4());
var TotalPriceDesktop = function(param) {
    var price = param.price;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalPriceDesktop_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceAndBtnWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPriceDesktop_StyledPrice, {
                            "aria-label": "מחיר נוכחי",
                            children: formatPrice(price.totalPrice)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomBar_NextStepButton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomBar_LicensingFee, {})
        ]
    });
};
/* harmony default export */ var totalPrice_TotalPriceDesktop = (TotalPriceDesktop);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/bottomBar/totalPrice/TotalPriceMobile.tsx

function TotalPriceMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: 0.08em;\n"
    ]);
    TotalPriceMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TotalPriceMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px;\n  margin: 0;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 4px rgba(0, 0, 0, 0.08);\n  border-radius: 5px;\n  background-color: #ffffff;\n  height: 100%;\n"
    ]);
    TotalPriceMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TotalPriceMobile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    TotalPriceMobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var TotalPriceMobile_StyledPrice = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "TotalPriceMobile__StyledPrice",
    componentId: "sc-e6f99eb9-0"
})(TotalPriceMobile_templateObject(), constants/* Font.MazdaType */.Zx.MazdaType);
var TotalPriceMobile_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TotalPriceMobile__StyledContainer",
    componentId: "sc-e6f99eb9-1"
})(TotalPriceMobile_templateObject1());
var StyledPriceAndBtnContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TotalPriceMobile__StyledPriceAndBtnContainer",
    componentId: "sc-e6f99eb9-2"
})(TotalPriceMobile_templateObject2());
var TotalPriceMobile = function(param) {
    var price = param.price;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalPriceMobile_StyledContainer, {
        discount: price.discount > 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceAndBtnContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalPriceMobile_StyledPrice, {
                        children: formatPrice(price.totalPrice)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomBar_NextStepButton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomBar_LicensingFee, {})
        ]
    });
};
/* harmony default export */ var totalPrice_TotalPriceMobile = (TotalPriceMobile);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/bottomBar/totalPrice/TotalPrice.tsx





var TotalPrice = function() {
    var price = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).price;
    if (!price) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(totalPrice_TotalPriceMobile, {
                    price: price
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(totalPrice_TotalPriceDesktop, {
                    price: price
                })
            })
        ]
    });
};
/* harmony default export */ var totalPrice_TotalPrice = (TotalPrice);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
;// CONCATENATED MODULE: ./components/shopFeatures/wizard/OutOfStockBanner.tsx

function OutOfStockBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        position: relative;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        border-radius: 0;\n        left: 0;\n        right: 0;\n      "
    ]);
    OutOfStockBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OutOfStockBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      position: relative;\n      top: 0;\n      left: 0;\n      border-radius: 0;\n      left: 0;\n      right: 0;\n    "
    ]);
    OutOfStockBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OutOfStockBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: ",
        ";\n  right: ",
        ";\n  ",
        ";\n  background-color: ",
        ";\n  display: flex;\n  /* padding: 0 8px 0 0; */\n  align-items: center;\n  z-index: 1300;\n  border-radius: 3px;\n\n  ",
        " {\n    left: 0;\n    right: 0;\n    padding: 3px 0 3px 0;\n    z-index: 1100;\n    bottom: calc(100% + 10px);\n    ",
        "\n  }\n  ",
        "\n"
    ]);
    OutOfStockBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OutOfStockBanner_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  line-height: 1.3;\n  font-family: ",
        ";\n  padding: 8px 16px;\n  ",
        " {\n    padding: 4px 8px;\n  }\n  letter-spacing: initial;\n"
    ]);
    OutOfStockBanner_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OutOfStockBanner_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: auto;\n  padding: 6px 8px;\n  ",
        " {\n    align-self: flex-start;\n  }\n"
    ]);
    OutOfStockBanner_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function OutOfStockBanner_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  font-weight: 700;\n"
    ]);
    OutOfStockBanner_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var StyledBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OutOfStockBanner__StyledBanner",
    componentId: "sc-68fe1685-0"
})(OutOfStockBanner_templateObject2(), function(p) {
    return !p.$addPadding ? "0" : "24px";
}, function(p) {
    return !p.$addPadding ? "0" : "24px";
}, function(p) {
    return p.$isSummery ? "top: 0" : "bottom:calc(100% + 24px)";
}, function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$isSummery && (0,styled_components_browser_esm/* css */.iv)(OutOfStockBanner_templateObject());
}, function(p) {
    return p.$isSummery && (0,styled_components_browser_esm/* css */.iv)(OutOfStockBanner_templateObject1());
});
var OutOfStockBanner_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "OutOfStockBanner__StyledText",
    componentId: "sc-68fe1685-1"
})(OutOfStockBanner_templateObject3(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.typography.fontFamily;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    displayName: "OutOfStockBanner__StyledIconButton",
    componentId: "sc-68fe1685-2"
})(OutOfStockBanner_templateObject4(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "OutOfStockBanner__StyledLink",
    componentId: "sc-68fe1685-3"
})(OutOfStockBanner_templateObject5(), function(p) {
    return p.theme.colors.white;
});
var OutOfStockBanner = function(param) {
    var _isSummery = param.isSummery, isSummery = _isSummery === void 0 ? false : _isSummery, isColors = param.isColors;
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }), hideOutOfStockBanner = ref.hideOutOfStockBanner, showOnlyStock = ref.showOnlyStock;
    var inStock = wizard_useInStock();
    var dispatch = (0,store/* useAppDispatch */.TL)();
    if (inStock || showOnlyStock || hideOutOfStockBanner) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBanner, {
        $isSummery: isSummery,
        $addPadding: isColors,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutOfStockBanner_StyledText, {
                children: [
                    "חלק מהבחירות שלך לא זמינות כרגע באתר, רוצה שנעזור לך למצוא את הרכב המתאים עבורך?",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                        href: "/contact-us?subject=קניית רכב",
                        children: "להשארת פרטים"
                    })
                ]
            }),
            !isSummery && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                onClick: function() {
                    return dispatch((0,wizardSlice/* setHideOutOfStockBanner */.zr)(true));
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/icons/exitMenu.svg",
                    alt: "סגירת ההודעה"
                })
            })
        ]
    });
};
/* harmony default export */ var wizard_OutOfStockBanner = (OutOfStockBanner);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/AssignmentOutlined.js
var AssignmentOutlined = __webpack_require__(66596);
// EXTERNAL MODULE: ./components/carModelPage/sections/specifications/pollutionColors.ts
var pollutionColors = __webpack_require__(81623);
// EXTERNAL MODULE: ./components/carModelPage/sections/specifications/safetyColors.ts
var safetyColors = __webpack_require__(34763);
// EXTERNAL MODULE: ./components/carModelPage/sections/specifications/PollutionTable.tsx
var PollutionTable = __webpack_require__(71231);
// EXTERNAL MODULE: ./components/carModelPage/sections/specifications/SafetyTable.tsx
var SafetyTable = __webpack_require__(70554);
// EXTERNAL MODULE: ./node_modules/next/dist/client/image.js
var client_image = __webpack_require__(28045);
var image_default = /*#__PURE__*/__webpack_require__.n(client_image);
// EXTERNAL MODULE: ./reusable/popups/PopUp.tsx
var PopUp = __webpack_require__(24184);
;// CONCATENATED MODULE: ./components/shopFeatures/wizard/pollutionAndSafety/ImageModal.tsx

function ImageModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 400px;\n  ",
        " {\n    width: 100%;\n  }\n  table {\n    width: 100%;\n  }\n"
    ]);
    ImageModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImageModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100px;\n  position: relative;\n"
    ]);
    ImageModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledInnerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageModal__StyledInnerContent",
    componentId: "sc-743d2f2c-0"
})(ImageModal_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageModal__StyledImageContainer",
    componentId: "sc-743d2f2c-1"
})(ImageModal_templateObject1());
var ImageModal = function(param) {
    var open = param.open, onClose = param.onClose, label = param.label, regulation = param.regulation, modalType = param.modalType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUp/* default */.Z, {
        header: label,
        setOpen: onClose,
        open: open,
        maxWidth: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: modalType === "pollution" ? regulation.pollutionMainImage : regulation.safetyMainImage,
                        alt: "alt",
                        layout: "fill"
                    })
                }),
                modalType === "pollution" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PollutionTable/* default */.Z, {
                    data: regulation
                }),
                modalType === "safety" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyTable/* default */.Z, {
                    data: regulation
                })
            ]
        })
    });
};
/* harmony default export */ var pollutionAndSafety_ImageModal = (ImageModal);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/pollutionAndSafety/PollutionAndSafety.tsx

function PollutionAndSafety_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 0;\n  padding: 0;\n  z-index: 1;\n\n  ",
        "\n"
    ]);
    PollutionAndSafety_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 13px;\n"
    ]);
    PollutionAndSafety_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ';\n  border-radius: 3px;\n  padding: 10px;\n  /* flex-shrink: 0; */\n  &:focus-visible {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n\n  > [class*="MuiButton-label"] {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n'
    ]);
    PollutionAndSafety_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  width: 120px;\n  /* flex-shrink: 0; */\n  ",
        "\n"
    ]);
    PollutionAndSafety_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: 0.05em;\n  display: inline-block;\n"
    ]);
    PollutionAndSafety_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 16px;\n  letter-spacing: 0em;\n"
    ]);
    PollutionAndSafety_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 18px;\n  height: 18px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 10px;\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  font-family: ",
        ";\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 16px;\n  letter-spacing: 0em;\n"
    ]);
    PollutionAndSafety_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  line-height: 13px;\n  letter-spacing: 0em;\n  color: ",
        ";\n"
    ]);
    PollutionAndSafety_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 5px;\n  width: 13px;\n"
    ]);
    PollutionAndSafety_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 16px;\n  letter-spacing: 0em;\n  margin-top: 6px;\n"
    ]);
    PollutionAndSafety_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function PollutionAndSafety_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    PollutionAndSafety_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
















var PollutionAndSafety_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PollutionAndSafety__StyledContainer",
    componentId: "sc-8e1db552-0"
})(PollutionAndSafety_templateObject(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$pathname) === constants/* STEPS_EN.color */.Ws.color && "padding: 0 32px;";
});
var StyledPollutionAndSafetyContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PollutionAndSafety__StyledPollutionAndSafetyContainer",
    componentId: "sc-8e1db552-1"
})(PollutionAndSafety_templateObject1());
var PollutionAndSafety_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "PollutionAndSafety__StyledButton",
    componentId: "sc-8e1db552-2"
})(PollutionAndSafety_templateObject2(), function(p) {
    return p.theme.colors.borderGrey;
});
var StyledButtonWheels = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).attrs({
    target: "_blank"
}).withConfig({
    displayName: "PollutionAndSafety__StyledButtonWheels",
    componentId: "sc-8e1db552-3"
})(PollutionAndSafety_templateObject3(), function(p) {
    return p.$mobile && "margin: 0 0 15px 0;";
}, function(p) {
    return p.$isShowRoomsScreens && "border: 1px solid ".concat(p.theme.colors.borderGrey, ";\n    border-radius: 3px;\n    padding: 10px;\n    p{\n      font-size:12px;\n    }");
});
var StyledWheelsLabel = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "PollutionAndSafety__StyledWheelsLabel",
    componentId: "sc-8e1db552-4"
})(PollutionAndSafety_templateObject4(), ShowRoomItem/* Font.OENaPro */.Zx.OENaPro);
var PollutionAndSafety_StyledLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PollutionAndSafety__StyledLabel",
    componentId: "sc-8e1db552-5"
})(PollutionAndSafety_templateObject5(), ShowRoomItem/* Font.OENaPro */.Zx.OENaPro);
var StyledNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PollutionAndSafety__StyledNumber",
    componentId: "sc-8e1db552-6"
})(PollutionAndSafety_templateObject6(), function(p) {
    return p.backgroundColor;
}, function(p) {
    return p.color;
}, ShowRoomItem/* Font.OENaPro */.Zx.OENaPro);
var StyledDisclaimer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "PollutionAndSafety__StyledDisclaimer",
    componentId: "sc-8e1db552-7"
})(PollutionAndSafety_templateObject7(), ShowRoomItem/* Font.OENaPro */.Zx.OENaPro, function(p) {
    return p.$invertColor ? "white" : "black";
});
var StyledAssignmentOutlinedIcon = (0,styled_components_browser_esm/* default */.ZP)(AssignmentOutlined/* default */.Z).withConfig({
    displayName: "PollutionAndSafety__StyledAssignmentOutlinedIcon",
    componentId: "sc-8e1db552-8"
})(PollutionAndSafety_templateObject8());
var StyledLabelLink = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).withConfig({
    displayName: "PollutionAndSafety__StyledLabelLink",
    componentId: "sc-8e1db552-9"
})(PollutionAndSafety_templateObject9(), ShowRoomItem/* Font.OENaPro */.Zx.OENaPro);
var StyledLabelAndBtnContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PollutionAndSafety__StyledLabelAndBtnContainer",
    componentId: "sc-8e1db552-10"
})(PollutionAndSafety_templateObject10());
var PollutionAndSafety = function(param) {
    var invertColor = param.invertColor;
    var ref = (0,react.useState)(null), openModal = ref[0], setOpenModal = ref[1];
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var isShowRoomsScreens = (0,LayoutContext/* useLayoutContext */.l)().isShowRoomsScreens;
    var ref1 = (0,useTheme/* default */.Z)(), _colors = ref1.colors, white = _colors.white, black = _colors.black;
    var themeColor = invertColor ? "secondary" : "primary";
    var selectedDetailing = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedDetailingSelector */.YF);
    if (!selectedDetailing) return null;
    var _details = selectedDetailing.details, pollutionLevel = _details.pollutionLevel, safetyLevel = _details.safetyLevel, tireSpecImage = _details.tireSpecImage, regulation = _details.regulation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollutionAndSafety_StyledContainer, {
        $pathname: pathname,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonWheels, {
                    $mobile: true,
                    color: themeColor,
                    href: tireSpecImage.imageUrl,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAssignmentOutlinedIcon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWheelsLabel, {
                            children: "נתוני צמיגים"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPollutionAndSafetyContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollutionAndSafety_StyledButton, {
                        color: themeColor,
                        onClick: function() {
                            return setOpenModal("pollution");
                        },
                        "aria-expanded": openModal === "pollution" ? true : false,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLabelAndBtnContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PollutionAndSafety_StyledLabel, {
                                        children: "דרגת זיהום"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNumber, {
                                        backgroundColor: pollutionColors/* default */.Z[pollutionLevel - 1],
                                        color: pollutionLevel <= 4 || pollutionLevel >= 13 ? white : black,
                                        children: pollutionLevel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabelLink, {
                                color: themeColor,
                                children: "לפרטים נוספים"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pollutionAndSafety_ImageModal, {
                        open: openModal === "pollution",
                        label: "דרגת זיהום",
                        onClose: function() {
                            return setOpenModal(null);
                        },
                        regulation: regulation,
                        modalType: openModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollutionAndSafety_StyledButton, {
                        color: themeColor,
                        onClick: function() {
                            return setOpenModal("safety");
                        },
                        "aria-expanded": openModal === "safety" ? true : false,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLabelAndBtnContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PollutionAndSafety_StyledLabel, {
                                        children: "רמת האבזור הבטיחותי"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNumber, {
                                        backgroundColor: safetyColors/* default */.Z[safetyLevel],
                                        color: safetyLevel <= 5 ? black : white,
                                        children: safetyLevel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabelLink, {
                                color: themeColor,
                                children: "לפרטים נוספים"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pollutionAndSafety_ImageModal, {
                        open: openModal === "safety",
                        label: "רמת האבזור הבטיחותי",
                        onClose: function() {
                            return setOpenModal(null);
                        },
                        regulation: regulation,
                        modalType: openModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonWheels, {
                            $isShowRoomsScreens: isShowRoomsScreens,
                            color: themeColor,
                            href: tireSpecImage.imageUrl,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAssignmentOutlinedIcon, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWheelsLabel, {
                                    color: themeColor,
                                    children: "נתוני צמיגים"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDisclaimer, {
                $invertColor: invertColor,
                children: [
                    "התמונה להמחשה בלבד. בכפוף ל",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                        href: "/מאזדה_אתר_הזמנות_אוןליין_תקנון_2209_G3693-V001.pdf",
                        target: "_blank",
                        color: themeColor,
                        children: "תקנון"
                    }),
                    ". לכל פניה ושאלה ניתן לפנות למוקד שירות הלקוחות בטלפון",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                        href: "tel:08-9139995",
                        color: themeColor,
                        children: "08-9139995"
                    }),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var pollutionAndSafety_PollutionAndSafety = (PollutionAndSafety);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/ShopFooter/ShopFooter.tsx

function ShopFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex-direction: column-reverse;\n      align-items: center;\n      gap: 20px;\n    "
    ]);
    ShopFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShopFooter_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: ",
        ";\n  z-index: 1;\n  ",
        "\n\n  ",
        "\n\n  > * {\n    direction: rtl;\n  }\n\n  ",
        " {\n    z-index: 999;\n  }\n"
    ]);
    ShopFooter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShopFooter_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 320px;\n  width: 320px;\n  border-radius: 5px;\n  box-shadow: 0px 4px 4px 0px #00000040, 0px -1px 4px 0px #00000014;\n  height: 91px;\n  background: ",
        ";\n\n  ",
        " {\n    position: fixed;\n    bottom: 1px;\n    margin-bottom: 10px;\n    width: calc(100% - 32px);\n    left: 16px;\n  }\n"
    ]);
    ShopFooter_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShopFooter_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 408px;\n  /* width: 408px; */\n"
    ]);
    ShopFooter_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var StyledShopFooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopFooter__StyledShopFooterContainer",
    componentId: "sc-2dd17057-0"
})(ShopFooter_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) === constants/* STEPS_EN.order */.Ws.order || (p === null || p === void 0 ? void 0 : p.$page) === constants/* STEPS_EN.payment */.Ws.payment ? "flex-end" : "space-between";
}, function(p) {
    return p.$isShowRoomsScreens && (0,styled_components_browser_esm/* css */.iv)(ShopFooter_templateObject());
}, function(p) {
    return p.$page === constants/* STEPS_EN.color */.Ws.color && "padding: 0 24px;";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledPriceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopFooter__StyledPriceContainer",
    componentId: "sc-2dd17057-1"
})(ShopFooter_templateObject2(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledPollutionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopFooter__StyledPollutionContainer",
    componentId: "sc-2dd17057-2"
})(ShopFooter_templateObject3());
var ShopFooter = function(param) {
    var hidePrice = param.hidePrice;
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var isShowRoomsScreens = (0,LayoutContext/* useLayoutContext */.l)().isShowRoomsScreens;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShopFooterContainer, {
        $page: pathname,
        $isShowRoomsScreens: isShowRoomsScreens,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPollutionContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pollutionAndSafety_PollutionAndSafety, {
                        invertColor: pathname === routes_0/* default.upholstery.path */.Z.upholstery.path
                    })
                })
            }),
            !hidePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(totalPrice_TotalPrice, {}),
                    (pathname === routes_0/* default.detailing.path */.Z.detailing.path || pathname === routes_0/* default.color.path */.Z.color.path || pathname === routes_0/* default.upholstery.path */.Z.upholstery.path || pathname === routes_0/* default.accessories.path */.Z.accessories.path) && /*#__PURE__*/ (0,jsx_runtime.jsx)(wizard_OutOfStockBanner, {
                        isColors: pathname === routes_0/* default.color.path */.Z.color.path
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ShopFooter_ShopFooter = (ShopFooter);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/ShopFooter/index.tsx


;// CONCATENATED MODULE: ./common/UnorderedList.tsx

function UnorderedList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 4px;\n\n  :before {\n    content: "";\n    width: 5px;\n    height: 5px;\n    background-color: ',
        ";\n    margin-left: 10px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    position: relative;\n    top: -1px;\n    order: -1;\n  }\n"
    ]);
    UnorderedList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledULItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "UnorderedList__StyledULItem",
    componentId: "sc-8760566-0"
})(UnorderedList_templateObject(), function(p) {
    return p.theme.colors.darkGrey;
});

;// CONCATENATED MODULE: ./components/shopFeatures/summary/LegalNotes.tsx

function LegalNotes_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  padding: 0;\n"
    ]);
    LegalNotes_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LegalNotes_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 20px;\n  letter-spacing: 0em;\n"
    ]);
    LegalNotes_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var notes = [
    'המחיר כולל מע"מ ואגרת רישוי',
    "התמונה להמחשה בלבד",
    "רכישת הרכב בכפוף לחתימה על הסכם הזמנה ותשלום המלא על פיה",
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "תוקף ההטבות למשך 7 ימי עסקים ומותנה בחתימה על",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                href: "/מאזדה_נספח_הזמנה_דוגמא.pdf",
                target: "_blank",
                color: "primary",
                children: "הסכם הזמנה"
            })
        ]
    }),
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "אחריות לרכב – כמפורט ב",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                href: "https://www.mazda.co.il/%D7%90%D7%97%D7%A8%D7%99%D7%95%D7%AA/%D7%A9%D7%99%D7%A8%D7%95%D7%AA",
                target: "_blank",
                color: "primary",
                children: "תנאי האחריות"
            })
        ]
    }), 
];
var StyledNotes = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "LegalNotes__StyledNotes",
    componentId: "sc-f5a3212b-0"
})(LegalNotes_templateObject());
var StyledNote = (0,styled_components_browser_esm/* default */.ZP)(StyledULItem).withConfig({
    displayName: "LegalNotes__StyledNote",
    componentId: "sc-f5a3212b-1"
})(LegalNotes_templateObject1(), constants/* Font.OENaPro */.Zx.OENaPro);
var LegalNotes = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNotes, {
        className: className,
        children: notes.map(function(note, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNote, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: note
                })
            }, i);
        })
    });
};
/* harmony default export */ var summary_LegalNotes = (LegalNotes);

// EXTERNAL MODULE: ./reusable/finance/CopyPopup.tsx
var CopyPopup = __webpack_require__(98105);
;// CONCATENATED MODULE: ./components/shopFeatures/summary/ShareButton.tsx



function ShareButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ShareButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShareButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 2px solid black;\n  padding: 8.25px 14px 8.25px 13px;\n  border-radius: 3px;\n"
    ]);
    ShareButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShareButton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 5px;\n  height: 14px;\n"
    ]);
    ShareButton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var ShareButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShareButton__ShareButtonContainer",
    componentId: "sc-90445db5-0"
})(ShareButton_templateObject());
var ShareButton_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "ShareButton__StyledButton",
    componentId: "sc-90445db5-1"
})(ShareButton_templateObject1());
var ShareIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: "/icons/share-icon.svg",
        className: className,
        alt: "שתפו את העמוד"
    });
};
var StyledShareIcon = (0,styled_components_browser_esm/* default */.ZP)(ShareIcon).withConfig({
    displayName: "ShareButton__StyledShareIcon",
    componentId: "sc-90445db5-2"
})(ShareButton_templateObject2());
var ShareButton = function(param) {
    var className = param.className;
    var ref, ref1;
    var ref2 = (0,react.useState)(""), link = ref2[0], setLink = ref2[1];
    var ref3 = (0,react.useState)(false), copyPopupOpen = ref3[0], setCopyPopupOpen = ref3[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var detailing = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedDetailingSelector */.YF);
    var color = (0,store/* useTypedSelector */.ix)(colorSelectors/* selectedColorSelector */.Q);
    var desktopCopyText = "אפשר להעתיק ולשלוח את הלינק ל-".concat(detailing === null || detailing === void 0 ? void 0 : (ref = detailing.details) === null || ref === void 0 ? void 0 : ref.modelName, " שלך\n    כדי להתייעץ עם אחרים או כדי לחזור אחר כך");
    var mobileCopyText = "הרכבתי לעצמי ".concat(detailing === null || detailing === void 0 ? void 0 : (ref1 = detailing.details) === null || ref1 === void 0 ? void 0 : ref1.modelName, ":");
    (0,react.useEffect)(function() {
        var ref;
        if (window && window.location) setLink(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
    });
    var mobileShare = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var ref, imageUrl, blob;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageUrl = (color === null || color === void 0 ? void 0 : color.details.images[MODEL_IMAGE_INDEX].imageUrl) || (detailing === null || detailing === void 0 ? void 0 : detailing.details.image.imageUrl);
                        return [
                            4,
                            fetch("".concat(imageUrl, "?width=600&bgcolor=white")).then(function(r) {
                                return r.blob();
                            })
                        ];
                    case 1:
                        blob = _state.sent();
                        console.log(blob);
                        navigator === null || navigator === void 0 ? void 0 : (ref = navigator.share) === null || ref === void 0 ? void 0 : ref.call(navigator, {
                            text: mobileCopyText,
                            url: link,
                            files: [
                                new File([
                                    blob
                                ], "model.png", {
                                    type: blob.type
                                })
                            ]
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function mobileShare() {
            return _ref.apply(this, arguments);
        };
    }();
    var openSharingPopup = function() {
        if (isDesktop) {
            setCopyPopupOpen(true);
        } else {
            mobileShare();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareButtonContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareButton_StyledButton, {
                variant: "outlined",
                onClick: function() {
                    return openSharingPopup();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShareIcon, {}),
                    "שיתוף"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyPopup["default"], {
                link: link,
                title: "להתייעץ ולהחליט בראש שקט",
                copyText: desktopCopyText,
                setCopyPopupOpen: setCopyPopupOpen,
                buttonText: "העתקת הלינק לשיתוף",
                copyPopupOpen: copyPopupOpen,
                customClose: function() {
                    setCopyPopupOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var summary_ShareButton = (ShareButton);

// EXTERNAL MODULE: ./components/shopFeatures/summary/SummaryGallery.tsx
var SummaryGallery = __webpack_require__(79542);
;// CONCATENATED MODULE: ./components/shopFeatures/summary/Disclaimer.tsx

function Disclaimer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n  p {\n    font-size: 18px;\n    font-weight: 300;\n  }\n"
    ]);
    Disclaimer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DisclaimerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Disclaimer__DisclaimerContainer",
    componentId: "sc-51c08d63-0"
})(Disclaimer_templateObject());
var Disclaimer = function() {
    var inStock = wizard_useInStock();
    if (!inStock) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_Typography/* default */.Z, {
            variant: "body2",
            color: "textSecondary",
            children: [
                "אנו שמחים להתקדם יחד! כדי שנוכל לשמור לך את ההצעה וההטבות, נדרש תשלום מקדמה. לאחר מכן ניצור איתך קשר על מנת להתקדם בעסקה. במידה ולא תושלם הרכישה, תוחזר לך המקדמה במלואה",
                " "
            ]
        })
    });
};
/* harmony default export */ var summary_Disclaimer = (Disclaimer);

// EXTERNAL MODULE: ./components/shopFeatures/auth/authSlice.ts
var authSlice = __webpack_require__(42210);
// EXTERNAL MODULE: ./common/postCallboxLead.ts
var common_postCallboxLead = __webpack_require__(43188);
;// CONCATENATED MODULE: ./components/shopFeatures/contact/ContactForm.tsx



function ContactForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n"
    ]);
    ContactForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 30px;\n"
    ]);
    ContactForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var ContactForm_StyledForm = (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Form).withConfig({
    displayName: "ContactForm__StyledForm",
    componentId: "sc-5b8e0ae4-0"
})(ContactForm_templateObject());
var ContactForm_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "ContactForm__StyledButton",
    componentId: "sc-5b8e0ae4-1"
})(ContactForm_templateObject1());
var ContactForm_schema = es/* object */.Ry({
    fullName: es/* string */.Z_().required("שדה חובה").max(50, "ניתן להזין עד 50 תווים").matches(/([a-zA-Zא-ת'"\\.-/,].+\s).+/, "שם מלא לא תקין"),
    phone: es/* string */.Z_().required("שדה חובה").matches(/^05\d-?\d{7}$/, "מספר נייד שגוי"),
    showRoom: es/* number */.Rx().positive("יש לבחור אולם תצוגה").defined(),
    agreeMarketingOffers: es/* boolean */.O7().defined()
}).defined();
var ContactForm_initialValues = {
    fullName: "",
    phone: "",
    showRoom: 0,
    agreeMarketingOffers: false
};
var ContactForm_ContactForm = function(param) {
    var onSubmit = param.onSubmit;
    var fullNameRef = useRef(null);
    var mobilePhoneRef = useRef(null);
    var termsRef = useRef(null);
    var fieldNameInputRefMap = useMemo(function() {
        return {
            fullName: fullNameRef,
            phone: mobilePhoneRef,
            terms: termsRef
        };
    }, []);
    var bagRef = useRef();
    var model = useTypedSelector(function(state) {
        return state.wizard;
    }).model;
    var ref = useTypedSelector(function(state) {
        return state.auth;
    }), registeredUserInfo = ref.userInfo;
    var isDesktop = useIsDesktop();
    useEffect(function() {
        var ref;
        if (!registeredUserInfo) return;
        (ref = bagRef.current) === null || ref === void 0 ? void 0 : ref.setValues({
            fullName: "".concat(registeredUserInfo.firstName, "  ").concat(registeredUserInfo.lastName),
            phone: registeredUserInfo.mobilePhone,
            showRoom: registeredUserInfo.showRoom,
            agreeMarketingOffers: false
        });
    }, [
        registeredUserInfo
    ]);
    return /*#__PURE__*/ _jsx(Formik, {
        innerRef: bagRef,
        validationSchema: ContactForm_schema,
        initialValues: ContactForm_initialValues,
        enableReinitialize: true,
        onSubmit: function() {
            var _ref = _async_to_generator(function(values) {
                var ref, ref1, utmValues, ref2, request, data, _body;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            utmValues = getUtmParamsAsKeyValueList();
                            request = {
                                fullName: values.fullName,
                                phone: values.phone,
                                description: "",
                                mediaChannelId: "",
                                branchId: values.showRoom,
                                modelId: (ref2 = model === null || model === void 0 ? void 0 : model.id) !== null && ref2 !== void 0 ? ref2 : null,
                                platform: isDesktop ? "Pc" : "Mobile",
                                isMailing: values.agreeMarketingOffers,
                                utmValues: utmValues,
                                emailAddress: (registeredUserInfo === null || registeredUserInfo === void 0 ? void 0 : registeredUserInfo.emailAddress) || "",
                                sid: (window === null || window === void 0 ? void 0 : (ref = window.__ctm) === null || ref === void 0 ? void 0 : (ref1 = ref.config) === null || ref1 === void 0 ? void 0 : ref1.sid) || "",
                                formName: "Mazda_meeting_form"
                            };
                            return [
                                4,
                                postContactEcommContact(request)
                            ];
                        case 1:
                            data = _state.sent().data;
                            postCallboxLead("contact", request);
                            if (data.body) {
                                trackCallMeBack();
                                trackPersonalDetails("ContactUs", (registeredUserInfo === null || registeredUserInfo === void 0 ? void 0 : registeredUserInfo.emailAddress) || "", values.phone, true);
                            }
                            // if error server return null, then return false
                            onSubmit((_body = data.body) !== null && _body !== void 0 ? _body : false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(param) {
            var isSubmitting = param.isSubmitting;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(UseFocusFirstInvalidField, {
                        fieldNameInputRefMap: fieldNameInputRefMap
                    }),
                    /*#__PURE__*/ _jsxs(ContactForm_StyledForm, {
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ _jsx(Field, {
                                name: "fullName",
                                component: TextField,
                                label: "שם מלא",
                                autoComplete: "name",
                                id: "name",
                                inputRef: fullNameRef,
                                required: true,
                                helperText: " " // prevent a "jump" when an error appears
                            }),
                            /*#__PURE__*/ _jsx(Field, {
                                name: "phone",
                                id: "phone",
                                component: TextField,
                                type: "tel",
                                label: "מספר נייד",
                                autoComplete: "tel-national",
                                required: true,
                                inputRef: mobilePhoneRef,
                                helperText: " " // prevent a "jump" when an error appears
                                ,
                                inputProps: {
                                    maxLength: 11
                                }
                            }),
                            /*#__PURE__*/ _jsx(ShowRoomSelect, {}),
                            /*#__PURE__*/ _jsx(FormikCheckboxField, {
                                inputRef: termsRef,
                                name: "agreeMarketingOffers",
                                label: 'הנני מאשר/ת קבלת פניות שיווקיות לדוא"ל, פקס, סמס מקבוצת דלק מוטורס ולהכלל במאגר המידע של הקבוצה'
                            }),
                            /*#__PURE__*/ _jsx(ContactForm_StyledButton, {
                                type: "submit",
                                variant: "contained",
                                color: "primary",
                                disabled: isSubmitting,
                                fullWidth: true,
                                children: "שליחה"
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var contact_ContactForm = ((/* unused pure expression or super */ null && (ContactForm_ContactForm)));

;// CONCATENATED MODULE: ./components/shopFeatures/contact/ContactDialog.tsx

function ContactDialog_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  text-align: center;\n  padding: 20px;\n  width: 100%;\n\n  ",
        " {\n    max-width: 470px;\n    padding: 20px 60px;\n  }\n"
    ]);
    ContactDialog_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactDialog_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: 30px;\n\n  ",
        " {\n    margin-top: 40px;\n  }\n"
    ]);
    ContactDialog_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ContactDialog_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactDialog__StyledContainer",
    componentId: "sc-65d01d25-0"
})(ContactDialog_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ContactDialog_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "ContactDialog__StyledButton",
    componentId: "sc-65d01d25-1"
})(ContactDialog_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ContactDialog_ContactDialog = function(param) {
    var open = param.open, onClose = param.onClose;
    var ref = useState(null), response = ref[0], setResponse = ref[1];
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onClose: onClose,
        "aria-label": "טופס חזרה טלפונית",
        TransitionProps: {
            onExited: function() {
                return setResponse(null);
            }
        },
        children: /*#__PURE__*/ _jsxs(ContactDialog_StyledContainer, {
            children: [
                /*#__PURE__*/ _jsx(CloseButton, {
                    onClick: onClose
                }),
                response === null && /*#__PURE__*/ _jsx(DialogTitle, {
                    children: "טופס חזרה טלפונית"
                }),
                /*#__PURE__*/ _jsx(DialogContent, {
                    children: response === null ? /*#__PURE__*/ _jsx(ContactForm, {
                        onSubmit: setResponse
                    }) : response ? /*#__PURE__*/ _jsx(Typography, {
                        variant: "h2",
                        children: "הטופס נשלח בהצלחה!"
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h2",
                                children: "שליחת הטופס נכשלה"
                            }),
                            /*#__PURE__*/ _jsx(ContactDialog_StyledButton, {
                                variant: "contained",
                                color: "primary",
                                onClick: function() {
                                    return setResponse(null);
                                },
                                children: "נסיון נוסף"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var contact_ContactDialog = ((/* unused pure expression or super */ null && (ContactDialog_ContactDialog)));

;// CONCATENATED MODULE: ./components/shopFeatures/summary/PurchaseButtonBox.tsx



function PurchaseButtonBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: 0 -5px 25px 0 rgba(0, 0, 0, 0.06);\n  flex-direction: column;\n  align-items: stretch;\n\n  ",
        " {\n    height: ",
        "px;\n  }\n\n  ",
        " {\n    height: ",
        "px;\n    box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 0.06);\n    border-top: none;\n    position: sticky;\n    bottom: -20px;\n    margin: 0px -20px -20px;\n  }\n\n  ",
        " {\n    position: fixed;\n    bottom: 0;\n    width: ",
        "px;\n    margin-bottom: 0;\n  }\n  ",
        " {\n    position: fixed;\n    bottom: 0;\n    width: ",
        "px;\n    margin-bottom: 0;\n  }\n"
    ]);
    PurchaseButtonBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PurchaseButtonBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  margin-top: 4px;\n  margin-bottom: -10px;\n  align-self: center;\n\n  :hover {\n    text-decoration: underline;\n  }\n"
    ]);
    PurchaseButtonBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var HEIGHT = 100;
var PurchaseButtonBox_StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container_StyledContainer).withConfig({
    displayName: "PurchaseButtonBox__StyledContainer",
    componentId: "sc-39ad86a3-0"
})(PurchaseButtonBox_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, HEIGHT, function(p) {
    return p.theme.breakpoints.up("md");
}, HEIGHT, MediaQueries/* IEMediaQuery */.bD, constants/* SIDEBAR_WIDTH */.ZR, MediaQueries/* EdgeMediaQuery */.vH, constants/* SIDEBAR_WIDTH */.ZR);
var StyledContactMeButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "PurchaseButtonBox__StyledContactMeButton",
    componentId: "sc-39ad86a3-1"
})(PurchaseButtonBox_templateObject1());
var PurchaseButtonBox = function() {
    var authenticated = useTypedSelector(function(state) {
        return state.auth;
    }).authenticated;
    var dispatch = useAppDispatch();
    var ref = useState(false), openContact = ref[0], setOpenContact = ref[1];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(PurchaseButtonBox_StyledContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                        variant: "outlined",
                        color: "primary"
                    }, authenticated ? {
                        component: Link,
                        to: routes.order.path
                    } : {
                        onClick: function() {
                            return dispatch(setOpen(true));
                        }
                    }), {
                        role: "link",
                        children: authenticated ? "לתשלום מקדמה" : "לחשיפת ההטבות"
                    })),
                    /*#__PURE__*/ _jsx(StyledContactMeButton, {
                        onClick: function() {
                            return setOpenContact(true);
                        },
                        children: "חזרו אליי טלפונית"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ContactDialog, {
                open: openContact,
                onClose: function() {
                    return setOpenContact(false);
                }
            })
        ]
    });
};
/* harmony default export */ var summary_PurchaseButtonBox = ((/* unused pure expression or super */ null && (PurchaseButtonBox)));

// EXTERNAL MODULE: ./components/Schedule/getIframeLink.ts
var getIframeLink = __webpack_require__(44039);
// EXTERNAL MODULE: ./components/carModelPage/popups/purchaseTools/PurchaseToolsRow.tsx
var PurchaseToolsRow = __webpack_require__(33041);
// EXTERNAL MODULE: ./components/carModelPage/popups/testDrive/TestDrivePopup.tsx + 2 modules
var TestDrivePopup = __webpack_require__(12821);
// EXTERNAL MODULE: ./reusable/finance/index.tsx + 6 modules
var finance = __webpack_require__(75181);
;// CONCATENATED MODULE: ./components/shopFeatures/summary/PurchaseTools.tsx



function PurchaseTools_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  overflow: auto;\n  width: 100%;\n"
    ]);
    PurchaseTools_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var PurchaseTools_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PurchaseTools__StyledWrapper",
    componentId: "sc-3a800bbd-0"
})(PurchaseTools_templateObject());
var PurchaseTools = function(param) {
    var className = param.className;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), popupOpen = ref4[0], setPopupOpen = ref4[1];
    var ref5 = (0,react.useState)(false), leadFormPopupOpen = ref5[0], setLeadFormPopupOpen = ref5[1];
    var ref6 = (0,react.useState)([]), showRoomList = ref6[0], setShowRoomList = ref6[1];
    var ref7 = (0,store/* useTypedSelector */.ix)(function(state) {
        return state;
    }), auth = ref7.auth, wizard = ref7.wizard;
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,api/* getShowroomAll */.jz)(null, null).then(api/* extractData */.Kj)
                            ];
                        case 1:
                            data = _state.sent();
                            setShowRoomList(data === null || data === void 0 ? void 0 : data.body);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData().catch(function(error) {
            return console.log(error);
        });
    }, []);
    var userInfo = auth.userInfo;
    if (!(wizard === null || wizard === void 0 ? void 0 : (ref = wizard.model) === null || ref === void 0 ? void 0 : ref.id)) return;
    var _model = wizard.model, modelId = _model.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PurchaseTools_StyledWrapper, {
                className: className || "",
                children: [
                    (0,getIframeLink/* isModelHasTestDriveIframe */.yz)(wizard.model.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        href: "/test-drive/".concat((wizard === null || wizard === void 0 ? void 0 : (ref1 = wizard.model) === null || ref1 === void 0 ? void 0 : ref1.id) || "1000"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                            text: "להזמנת נסיעת הדגמה",
                            iconName: "fi_calendar",
                            page: constants/* STEPS_EN.summary */.Ws.summary,
                            onClick: function() {
                                (0,analytics/* trackPopUpOpen */.W1)("showrooms meeting");
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                        text: "להזמנת נסיעת הדגמה",
                        iconName: "fi_calendar",
                        page: constants/* STEPS_EN.summary */.Ws.summary,
                        onClick: function() {
                            setLeadFormPopupOpen(true);
                            (0,analytics/* trackPopUpOpen */.W1)("showrooms meeting");
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                        text: "לקבל הצעת מימון",
                        iconName: "calculator",
                        page: constants/* STEPS_EN.summary */.Ws.summary,
                        onClick: function() {
                            // onClose()
                            setPopupOpen(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                            text: "לצ'אט עם נציג",
                            iconName: "fi_message-circle",
                            page: constants/* STEPS_EN.summary */.Ws.summary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TestDrivePopup/* default */.Z, {
                        open: leadFormPopupOpen,
                        onClose: function() {
                            setLeadFormPopupOpen(false);
                        },
                        formType: "test-drive",
                        showRoomsList: showRoomList,
                        dialogClass: "summaryTestDrive",
                        title: "תיאום נסיעת מבחן",
                        modelId: modelId,
                        userInfo: userInfo,
                        buttonText: "תאמו איתי נסיעת מבחן",
                        analyticName: "showrooms meeting",
                        isShop: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(finance["default"], {
                onlyClick: true,
                modelId: wizard === null || wizard === void 0 ? void 0 : (ref2 = wizard.model) === null || ref2 === void 0 ? void 0 : ref2.id,
                modelName: wizard === null || wizard === void 0 ? void 0 : (ref3 = wizard.model) === null || ref3 === void 0 ? void 0 : ref3.name,
                popupOpen: popupOpen,
                setPopupOpen: setPopupOpen
            })
        ]
    });
};
/* harmony default export */ var summary_PurchaseTools = (PurchaseTools);

// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./reusable/formsComp/FormErrorState.tsx + 1 modules
var FormErrorState = __webpack_require__(99763);
// EXTERNAL MODULE: ./reusable/formsComp/FormInput.tsx
var FormInput = __webpack_require__(77498);
// EXTERNAL MODULE: ./reusable/formsComp/FormSuccessState.tsx
var FormSuccessState = __webpack_require__(27047);
// EXTERNAL MODULE: ./reusable/popups/ClassicPopUp.tsx
var ClassicPopUp = __webpack_require__(66395);
// EXTERNAL MODULE: ./common/bit/form/FormikSchema.ts
var FormikSchema = __webpack_require__(46363);
;// CONCATENATED MODULE: ./components/carModelPage/popups/showrooms/SchemaSendEmail.ts


var schemaSendEmail = es/* object */.Ry({
    fullName: FormikSchema/* schemaCommon.fullName */.Cr.fullName,
    email: FormikSchema/* schemaCommon.email */.Cr.email,
    acceptTerms: es/* mixed */.nK().oneOf([
        true
    ], "שדה חובה")
}).defined();
var initialFormStatesSendWhatsapp = {
    fullName: "",
    email: "",
    acceptTerms: false
};
/* harmony default export */ var SchemaSendEmail = (schemaSendEmail);

;// CONCATENATED MODULE: ./components/carModelPage/popups/showrooms/SendMailPopup.tsx



function SendMailPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h2 {\n    font-size: 24px;\n  }\n"
    ]);
    SendMailPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SendMailPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n"
    ]);
    SendMailPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SendMailPopup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n"
    ]);
    SendMailPopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SendMailPopup_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-left: auto;\n"
    ]);
    SendMailPopup_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SendMailPopup_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n  gap: 2px;\n  ",
        " {\n    flex-direction: row;\n    column-gap: 16px;\n  }\n"
    ]);
    SendMailPopup_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SendMailPopup_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  margin: 0;\n  label[data-shrink="true"] {\n    transform: translate(-4px, 4px) scale(0.75);\n  }\n  legend {\n    width: 0;\n  }\n'
    ]);
    SendMailPopup_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SendMailPopup_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 320px;\n"
    ]);
    SendMailPopup_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SendMailPopup_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0px;\n  height: 45px;\n  background: ",
        ";\n  color: white;\n  :hover {\n    background: ",
        ";\n    outline: none;\n  }\n"
    ]);
    SendMailPopup_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}














var StyledClassicPopup = (0,styled_components_browser_esm/* default */.ZP)(ClassicPopUp/* default */.Z).withConfig({
    displayName: "SendMailPopup__StyledClassicPopup",
    componentId: "sc-90abfd2d-0"
})(SendMailPopup_templateObject());
var SendMailPopup_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SendMailPopup__StyledWrapper",
    componentId: "sc-90abfd2d-1"
})(SendMailPopup_templateObject1());
var StyledFormDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SendMailPopup__StyledFormDiv",
    componentId: "sc-90abfd2d-2"
})(SendMailPopup_templateObject2());
var StyledRequiredFields = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "SendMailPopup__StyledRequiredFields",
    componentId: "sc-90abfd2d-3"
})(SendMailPopup_templateObject3(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledRowCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SendMailPopup__StyledRowCol",
    componentId: "sc-90abfd2d-4"
})(SendMailPopup_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
    displayName: "SendMailPopup__StyledFormInput",
    componentId: "sc-90abfd2d-5"
})(SendMailPopup_templateObject5());
var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SendMailPopup__StyledWrap",
    componentId: "sc-90abfd2d-6"
})(SendMailPopup_templateObject6());
var SendMailPopup_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "SendMailPopup__StyledButton",
    componentId: "sc-90abfd2d-7"
})(SendMailPopup_templateObject7(), function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.black;
}, function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.steel;
});
var SendMailPopup_initialValues = {
    fullName: "",
    email: ""
};
var SendMailPopup = function(param) {
    var open = param.open, onClose = param.onClose;
    var ref = (0,react.useState)(TestDrivePopup/* FormStatus.Normal */.P.Normal), formStatus = ref[0], setFormStatus = ref[1];
    var selectedDetailingCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.detailing;
    }).selectedDetailingCode;
    var selectedColorCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    var selectedUpholsteryCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.upholstery;
    }).selectedUpholsteryCode;
    var selectedAccessoriesCodes = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.accessories;
    }).selectedAccessoriesCodes;
    (0,react.useEffect)(function() {
        if (open) {
            (0,analytics/* trackPopUpOpen */.W1)("showrooms_send_summery_email");
        }
        if (!open) {
            setFormStatus(TestDrivePopup/* FormStatus.Normal */.P.Normal);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClassicPopup, {
        open: open,
        onClose: onClose,
        title: formStatus === TestDrivePopup/* FormStatus.Success */.P.Success ? "שלחנו לך למייל את הקטלוג הדיגיטלי" : "שליחת הסיכום למייל שלך",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SendMailPopup_StyledWrapper, {
            children: [
                formStatus === TestDrivePopup/* FormStatus.Normal */.P.Normal && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
                    validationSchema: SchemaSendEmail,
                    initialValues: SendMailPopup_initialValues,
                    onSubmit: function() {
                        var _ref = (0,src_async_to_generator/* default */.Z)(function(values) {
                            var data, e;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            (0,api/* postEcommOrdersShareConfigurator */.YZ)({
                                                isMailing: false,
                                                firstName: values.fullName.split(" ")[0],
                                                lastName: values.fullName.split(" ")[1],
                                                email: values.email,
                                                shopLink: location.href.replace("showroomsscreens/", "shop/"),
                                                finishingLevelCode: selectedDetailingCode,
                                                colorCode: selectedColorCode,
                                                upholsteryCode: selectedUpholsteryCode,
                                                carExtraCodes: selectedAccessoriesCodes
                                            })
                                        ];
                                    case 1:
                                        data = _state.sent().data;
                                        if (data.body) {
                                            setFormStatus(TestDrivePopup/* FormStatus.Success */.P.Success);
                                        } else {
                                            setFormStatus(TestDrivePopup/* FormStatus.Error */.P.Error);
                                        }
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        setFormStatus(TestDrivePopup/* FormStatus.Error */.P.Error);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    render: function(formik) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormDiv, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequiredFields, {
                                    children: "* שדות חובה"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRowCol, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormInput, {
                                        name: "fullName",
                                        label: "שם מלא",
                                        required: true,
                                        autoComplete: "name",
                                        marginTop: 0
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRowCol, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormInput, {
                                        name: "email",
                                        label: "אימייל",
                                        required: true,
                                        autoComplete: "email",
                                        type: "email",
                                        marginTop: 0
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                                    children: "הסיכום ישלח לכתובת המייל. הפרטים האישיים לא ישמרו, לא יעשה בהם כל שימוש נוסף"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrap, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendMailPopup_StyledButton, {
                                        disabled: formik.isSubmitting,
                                        fullWidth: true,
                                        variant: "text",
                                        type: "submit",
                                        children: "שליחה"
                                    })
                                })
                            ]
                        });
                    }
                }),
                formStatus === TestDrivePopup/* FormStatus.Error */.P.Error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormErrorState/* default */.ZP, {}),
                formStatus === TestDrivePopup/* FormStatus.Success */.P.Success && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSuccessState/* default */.Z, {
                    title: "\xa0",
                    subtitle: "נציגנו ישמחו לעמוד לרשותך בכל שאלה בדרך למאזדה החדשה והמרגשת שלך"
                })
            ]
        })
    });
};
/* harmony default export */ var showrooms_SendMailPopup = (SendMailPopup);

// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./components/shopFeatures/summary/SendToMailButton.tsx

function SendToMailButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  inset: auto 30px 30px 30px;\n  width: auto;\n  position: absolute;\n"
    ]);
    SendToMailButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SendToMailButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 3px;\n  height: 45px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: ",
        ";\n  :hover {\n    background: #999;\n    border: 0;\n  }\n  border: ",
        ";\n"
    ]);
    SendToMailButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SendToMailButton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-family: ",
        ";\n  font-weight: 400;\n"
    ]);
    SendToMailButton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var SendToMailButton_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SendToMailButton__StyledContainer",
    componentId: "sc-cc185536-0"
})(SendToMailButton_templateObject());
var StyledFakeButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SendToMailButton__StyledFakeButton",
    componentId: "sc-cc185536-1"
})(SendToMailButton_templateObject1(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    var ref, ref1;
    return (p === null || p === void 0 ? void 0 : p.$dark) ? "none" : "2px solid ".concat(p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.black);
});
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).withConfig({
    displayName: "SendToMailButton__StyledTypography",
    componentId: "sc-cc185536-2"
})(SendToMailButton_templateObject2(), constants/* Font.OENaPro */.Zx.OENaPro);
var SendToMailButton = function() {
    var ref;
    var wizard = (0,store/* useTypedSelector */.ix)(function(state) {
        return state;
    }).wizard;
    var ref1 = (0,react.useState)(false), sendMailPopupOpen = ref1[0], setSendMailPopupOpen = ref1[1];
    if (!(wizard === null || wizard === void 0 ? void 0 : (ref = wizard.model) === null || ref === void 0 ? void 0 : ref.id)) return;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SendToMailButton_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFakeButton, {
                onClick: function() {
                    return setSendMailPopupOpen(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                    variant: "body2",
                    children: "שלחו לי את הסיכום למייל"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(showrooms_SendMailPopup, {
                open: sendMailPopupOpen,
                onClose: function() {
                    setSendMailPopupOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var summary_SendToMailButton = (SendToMailButton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var next_image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/shopFeatures/auth/OnlineBenefits/NumericBadge.tsx
"use client";

function NumericBadge_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 27px;\n  background-color: #4c607e;\n  overflow: hidden;\n  font-size: 12px;\n  color: #fff;\n  font-weight: 300;\n  white-space: nowrap;\n  text-align: center;\n  line-height: 1.3;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  user-select: none;\n"
    ]);
    NumericBadge_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Badge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "NumericBadge__Badge",
    componentId: "sc-b13b481e-0"
})(NumericBadge_templateObject());
var NumericBadge = function(param) {
    var number = param.number, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
        className: className,
        role: "status",
        "aria-label": "Count: ".concat(number),
        children: number
    });
};
/* harmony default export */ var OnlineBenefits_NumericBadge = (NumericBadge);

;// CONCATENATED MODULE: ./components/shopFeatures/auth/OnlineBenefits/OnlinePrices.tsx

function OnlinePrices_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n"
    ]);
    OnlinePrices_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OnlinePrices_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 1.3;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n"
    ]);
    OnlinePrices_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OnlinePrices_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 12px;\n      margin-right: auto;\n      text-decoration: line-through;\n    "
    ]);
    OnlinePrices_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OnlinePrices_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 10px;\n  letter-spacing: 0.64px;\n  color: ",
        ";\n  font-size: 16px;\n  direction: ltr;\n  ",
        "\n"
    ]);
    OnlinePrices_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OnlinePrices_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 12px;\n      margin-right: auto;\n      text-decoration: line-through;\n    "
    ]);
    OnlinePrices_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function OnlinePrices_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: ",
        "px;\n  direction: ltr;\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    OnlinePrices_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function OnlinePrices_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        font-weight: 600;\n        letter-spacing: 0.72px;\n      }\n\n      ",
        " {\n        font-weight: bold;\n        letter-spacing: 0.8px;\n      }\n    "
    ]);
    OnlinePrices_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function OnlinePrices_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        font-weight: 400;\n        color: black;\n        font-size: 20px;\n      }\n\n      ",
        " {\n        font-weight: 700;\n        color: black;\n        font-size: 24px;\n      }\n    "
    ]);
    OnlinePrices_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function OnlinePrices_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    OnlinePrices_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var OnlinePrices_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OnlinePrices__StyledContainer",
    componentId: "sc-b5b03ea1-0"
})(OnlinePrices_templateObject(), function(p) {
    return p.theme.spacing(1, 0);
});
var OnlinePrices_StyledLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "OnlinePrices__StyledLabel",
    componentId: "sc-b5b03ea1-1"
})(OnlinePrices_templateObject1());
var OnlinePrices_StyledPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "OnlinePrices__StyledPrice",
    componentId: "sc-b5b03ea1-2"
})(OnlinePrices_templateObject3(), function(p) {
    return p.theme.palette.text.primary;
}, function(p) {
    return p.original && (0,styled_components_browser_esm/* css */.iv)(OnlinePrices_templateObject2());
});
var StyledPrices = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "OnlinePrices__StyledPrices",
    componentId: "sc-b5b03ea1-3"
})(OnlinePrices_templateObject5(), function(p) {
    return p.theme.spacing(1);
}, function(p) {
    return p.original && (0,styled_components_browser_esm/* css */.iv)(OnlinePrices_templateObject4());
});
var OnlinePrices_StyledRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OnlinePrices__StyledRow",
    componentId: "sc-b5b03ea1-4"
})(OnlinePrices_templateObject8(), function(p) {
    return p.final && (0,styled_components_browser_esm/* css */.iv)(OnlinePrices_templateObject6(), OnlinePrices_StyledLabel, OnlinePrices_StyledPrice);
}, function(p) {
    return p.finalDiscount && (0,styled_components_browser_esm/* css */.iv)(OnlinePrices_templateObject7(), OnlinePrices_StyledLabel, OnlinePrices_StyledPrice);
});
var OnlinePrices = function(param) {
    var label = param.label, price = param.price, final = param.final, finalDiscount = param.finalDiscount, itemNumber = param.itemNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlinePrices_StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnlinePrices_StyledRow, {
            final: final,
            finalDiscount: finalDiscount,
            role: finalDiscount ? "alert" : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnlinePrices_StyledLabel, {
                    children: [
                        itemNumber !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineBenefits_NumericBadge, {
                            number: itemNumber
                        }),
                        label
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrices, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlinePrices_StyledPrice, {
                            "aria-label": "מחיר נוכחי",
                            children: formatPrice(typeof price === "object" ? price.totalPrice : price)
                        }),
                        typeof price === "object" && price.discount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlinePrices_StyledPrice, {
                            original: true,
                            "aria-label": "מחיר לפני ההנחה",
                            children: formatPrice(price.originalPrice)
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var OnlineBenefits_OnlinePrices = (OnlinePrices);

;// CONCATENATED MODULE: ./components/shopFeatures/auth/OnlineBenefits/OnlineBenefits.tsx



function OnlineBenefits_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  padding: 20px;\n  width: 100%;\n\n  ",
        " {\n    padding: 20px 50px;\n  }\n"
    ]);
    OnlineBenefits_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OnlineBenefits_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  text-align: center;\n"
    ]);
    OnlineBenefits_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OnlineBenefits_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: black;\n\n  :hover,\n  :active {\n    background: black;\n  }\n\n  :focus {\n    background: ",
        ";\n    color: white;\n    border: none;\n    outline: none;\n  }\n\n  ",
        " {\n    margin-top: 10px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    OnlineBenefits_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OnlineBenefits_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: ",
        ";\n  margin: ",
        ";\n  color: black;\n  margin: 15px 0;\n"
    ]);
    OnlineBenefits_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OnlineBenefits_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  line-height: 1;\n"
    ]);
    OnlineBenefits_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function OnlineBenefits_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    OnlineBenefits_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function OnlineBenefits_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 30px 0 0 0;\n"
    ]);
    OnlineBenefits_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}















var OnlineBenefits_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OnlineBenefits__StyledContainer",
    componentId: "sc-af490052-0"
})(OnlineBenefits_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var OnlineBenefits_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "OnlineBenefits__StyledTitle",
    componentId: "sc-af490052-1"
})(OnlineBenefits_templateObject1(), constants/* Font.OENaPro */.Zx.OENaPro);
var OnlineBenefits_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "OnlineBenefits__StyledButton",
    componentId: "sc-af490052-2"
})(OnlineBenefits_templateObject2(), function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.disable;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
// const StyledHeading = styled(Typography).attrs({
//   variant: "h2",
//   component: "h3",
// })`
//   font-family: ${Font.OENaPro};
//   font-size: 20px;
//   font-weight: 300;
//   line-height: 32px;
//   letter-spacing: 0.03em;
// `
var StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OnlineBenefits__StyledDivider",
    componentId: "sc-af490052-3"
})(OnlineBenefits_templateObject3(), function(p) {
    return p.theme.colors.lightGray;
}, function(p) {
    return p.theme.spacing(2, 0);
});
var StyledSubText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "OnlineBenefits__StyledSubText",
    componentId: "sc-af490052-4"
})(OnlineBenefits_templateObject4(), constants/* Font.OENaPro */.Zx.OENaPro);
var OnlineBenefits_StyledPriceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OnlineBenefits__StyledPriceContainer",
    componentId: "sc-af490052-5"
})(OnlineBenefits_templateObject5());
var StyledInfoSubText = (0,styled_components_browser_esm/* default */.ZP)(StyledSubText).withConfig({
    displayName: "OnlineBenefits__StyledInfoSubText",
    componentId: "sc-af490052-6"
})(OnlineBenefits_templateObject6());
var OnlineBenefits = function() {
    var ref;
    var detailing = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedDetailingSelector */.YF);
    var color = (0,store/* useTypedSelector */.ix)(colorSelectors/* selectedColorSelector */.Q);
    var upholstery = (0,store/* useTypedSelector */.ix)(upholsterySelectors/* selectedUpholsterySelector */._);
    var ref1 = (0,react.useState)(false), openDialog = ref1[0], setOpenDialog = ref1[1];
    var accessories = (0,store/* useTypedSelector */.ix)(accessoriesSelectors/* selectedAccessoriesSelector */.q);
    var ref2 = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }), licensingFee = ref2.licensingFee, price = ref2.price;
    var _ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state;
    }), _auth = _ref.auth, clientLoggedIn = _auth.clientLoggedIn, authenticated = _auth.authenticated, isDialogOpen = _ref.wizard.isDialogOpen, auth = (0,_object_without_properties/* default */.Z)(_ref.auth, [
        "clientLoggedIn",
        "authenticated"
    ]);
    var dispatch = (0,store/* useAppDispatch */.TL)();
    (0,react.useEffect)(function() {
        if (!clientLoggedIn || price && price.discount <= 0) return;
        setOpenDialog(true);
        dispatch((0,authSlice/* setClientLoggedIn */.QJ)(false));
    }, [
        clientLoggedIn,
        dispatch,
        price
    ]);
    var handleOnClose = function() {
        setOpenDialog(false);
        dispatch((0,wizardSlice/* setIsDialogOpen */.m1)(false));
    };
    if (!detailing || !licensingFee) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog_Dialog/* default */.Z, {
        open: openDialog || authenticated && isDialogOpen,
        onClose: handleOnClose,
        "aria-labelledby": "dialog-title",
        maxWidth: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnlineBenefits_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CloseButton/* default */.Z, {
                    onClick: handleOnClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnlineBenefits_StyledTitle, {
                    id: "dialog-title",
                    children: [
                        "היי ",
                        auth === null || auth === void 0 ? void 0 : (ref = auth.userInfo) === null || ref === void 0 ? void 0 : ref.firstName,
                        ","
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubText, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                            src: "/icons/Discount.svg",
                            alt: "Discount",
                            width: 17,
                            height: 17
                        }),
                        "קיבלת הטבות רכישה אונליין"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnlineBenefits_StyledPriceContainer, {
                    children: [
                        " ",
                        function() {
                            var _benefitItems;
                            // Build an array of benefit items to display
                            var benefitItems = [];
                            var itemCounter = 0;
                            // Add detailing item if it has a discount
                            if (detailing && detailing.price.discount > 0) {
                                benefitItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineBenefits_OnlinePrices, {
                                    itemNumber: ++itemCounter,
                                    label: "הנחה מיוחדת על סך ".concat(detailing.price.discount, " ₪"),
                                    price: -detailing.price.discount
                                }, "detailing"));
                            }
                            // Add color item if applicable
                            if (color && color.price.originalPrice > 0 && color.price.totalPrice != color.price.originalPrice) {
                                benefitItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineBenefits_OnlinePrices, {
                                    itemNumber: ++itemCounter,
                                    label: color.details.name,
                                    price: color.price
                                }, "color"));
                            }
                            // Add upholstery item if applicable
                            if (upholstery && upholstery.price.originalPrice > 0 && upholstery.price.totalPrice != upholstery.price.originalPrice) {
                                benefitItems.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineBenefits_OnlinePrices, {
                                    itemNumber: ++itemCounter,
                                    label: upholstery.details.name,
                                    price: upholstery.price
                                }, "upholstery"));
                            }
                            // Add accessory items
                            var accessoryItems = accessories.filter(function(accessory) {
                                return accessory.price.discount > 0;
                            }).map(function(accessory) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineBenefits_OnlinePrices, {
                                    itemNumber: ++itemCounter,
                                    label: accessory.details.name,
                                    price: accessory.price
                                }, accessory.details.code);
                            });
                            (_benefitItems = benefitItems).push.apply(_benefitItems, (0,_to_consumable_array/* default */.Z)(accessoryItems));
                            // Return all the items
                            return benefitItems;
                        }()
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
                price && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (price === null || price === void 0 ? void 0 : price.discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineBenefits_OnlinePrices, {
                        label: "סה״כ חיסכון ברכישה אונליין",
                        price: price === null || price === void 0 ? void 0 : price.discount,
                        finalDiscount: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInfoSubText, {
                    children: "ההטבה תישמר לך מרגע תשלום המקדמה באתר"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineBenefits_StyledButton, {
                    variant: "contained",
                    color: "primary",
                    onClick: handleOnClose,
                    children: "מעולה, תודה"
                })
            ]
        })
    });
};
/* harmony default export */ var OnlineBenefits_OnlineBenefits = (OnlineBenefits);

;// CONCATENATED MODULE: ./components/shopFeatures/summary/SummaryButtons.tsx

function SummaryButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  gap: 4px;\n\n  ",
        " {\n    gap: 8px;\n    position: fixed;\n    padding: 5px;\n    background: white;\n    border-radius: 5px;\n    width: calc(100% - 32px);\n    left: 16px;\n    bottom: 25px;\n    z-index: 999;\n    box-shadow: 0px -1px 4px 0px #00000014, 0px 4px 4px 0px #00000040;\n  }\n"
    ]);
    SummaryButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SummaryButtons_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 3px;\n  height: 45px;\n  width: 48%;\n  flex-grow: 1;\n\n  ",
        ' {\n    width: 50%;\n  }\n\n  &[class*="MuiButton-text"] {\n    padding: 0;\n  }\n'
    ]);
    SummaryButtons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SummaryButtons_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  border-radius: 3px;\n  height: 45px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border: ",
        ";\n"
    ]);
    SummaryButtons_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SummaryButtons_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-family: ",
        ";\n  font-weight: 400;\n  line-height: 1.1;\n"
    ]);
    SummaryButtons_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SummaryButtons_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 3px;\n  background: black;\n  color: white;\n  width: 100%;\n  height: 45px;\n  border: 0;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19.2px;\n  letter-spacing: 0.05em;\n  font-family: ",
        ";\n\n  :hover {\n    background: #999;\n    border: 0;\n  }\n"
    ]);
    SummaryButtons_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}















var SummaryButtons_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SummaryButtons__StyledContainer",
    componentId: "sc-f1156be2-0"
})(SummaryButtons_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledButtonBaseBlank = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "SummaryButtons__StyledButtonBaseBlank",
    componentId: "sc-f1156be2-1"
})(SummaryButtons_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var SummaryButtons_StyledFakeButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SummaryButtons__StyledFakeButton",
    componentId: "sc-f1156be2-2"
})(SummaryButtons_templateObject2(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$dark) && "background-color: ".concat(p.theme.colors.black, ";");
}, function(p) {
    var ref, ref1;
    return (p === null || p === void 0 ? void 0 : p.$dark) ? "none" : "2px solid ".concat(p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.black);
});
var SummaryButtons_StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).withConfig({
    displayName: "SummaryButtons__StyledTypography",
    componentId: "sc-f1156be2-3"
})(SummaryButtons_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro);
var SummaryButtons_StyledButtonLink = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).attrs({
    component: react_router_dom/* Link */.rU
}).withConfig({
    displayName: "SummaryButtons__StyledButtonLink",
    componentId: "sc-f1156be2-4"
})(SummaryButtons_templateObject4(), constants/* Font.OENaPro */.Zx.OENaPro);
var SummaryButtons = function(param) {
    var className = param.className;
    var ref;
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var ref1 = (0,store/* useTypedSelector */.ix)(function(state) {
        return state;
    }), auth = ref1.auth, wizard = ref1.wizard;
    var isInStock = wizard_useInStock();
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var activeStepIndex = routes_0/* default.array.findIndex */.Z.array.findIndex(function(r) {
        return r.path === pathname;
    });
    var nextStep = routes_0/* default.array */.Z.array[activeStepIndex + 1];
    var focusMain = (0,LayoutContext/* useLayoutContext */.l)().focusMain;
    if (!(wizard === null || wizard === void 0 ? void 0 : (ref = wizard.model) === null || ref === void 0 ? void 0 : ref.id)) return;
    var authenticated = auth.authenticated;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryButtons_StyledContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonBaseBlank, {
                onClick: function() {
                    !authenticated && dispatch((0,authSlice/* setOpen */.A_)(true));
                },
                children: [
                    authenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryButtons_StyledButtonLink, {
                        onClick: function() {
                            nextStep.path === routes_0/* default.summary.path */.Z.summary.path;
                            focusMain();
                        },
                        variant: "outlined",
                        color: "primary",
                        to: nextStep.path,
                        role: "link",
                        children: !isInStock ? "להשארת פרטים" : "להזמנה ותשלום מקדמה"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryButtons_StyledFakeButton, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryButtons_StyledTypography, {
                            variant: "body2",
                            onClick: function() {
                                if (authenticated) {
                                    nextStep.path === routes_0/* default.summary.path */.Z.summary.path;
                                }
                                dispatch((0,wizardSlice/* setIsDialogOpen */.m1)(true));
                            },
                            children: authenticated ? "להזמנה ותשלום מקדמה" : "להטבה בלעדית באתר"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlineBenefits_OnlineBenefits, {})
                ]
            }),
            !authenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: !isInStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/contact-us?subject=קניית רכב",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonBaseBlank, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryButtons_StyledFakeButton, {
                            $dark: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledRow */.N0, {
                                $fullWidth: true,
                                $justify: "center",
                                $gap: "4px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryButtons_StyledTypography, {
                                    variant: "body2",
                                    $color: colors/* default.white */.Z.white,
                                    children: "להשארת פרטים"
                                })
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonBaseBlank, {
                    onClick: function() {
                        !authenticated && dispatch((0,authSlice/* setOpen */.A_)(true));
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryButtons_StyledFakeButton, {
                        $dark: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryButtons_StyledTypography, {
                            variant: "body2",
                            $color: colors/* default.white */.Z.white,
                            onClick: function() {
                                if (authenticated) {
                                    nextStep.path === routes_0/* default.summary.path */.Z.summary.path;
                                }
                                dispatch((0,wizardSlice/* setIsDialogOpen */.m1)(true));
                            },
                            children: "להזמנה ותשלום מקדמה"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var summary_SummaryButtons = (SummaryButtons);

;// CONCATENATED MODULE: ./components/shopFeatures/summary/priceDetails/PriceDetail.tsx

function PriceDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  margin-bottom: 12px;\n"
    ]);
    PriceDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-weight: 400;\n          font-size: 18px;\n        "
    ]);
    PriceDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-weight: 400;\n        "
    ]);
    PriceDetail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-family: ",
        ";\n  font-weight: 300;\n  line-height: 1.4;\n  letter-spacing: 0em;\n  ",
        "\n  ",
        "\n"
    ]);
    PriceDetail_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-weight: 400;\n        "
    ]);
    PriceDetail_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 12px;\n      margin-right: auto;\n      text-decoration: line-through;\n    "
    ]);
    PriceDetail_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: ",
        "px;\n  letter-spacing: 0.64px;\n  color: ",
        ";\n  font-size: ",
        ";\n  direction: ltr;\n  ",
        "\n  ",
        "\n"
    ]);
    PriceDetail_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-weight: 400;\n        "
    ]);
    PriceDetail_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  ",
        "\n"
    ]);
    PriceDetail_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function PriceDetail_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  font-size: 10px;\n"
    ]);
    PriceDetail_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}





var PriceDetail_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PriceDetail__StyledContainer",
    componentId: "sc-5d73389b-0"
})(PriceDetail_templateObject(), function(p) {
    return p.theme.spacing(1, 0);
});
var PriceDetail_StyledLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PriceDetail__StyledLabel",
    componentId: "sc-5d73389b-1"
})(PriceDetail_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro, function(p) {
    return p.$final ? (0,styled_components_browser_esm/* css */.iv)(PriceDetail_templateObject1()) : "";
}, function(p) {
    return p.finalDiscount ? (0,styled_components_browser_esm/* css */.iv)(PriceDetail_templateObject2()) : "";
});
var PriceDetail_StyledPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PriceDetail__StyledPrice",
    componentId: "sc-5d73389b-2"
})(PriceDetail_templateObject6(), function(p) {
    return p.theme.spacing(1);
}, function(p) {
    return p.theme.palette.text.primary;
}, function(p) {
    return p.final ? "16px" : "14px";
}, function(p) {
    return p.finalDiscount || p.final ? (0,styled_components_browser_esm/* css */.iv)(PriceDetail_templateObject4()) : "";
}, function(p) {
    return p.original && (0,styled_components_browser_esm/* css */.iv)(PriceDetail_templateObject5());
});
var PriceDetail_StyledRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PriceDetail__StyledRow",
    componentId: "sc-5d73389b-3"
})(PriceDetail_templateObject8(), function(p) {
    return p.finalDiscount || p.final ? (0,styled_components_browser_esm/* css */.iv)(PriceDetail_templateObject7()) : "";
});
var PriceDetail_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_Typography/* default */.Z).attrs({
    variant: "h6",
    component: "h3"
}).withConfig({
    displayName: "PriceDetail__StyledTitle",
    componentId: "sc-5d73389b-4"
})(PriceDetail_templateObject9(), function(p) {
    return p.theme.spacing(1);
});
var PriceDetail = function(param) {
    var label = param.label, price = param.price, final = param.final, finalDiscount = param.finalDiscount, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceDetail_StyledContainer, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetail_StyledTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceDetail_StyledRow, {
                final: final,
                finalDiscount: finalDiscount,
                role: finalDiscount ? "alert" : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetail_StyledLabel, {
                        $final: final,
                        finalDiscount: finalDiscount,
                        children: label
                    }),
                    final && typeof price === "object" && price.discount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetail_StyledPrice, {
                        original: true,
                        title: "מחיר לפני ההנחה",
                        children: formatPrice(price.originalPrice)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetail_StyledPrice, {
                        title: "מחיר נוכחי",
                        final: final,
                        finalDiscount: finalDiscount,
                        children: formatPrice(typeof price === "object" ? price.totalPrice : price)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var priceDetails_PriceDetail = (PriceDetail);

;// CONCATENATED MODULE: ./components/shopFeatures/summary/priceDetails/PriceDetails.tsx

function PriceDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: ",
        ";\n  margin: ",
        ";\n"
    ]);
    PriceDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PriceDetails_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    min-width: 390px;\n  }\n"
    ]);
    PriceDetails_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PriceDetails_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 1.6;\n  letter-spacing: 0em;\n  margin: 0;\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n"
    ]);
    PriceDetails_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PriceDetails_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px;\n  background: ",
        ";\n"
    ]);
    PriceDetails_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var PriceDetails_StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PriceDetails__StyledDivider",
    componentId: "sc-f0b5a5dd-0"
})(PriceDetails_templateObject(), function(p) {
    return p.theme.colors.lightGray;
}, function(p) {
    return p.theme.spacing(2, 0, 4);
});
var PriceDetails_StyledPriceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PriceDetails__StyledPriceContainer",
    componentId: "sc-f0b5a5dd-1"
})(PriceDetails_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var PriceDetails_StyledHeading = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "PriceDetails__StyledHeading",
    componentId: "sc-f0b5a5dd-2"
})(PriceDetails_templateObject2(), constants/* Font.OENaPro */.Zx.OENaPro, function(p) {
    return p.theme.colors.lightGray;
});
var StyledContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PriceDetails__StyledContentContainer",
    componentId: "sc-f0b5a5dd-3"
})(PriceDetails_templateObject3(), function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.white;
});
var PriceDetails = function() {
    var ref, ref1, ref2;
    var detailing = (0,store/* useTypedSelector */.ix)(detailingSelectors/* selectedDetailingSelector */.YF);
    var color = (0,store/* useTypedSelector */.ix)(colorSelectors/* selectedColorSelector */.Q);
    var upholstery = (0,store/* useTypedSelector */.ix)(upholsterySelectors/* selectedUpholsterySelector */._);
    var accessories = (0,store/* useTypedSelector */.ix)(accessoriesSelectors/* selectedAccessoriesSelector */.q);
    // const { authenticated } = useTypedSelector((state) => state.auth)
    var ref3 = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }), licensingFee = ref3.licensingFee, price = ref3.price, advancePaymentAmount = ref3.advancePaymentAmount;
    var totalAccessoryDiscount = accessories.reduce(function(sum, acc) {
        return sum + acc.price.discount;
    }, 0);
    var totalColorDiscount = (color === null || color === void 0 ? void 0 : (ref = color.price) === null || ref === void 0 ? void 0 : ref.discount) || 0;
    var totalUpholsteryDiscount = (upholstery === null || upholstery === void 0 ? void 0 : (ref1 = upholstery.price) === null || ref1 === void 0 ? void 0 : ref1.discount) || 0;
    var onlineDiscount = (detailing === null || detailing === void 0 ? void 0 : (ref2 = detailing.price) === null || ref2 === void 0 ? void 0 : ref2.discount) || 0;
    var hasDiscount = totalAccessoryDiscount > 0 || totalColorDiscount > 0 || totalUpholsteryDiscount > 0 || onlineDiscount > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetails_StyledPriceContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContentContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetails_StyledHeading, {
                    children: "סיכום הזמנה"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(wizard_OutOfStockBanner, {
                    isSummery: true
                }),
                detailing && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                            label: "מחיר מחירון",
                            price: detailing.price.originalPrice
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                            label: detailing.details.name,
                            price: detailing.price,
                            title: "רמת גימור"
                        })
                    ]
                }),
                color && /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                    title: "צבע",
                    label: color.details.name,
                    price: color.price
                }),
                upholstery && /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                    title: "ריפוד",
                    label: upholstery.details.name,
                    price: upholstery.price
                }),
                accessories.map(function(accessory) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                        label: accessory.details.name,
                        price: accessory.price,
                        title: "אבזור"
                    }, accessory.details.code);
                }),
                (licensingFee === null || licensingFee === void 0 ? void 0 : licensingFee.totalPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                    label: "אגרת רישוי",
                    price: licensingFee.totalPrice
                }),
                hasDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetails_StyledDivider, {}),
                        totalColorDiscount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                            label: "הנחת צבע",
                            price: -totalColorDiscount
                        }),
                        totalUpholsteryDiscount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                            label: "הנחת ריפוד",
                            price: -totalUpholsteryDiscount
                        }),
                        totalAccessoryDiscount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                            label: "הנחת אביזר",
                            price: -totalAccessoryDiscount
                        }),
                        onlineDiscount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                            label: "הנחה בגין רכישה אונליין",
                            price: -onlineDiscount
                        })
                    ]
                }),
                (price === null || price === void 0 ? void 0 : price.discount) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetails_StyledDivider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                            label: "סה״כ חיסכון ברכישה אונליין",
                            price: -price.discount,
                            finalDiscount: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceDetails_StyledDivider, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                    label: "סה״כ מחיר מקדמה",
                    price: advancePaymentAmount,
                    finalDiscount: true
                }),
                price && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetail, {
                        label: "סה״כ לתשלום",
                        price: price,
                        final: true
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var priceDetails_PriceDetails = (PriceDetails);

;// CONCATENATED MODULE: ./components/shopFeatures/summary/SummarySidebar.tsx

function SummarySidebar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: calc(100% - ",
        "px);\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    padding-bottom: 30px;\n  }\n\n  // Keeping for historical purposes in case we need them later\n  // ",
        " {\n  //   padding-bottom: calc(\n  //     ",
        "px + ",
        "px\n  //   );\n  // }\n  // ",
        " {\n  //   padding-bottom: calc(\n  //     ",
        "px + ",
        "px\n  //   );\n  // }\n"
    ]);
    SummarySidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SummarySidebar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n"
    ]);
    SummarySidebar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SummarySidebar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n"
    ]);
    SummarySidebar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SummarySidebar_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0;\n"
    ]);
    SummarySidebar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SummarySidebar_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 10px;\n  margin-bottom: 30px;\n"
    ]);
    SummarySidebar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SummarySidebar_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n"
    ]);
    SummarySidebar_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

















var SummarySidebar_StyledContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SummarySidebar__StyledContentContainer",
    componentId: "sc-b8f0fbf5-0"
})(SummarySidebar_templateObject(), HEIGHT, function(p) {
    return p.theme.breakpoints.up("md");
}, MediaQueries/* IEMediaQuery */.bD, function(p) {
    return p.theme.spacing(2);
}, HEIGHT, MediaQueries/* EdgeMediaQuery */.vH, function(p) {
    return p.theme.spacing(2);
}, HEIGHT);
var StyledPurchaseTools = (0,styled_components_browser_esm/* default */.ZP)(summary_PurchaseTools).withConfig({
    displayName: "SummarySidebar__StyledPurchaseTools",
    componentId: "sc-b8f0fbf5-1"
})(SummarySidebar_templateObject1());
var StyledShareButton = (0,styled_components_browser_esm/* default */.ZP)(summary_ShareButton).withConfig({
    displayName: "SummarySidebar__StyledShareButton",
    componentId: "sc-b8f0fbf5-2"
})(SummarySidebar_templateObject2());
var StyledSummaryGallery = (0,styled_components_browser_esm/* default */.ZP)(SummaryGallery/* default */.ZP).withConfig({
    displayName: "SummarySidebar__StyledSummaryGallery",
    componentId: "sc-b8f0fbf5-3"
})(SummarySidebar_templateObject3());
var StyledLegalNotes = (0,styled_components_browser_esm/* default */.ZP)(summary_LegalNotes).withConfig({
    displayName: "SummarySidebar__StyledLegalNotes",
    componentId: "sc-b8f0fbf5-4"
})(SummarySidebar_templateObject4());
var StyledSummaryButtons = (0,styled_components_browser_esm/* default */.ZP)(summary_SummaryButtons).withConfig({
    displayName: "SummarySidebar__StyledSummaryButtons",
    componentId: "sc-b8f0fbf5-5"
})(SummarySidebar_templateObject5());
var SummarySidebar = function() {
    useRedirectIfPreviousComponentsAreNotSelected();
    var isShowRoomsScreens = (0,LayoutContext/* useLayoutContext */.l)().isShowRoomsScreens;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummarySidebar_StyledContentContainer, {
            children: [
                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_Disclaimer, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetails, {}),
                        !isShowRoomsScreens && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSummaryButtons, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPurchaseTools, {})
                            ]
                        })
                    ]
                }),
                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ModelTitleAndImage, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShareButton, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_Disclaimer, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(priceDetails_PriceDetails, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_PurchaseTools, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSummaryGallery, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(detailing_SelectedDetailingDetails, {
                            hasBackground: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLegalNotes, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pollutionAndSafety_PollutionAndSafety, {
                            invertColor: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSummaryButtons, {})
                    ]
                }),
                isShowRoomsScreens && /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_SendToMailButton, {})
            ]
        })
    });
};
/* harmony default export */ var summary_SummarySidebar = (SummarySidebar);

;// CONCATENATED MODULE: ./components/shopFeatures/summary/SummaryPage.tsx

function SummaryPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 40px 0;\n"
    ]);
    SummaryPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SummaryPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  direction: ltr !important;\n"
    ]);
    SummaryPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SummaryPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 15px;\n\n  direction: rtl;\n"
    ]);
    SummaryPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SummaryPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n"
    ]);
    SummaryPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var SummaryPage_StyledLegalNotes = (0,styled_components_browser_esm/* default */.ZP)(summary_LegalNotes).withConfig({
    displayName: "SummaryPage__StyledLegalNotes",
    componentId: "sc-66ebe3d0-0"
})(SummaryPage_templateObject());
var StyledShareContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SummaryPage__StyledShareContainer",
    componentId: "sc-66ebe3d0-1"
})(SummaryPage_templateObject1());
var SummaryPage_StyledShareButton = (0,styled_components_browser_esm/* default */.ZP)(summary_ShareButton).withConfig({
    displayName: "SummaryPage__StyledShareButton",
    componentId: "sc-66ebe3d0-2"
})(SummaryPage_templateObject2());
var SummaryPage_StyledSummaryGallery = (0,styled_components_browser_esm/* default */.ZP)(SummaryGallery/* default */.ZP).withConfig({
    displayName: "SummaryPage__StyledSummaryGallery",
    componentId: "sc-66ebe3d0-3"
})(SummaryPage_templateObject3());
var SummaryPage = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var isShowRoomsScreens = (0,LayoutContext/* useLayoutContext */.l)().isShowRoomsScreens;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "srOnly",
                component: "h1",
                children: "סיכום"
            }),
            !isShowRoomsScreens && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShareContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryPage_StyledShareButton, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ModelTitleAndImage, {}),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_SummarySidebar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryPage_StyledSummaryGallery, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(detailing_SelectedDetailingDetails, {
                hasBackground: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryPage_StyledLegalNotes, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopFooter_ShopFooter, {
                hidePrice: true
            })
        ]
    });
};
/* harmony default export */ var summary_SummaryPage = (SummaryPage);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js + 7 modules
var Tabs = __webpack_require__(57821);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(38579);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(53557);
;// CONCATENATED MODULE: ./components/shopFeatures/wizard/stepsNav/Steps.tsx

function Steps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  z-index: 1;\n  ",
        " {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  ",
        " {\n    position: fixed;\n    width: 100%;\n  }\n"
    ]);
    Steps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Steps_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    max-width: 450px;\n    margin: 0 auto;\n  }\n"
    ]);
    Steps_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Steps_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  color: ",
        ";\n  letter-spacing: 0.5px;\n  text-decoration: none;\n  min-width: 40px;\n\n  &.MuiTab-root-12 {\n    padding: 6px 0;\n  }\n\n  ",
        " {\n    min-width: 60px;\n  }\n\n  ",
        " {\n    &.MuiTab-root-46,\n    &.MuiTab-root-960 {\n      padding: 6px 0;\n    }\n  }\n\n  &.active {\n    font-weight: bold;\n    color: ",
        ";\n  }\n"
    ]);
    Steps_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Steps_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  ",
        "\n"
    ]);
    Steps_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Steps_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  color: ",
        ";\n"
    ]);
    Steps_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Steps_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  color: ",
        ";\n"
    ]);
    Steps_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Steps_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 1;\n\n  svg {\n    height: 11px;\n  }\n"
    ]);
    Steps_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Steps_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Steps_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}








var StyledTabsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Steps__StyledTabsContainer",
    componentId: "sc-6142cf76-0"
})(Steps_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTabs = (0,styled_components_browser_esm/* default */.ZP)(Tabs/* default */.Z).withConfig({
    displayName: "Steps__StyledTabs",
    componentId: "sc-6142cf76-1"
})(Steps_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledStepNavLink = (0,styled_components_browser_esm/* default */.ZP)(react_router_dom/* NavLink */.OL).withConfig({
    displayName: "Steps__StyledStepNavLink",
    componentId: "sc-6142cf76-2"
})(Steps_templateObject2(), function(p) {
    return p.hidden ? "none" : "flex";
}, function(p) {
    return p.theme.palette.text.secondary;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("md");
}, function(p) {
    return p.theme.palette.text.primary;
});
var StyledStepText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Steps__StyledStepText",
    componentId: "sc-6142cf76-3"
})(Steps_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro, function(p) {
    return p.$index === 0 && "min-width:56px;";
});
var StyledArrowForwardIosIcon = (0,styled_components_browser_esm/* default */.ZP)(ArrowForwardIos/* default */.Z).withConfig({
    displayName: "Steps__StyledArrowForwardIosIcon",
    componentId: "sc-6142cf76-4"
})(Steps_templateObject4(), function(p) {
    return p.theme.palette.text.primary;
});
var StyledArrowBackIosIcon = (0,styled_components_browser_esm/* default */.ZP)(ArrowBackIos/* default */.Z).withConfig({
    displayName: "Steps__StyledArrowBackIosIcon",
    componentId: "sc-6142cf76-5"
})(Steps_templateObject5(), function(p) {
    return p.theme.palette.text.primary;
});
var StyledTab = (0,styled_components_browser_esm/* default */.ZP)(Tab/* default */.Z).withConfig({
    displayName: "Steps__StyledTab",
    componentId: "sc-6142cf76-6"
})(Steps_templateObject6());
var StyledNameTab = (0,styled_components_browser_esm/* default */.ZP)(Tab/* default */.Z).withConfig({
    displayName: "Steps__StyledNameTab",
    componentId: "sc-6142cf76-7"
})(Steps_templateObject7());
var Steps = function() {
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var activeStepIndex = routes_0/* default.array.findIndex */.Z.array.findIndex(function(r) {
        return r.path === pathname;
    });
    var countActiveSteps = routes_0/* default.array.reduce */.Z.array.reduce(function(a, b) {
        if (b.showStep) return a + 1;
        return a;
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabsContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabs, {
            value: pathname === "/" ? routes_0/* default.array.0.path */.Z.array[0].path : pathname,
            "aria-label": "תפריט ניווט של שלבי הרכבת רכב",
            indicatorColor: "primary",
            variant: "fullWidth",
            component: "nav",
            role: "navigation",
            TabIndicatorProps: {
                style: {
                    bottom: "8px"
                }
            },
            $page: pathname,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                    component: StyledStepNavLink,
                    to: activeStepIndex > 0 ? routes_0/* default.array */.Z.array[activeStepIndex - 1].path : routes_0/* default.array.0.path */.Z.array[0].path,
                    value: "back",
                    "aria-current": "step",
                    id: "steps-nav-tab-back-arrow",
                    "aria-controls": "steps-nav-tabpanel-forward-arrow",
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrowForwardIosIcon, {}),
                    disabled: activeStepIndex === 0
                }),
                routes_0/* default.array.map */.Z.array.map(function(route, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNameTab, {
                        component: StyledStepNavLink,
                        hidden: !route.showStep,
                        to: route.path,
                        value: route.path,
                        "aria-current": "step",
                        id: "steps-nav-tab-".concat(i),
                        "aria-controls": "steps-nav-tabpanel-".concat(i),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepText, {
                            $index: i,
                            children: constants/* STEPS_TEXT */.HZ[i]
                        }),
                        disabled: false,
                        tabIndex: 0
                    }, route.path);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTab, {
                    component: StyledStepNavLink,
                    to: activeStepIndex !== routes_0/* default.array.length */.Z.array.length - 1 ? routes_0/* default.array */.Z.array[activeStepIndex + 1].path : routes_0/* default.array */.Z.array[activeStepIndex].path,
                    value: "forwards",
                    "aria-current": "step",
                    id: "steps-nav-tab-left-arrow",
                    "aria-controls": "steps-nav-tabpanel-left-arrow",
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrowBackIosIcon, {}),
                    disabled: activeStepIndex === countActiveSteps - 1
                })
            ]
        })
    });
};
/* harmony default export */ var stepsNav_Steps = (Steps);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/Sidebar.tsx


function Sidebar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    background-color: ",
        ";\n    width: ",
        ";\n    flex-shrink: 0;\n    padding: 0;\n    // ",
        "\n    position: relative;\n\n    border-left: 1px solid ",
        ";\n    transition: width 0.5s ease;\n  }\n"
    ]);
    Sidebar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Sidebar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // height: 100%;\n  position: absolute;\n  inset: 0;\n  inset-block-start: ",
        ";\n\n  &.fade-enter {\n    opacity: 0;\n    transform: translateY(50px);\n    z-index: 1;\n  }\n\n  &.fade-enter-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: transform ease 300ms, opacity ease 300ms;\n  }\n\n  &.fade-exit {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  &.fade-exit-active {\n    opacity: 0;\n    transition: transform ease 300ms, opacity ease 300ms;\n    z-index: 1;\n  }\n"
    ]);
    Sidebar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Sidebar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n\n  direction: ltr;\n  > * {\n    direction: rtl;\n  }\n  overflow: auto;\n  height: 100%;\n"
    ]);
    Sidebar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var _obj;
var routesToComponents = (_obj = {}, (0,_define_property/* default */.Z)(_obj, routes_0/* default.detailing.path */.Z.detailing.path, detailing_DetailingSidebar), (0,_define_property/* default */.Z)(_obj, routes_0/* default.color.path */.Z.color.path, color_ColorSidebar), (0,_define_property/* default */.Z)(_obj, routes_0/* default.upholstery.path */.Z.upholstery.path, upholstery_UpholsterySidebar), (0,_define_property/* default */.Z)(_obj, routes_0/* default.accessories.path */.Z.accessories.path, accessories_AccessoriesSidebar), (0,_define_property/* default */.Z)(_obj, routes_0/* default.summary.path */.Z.summary.path, summary_SummaryPage), (0,_define_property/* default */.Z)(_obj, routes_0/* default.order.path */.Z.order.path, order_OrderPage), (0,_define_property/* default */.Z)(_obj, routes_0/* default.payment.path */.Z.payment.path, payment_PaymentPage), _obj);
var StyledSideContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Sidebar__StyledSideContent",
    componentId: "sc-5c1eef05-0"
})(Sidebar_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.$page === constants/* STEPS_EN.summary */.Ws.summary ? "calc(100% - ".concat(constants/* SIDEBAR_WIDTH */.ZR, "px)") : "".concat(constants/* SIDEBAR_WIDTH */.ZR, "px");
}, function(p) {
    return p.$page !== constants/* STEPS_EN.summary */.Ws.summary && "overflow: hidden;";
}, function(p) {
    return p.theme.colors.borderGrey;
});
var StyledTransitionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Sidebar__StyledTransitionWrapper",
    componentId: "sc-5c1eef05-1"
})(Sidebar_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== constants/* STEPS_EN.order */.Ws.order && (p === null || p === void 0 ? void 0 : p.$page) !== constants/* STEPS_EN.payment */.Ws.payment && "50px";
});
var ComponentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Sidebar__ComponentContainer",
    componentId: "sc-5c1eef05-2"
})(Sidebar_templateObject2(), function(p) {
    if ((p === null || p === void 0 ? void 0 : p.$page) === constants/* STEPS_EN.summary */.Ws.summary) return "55px 30px";
    return "0 30px 30px 30px";
});
var Sidebar = function() {
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSideContent, {
            $page: pathname,
            children: [
                pathname !== constants/* STEPS_EN.order */.Ws.order && pathname !== constants/* STEPS_EN.payment */.Ws.payment && /*#__PURE__*/ (0,jsx_runtime.jsx)(stepsNav_Steps, {}),
                routes_0/* default.array.map */.Z.array.map(function(route) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router/* Route */.AW, {
                        path: route.path,
                        children: function(param) {
                            var match = param.match;
                            var Component = routesToComponents[route.path];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                                in: match != null,
                                timeout: 300,
                                classNames: "fade",
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTransitionWrapper, {
                                    $page: pathname,
                                    id: "transitionwrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentContainer, {
                                        $page: pathname,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {})
                                    })
                                })
                            });
                        }
                    }, route.path);
                })
            ]
        })
    });
};
/* harmony default export */ var wizard_Sidebar = (Sidebar);

;// CONCATENATED MODULE: ./components/shopFeatures/accessories/AccessoriesPage.tsx





var AccessoriesPage = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopTitle, {
                    children: "הוספת אבזור"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(accessories_AccessoriesSidebar, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ModelTitleAndImage, {})
    });
};
/* harmony default export */ var accessories_AccessoriesPage = (AccessoriesPage);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./public/animation/shopLoader.json
var shopLoader_namespaceObject = JSON.parse('{"nm":"final","h":432,"w":768,"meta":{"g":"LottieFiles AE "},"layers":[{"ty":0,"nm":"applying r","sr":1,"st":0,"op":600,"ip":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[160,160,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[384,216,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"w":320,"h":320,"refId":"comp_0","ind":1},{"ty":0,"nm":"applying r","sr":1,"st":0,"op":600,"ip":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[160,160,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[384,239,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":38}},"ef":[{"ty":29,"nm":"Gaussian Blur","en":1,"ef":[{"ty":0,"nm":"Blurriness","v":{"a":0,"k":65.3}},{"ty":7,"nm":"Blur Dimensions","v":{"a":0,"k":1}},{"ty":7,"nm":"Repeat Edge Pixels","v":{"a":0,"k":0}}]}],"w":320,"h":320,"refId":"comp_0","ind":2}],"v":"4.8.0","fr":60,"op":480,"ip":0,"assets":[{"nm":"","id":"comp_0","layers":[{"ty":0,"nm":"one seq","sr":1,"st":0,"op":600,"ip":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[160,160,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":0},{"s":[900],"t":481}]},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"w":320,"h":320,"refId":"comp_1","ind":1}]},{"nm":"","id":"comp_1","layers":[{"ty":4,"nm":"04_dec","sr":1,"st":360,"op":480,"ip":420,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[75],"t":420},{"s":[75],"t":480}]},"o":{"a":0,"k":-270},"s":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":420},{"s":[75],"t":480}]},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":1},{"ty":4,"nm":"04_inc","sr":1,"st":360,"op":420,"ip":356,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":360},{"s":[75],"t":420}]},"o":{"a":0,"k":-270},"s":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":360},{"s":[0],"t":420}]},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":2},{"ty":4,"nm":"03_dec","sr":1,"st":240,"op":365,"ip":300,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[75],"t":300},{"s":[75],"t":360}]},"o":{"a":0,"k":-180},"s":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":300},{"s":[75],"t":360}]},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":3},{"ty":4,"nm":"03_inc","sr":1,"st":240,"op":301,"ip":236,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":240},{"s":[75],"t":300}]},"o":{"a":0,"k":-180},"s":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":240},{"s":[0],"t":300}]},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":4},{"ty":4,"nm":"02_dec","sr":1,"st":121,"op":246,"ip":180,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[75],"t":180},{"s":[75],"t":240}]},"o":{"a":0,"k":-90},"s":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":180},{"s":[75],"t":240}]},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":5},{"ty":4,"nm":"02_inc","sr":1,"st":121,"op":180,"ip":116,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":120},{"s":[75],"t":180}]},"o":{"a":0,"k":-90},"s":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":120},{"s":[0],"t":180}]},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":6},{"ty":4,"nm":"01_dec","sr":1,"st":0,"op":125,"ip":60,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[75],"t":60},{"s":[75],"t":120}]},"o":{"a":0,"k":0},"s":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":60},{"s":[75],"t":120}]},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":7},{"ty":4,"nm":"01_inc","sr":1,"st":0,"op":60,"ip":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":0},{"s":[75],"t":60}]},"o":{"a":0,"k":0},"s":{"a":1,"k":[{"o":{"x":0.85,"y":0},"i":{"x":0.15,"y":1},"s":[0],"t":0},{"s":[0],"t":60}]},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":8},{"ty":4,"nm":"01_inc 2","sr":1,"st":0,"op":486,"ip":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.547,16.547,0]},"s":{"a":0,"k":[100,100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[160,160,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":15}},"ef":[],"shapes":[{"ty":"gr","nm":"Ellipse 1","it":[{"ty":"el","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[177.094,177.094]}},{"ty":"tm","nm":"Trim Paths 1","e":{"a":0,"k":100},"o":{"a":0,"k":0},"s":{"a":0,"k":0},"m":1},{"ty":"st","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100},"w":{"a":0,"k":20},"c":{"a":0,"k":[0.569,0.039,0.177]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[10.547,16.547]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":9}]}]}');
;// CONCATENATED MODULE: ./reusable/ShopLoader.tsx

function ShopLoader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  inset: 0;\n  z-index: 5;\n  position: fixed;\n"
    ]);
    ShopLoader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShopLoader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  background-color: rgba(16, 16, 16, 0.4);\n  backdrop-filter: blur(5.5px);\n"
    ]);
    ShopLoader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShopLoader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 298px;\n  height: 167px;\n  ",
        " {\n    width: 500px;\n    height: 281px;\n  }\n"
    ]);
    ShopLoader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Lottie = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69260)
            ];
        }
    },
    ssr: false
});
var StyledLoaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopLoader__StyledLoaderWrapper",
    componentId: "sc-3707a2a6-0"
})(ShopLoader_templateObject());
var StyledbackDrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopLoader__StyledbackDrop",
    componentId: "sc-3707a2a6-1"
})(ShopLoader_templateObject1());
var StyledLottie = (0,styled_components_browser_esm/* default */.ZP)(Lottie).withConfig({
    displayName: "ShopLoader__StyledLottie",
    componentId: "sc-3707a2a6-2"
})(ShopLoader_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ShopLoader = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLoaderWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledbackDrop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLottie, {
                animationData: shopLoader_namespaceObject
            })
        ]
    });
};
/* harmony default export */ var reusable_ShopLoader = (ShopLoader);

;// CONCATENATED MODULE: ./components/shopFeatures/color/ThreeSixtyWrapper.tsx




function ThreeSixtyWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  overflow: hidden;\n  cursor: grab;\n  position: relative;\n  &:focus-visible {\n    :after {\n      // contact from aria-label\n      content: "',
        '";\n      position: absolute;\n      top: 0;\n      right: 0;\n      padding: 5px;\n      background: rgba(0, 0, 0, 0.8);\n      color: white;\n    }\n  }\n'
    ]);
    ThreeSixtyWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ThreeSixtyWrapper_StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(StyledModelImageContainer).withConfig({
    displayName: "ThreeSixtyWrapper__StyledContainer",
    componentId: "sc-8c558f29-0"
})(ThreeSixtyWrapper_templateObject(), function(p) {
    return p["data-a11y"];
});
// THIS ELEMENT IS REUSED IN BOTH SHOP AND MODEL PAGE !!!!
var ThreeSixtyWrapper = function(param) {
    var images = param.imageList, alt = param.alt, className = param.className, _enable = param.enable, enable = _enable === void 0 ? true : _enable, allEagerLoading = param.allEagerLoading, selectedColorCode = param.selectedColorCode;
    var ref = (0,react.useState)(true), loadingCirclr = ref[0], setLoadingCirclr = ref[1];
    var ref1 = (0,react.useState)(0), imagesLeftToLoad = ref1[0], setImagesLeftToLoad = ref1[1];
    var loading = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }).loading;
    var ref2 = (0,react.useState)([]), colorsFullyLoaded = ref2[0], setColorsFullyLoaded = ref2[1];
    var ref3 = (0,react.useState)(null), circlrInstance = ref3[0], setCirclrInstance = ref3[1];
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var imagesContainerRef = (0,react.useCallback)(function(node) {
        if (!node) return;
        __webpack_require__.e(/* import() */ 3672).then(__webpack_require__.t.bind(__webpack_require__, 53672, 23)).then(function(param) {
            var circlr = param.default;
            var circlrObj = circlr(node).scroll(true);
            setLoadingCirclr(false);
            setCirclrInstance(circlrObj);
        });
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        setImagesLeftToLoad((ref = images === null || images === void 0 ? void 0 : images.length) !== null && ref !== void 0 ? ref : 0);
        if (colorsFullyLoaded.includes(selectedColorCode)) return;
        dispatch((0,colorSlice/* setLoading */.K4)(true));
    }, [
        images,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (!loadingCirclr && imagesLeftToLoad === 0) {
            dispatch((0,colorSlice/* setLoading */.K4)(false));
            setColorsFullyLoaded(function(c) {
                return (0,_to_consumable_array/* default */.Z)(c).concat([
                    selectedColorCode
                ]);
            });
        }
    }, [
        loadingCirclr,
        imagesLeftToLoad,
        dispatch
    ]);
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var getImageProps = function(image, colorCode) {
        return isDesktop ? {
            src: "".concat(image, "?width=900&colorCode=").concat(colorCode)
        } : {
            src: "".concat(image, "?width=375&colorCode=").concat(colorCode),
            sizes: "100vw",
            srcSet: "".concat(image, "?width=375&colorCode=").concat(colorCode, " 1x,\n                   ").concat(image, "?width=750&colorCode=").concat(colorCode, " 2x,\n                   ").concat(image, "?width=1125&colorCode=").concat(colorCode, " 3x")
        };
    };
    if (!images || !selectedColorCode) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeSixtyWrapper_StyledContainer, {
                ref: imagesContainerRef,
                style: {
                    pointerEvents: loading || !enable ? "none" : "auto"
                },
                className: className,
                tabIndex: 0,
                role: "application",
                "data-a11y": "רכיב קרוסלת 360 מעלות. ניתן לשנות תמונה על ידי שימוש בחצי המקלדת ימינה ושמאלה",
                onKeyDown: function(e) {
                    if (e.key === "ArrowLeft") {
                        circlrInstance === null || circlrInstance === void 0 ? void 0 : circlrInstance.next();
                    } else if (e.key === "ArrowRight") {
                        circlrInstance === null || circlrInstance === void 0 ? void 0 : circlrInstance.prev();
                    }
                },
                children: images.map(function(image, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModelImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getImageProps(image, selectedColorCode)), {
                        style: {
                            visibility: i === 0 || !loading ? "visible" : "hidden"
                        },
                        onLoad: function() {
                            setImagesLeftToLoad(function(l) {
                                return l - 1;
                            });
                        },
                        onError: function() {
                            setImagesLeftToLoad(function(l) {
                                return l - 1;
                            });
                        },
                        alt: "".concat(alt, "=").concat(i),
                        loading: i === 0 || allEagerLoading ? "eager" : "lazy"
                    }), i);
                })
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(reusable_ShopLoader, {})
        ]
    });
};
/* harmony default export */ var color_ThreeSixtyWrapper = (ThreeSixtyWrapper);

;// CONCATENATED MODULE: ./components/shopFeatures/color/ColorPage.tsx


function ColorPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  align-self: stretch;\n  align-items: center;\n"
    ]);
    ColorPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ColorPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 27px;\n  right: calc(50% - 27px / 2);\n  ",
        " {\n    top: 90%;\n  }\n"
    ]);
    ColorPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var totalFrames = 24;
var ColorPage_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ColorPage__StyledContainer",
    componentId: "sc-824b1791-0"
})(ColorPage_templateObject());
var ColorPage_StyledThreeSixtyIcon = (0,styled_components_browser_esm/* default */.ZP)(color_ThreeSixtyIcon).withConfig({
    displayName: "ColorPage__StyledThreeSixtyIcon",
    componentId: "sc-824b1791-1"
})(ColorPage_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var ColorPage = function(param) {
    var _hideColorSidebar = param.hideColorSidebar, hideColorSidebar = _hideColorSidebar === void 0 ? false : _hideColorSidebar, _show360IconOnMobile = param.show360IconOnMobile, show360IconOnMobile = _show360IconOnMobile === void 0 ? false : _show360IconOnMobile;
    var ref;
    var selectedColor = (0,store/* useTypedSelector */.ix)(colorSelectors/* selectedColorSelector */.Q);
    var colors = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }).colors;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var images = (0,react.useMemo)(function() {
        if (!selectedColor) return;
        dispatch((0,colorSlice/* setLoading */.K4)(false));
        var _images = selectedColor.details.images.map(function(i) {
            return i.imageUrl;
        });
        return _images.length === totalFrames ? _images : (0,_to_consumable_array/* default */.Z)(_images).concat((0,_to_consumable_array/* default */.Z)(Array(totalFrames - _images.length).fill(_images[0])));
    }, [
        selectedColor
    ]);
    // On mount, if there's no selected color, select the first one
    (0,react.useEffect)(function() {
        if (selectedColor || colors.length === 0) return;
        dispatch((0,colorSlice/* setSelectedColor */.El)(colors[0].details.code));
    }, [
        selectedColor,
        dispatch,
        colors
    ]);
    if (!selectedColor) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColorPage_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ModelAndDetailing, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(color_ThreeSixtyWrapper, {
                imageList: images,
                selectedColorCode: selectedColor === null || selectedColor === void 0 ? void 0 : (ref = selectedColor.details) === null || ref === void 0 ? void 0 : ref.code,
                allEagerLoading: true
            }),
            !isDesktop && !hideColorSidebar && /*#__PURE__*/ (0,jsx_runtime.jsx)(color_ColorSidebar, {}),
            (isDesktop || show360IconOnMobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPage_StyledThreeSixtyIcon, {})
        ]
    });
};
/* harmony default export */ var color_ColorPage = (ColorPage);

;// CONCATENATED MODULE: ./components/shopFeatures/detailing/DetailingPage.tsx







var DetailingPage = function() {
    var model = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).model;
    (0,react.useEffect)(function() {
        if (!model) return;
        (0,analytics/* trackDetail */.jg)(model.name, model.id);
    }, [
        model
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(color_ColorPage, {
                hideColorSidebar: true,
                show360IconOnMobile: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detailing_DetailingSidebar, {})
            })
        ]
    });
};
/* harmony default export */ var detailing_DetailingPage = (DetailingPage);

// EXTERNAL MODULE: ./node_modules/react-pannellum/dist/index.js
var dist = __webpack_require__(45819);
;// CONCATENATED MODULE: ./components/shopFeatures/upholstery/Panorama.tsx



function Panorama_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  width: auto;\n\n  .pnlm-container {\n    background: #fff !important;\n    :focus-visible {\n      outline: 3px solid ",
        ';\n      :after {\n        // contact from aria-label\n        content: "רכיב פנורמה, ניתן לנווט עם חצי המקלדת";\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 5px;\n        background: rgba(255, 255, 255, 0.9);\n        color: black;\n      }\n    }\n    .pnlm-panorama-info {\n      display: none !important;\n    }\n    .pnlm-load-box {\n      height: 100px;\n      visibility: hidden;\n      .pnlm-lmsg {\n        display: none;\n      }\n    }\n  }\n\n  .psv-loader {\n    color: ',
        ";\n    border-width: 3px;\n    width: 100px;\n    height: 100px;\n  }\n"
    ]);
    Panorama_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Panorama_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Panorama_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var StyledPanoramaWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Panorama__StyledPanoramaWrap",
    componentId: "sc-e6a2a6f8-0"
})(Panorama_templateObject(), function(p) {
    return p.theme.colors.red;
}, function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledShopLoader = (0,styled_components_browser_esm/* default */.ZP)(reusable_ShopLoader).withConfig({
    displayName: "Panorama__StyledShopLoader",
    componentId: "sc-e6a2a6f8-1"
})(Panorama_templateObject1());
var panoramaConfig = {
    autoLoad: true,
    showControls: false,
    showZoomCtrl: false,
    keyboardZoom: false,
    doubleClickZoom: false,
    mouseZoom: false,
    showFullscreenCtrl: false,
    avoidShowingBackground: true,
    uiText: {
        loadingLabel: "טוען...",
        bylineLabel: ""
    }
};
var Panorama = function(param) {
    var image = param.image;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,react.useState)(false), panoramaLoaded = ref[0], setPanoramaLoaded = ref[1];
    var ref1 = (0,react.useState)(100), zoomLevel = ref1[0], setZoomLevel = ref1[1];
    var ref2 = (0,react.useState)(true), loading = ref2[0], setLoading = ref2[1];
    // Update some options whenever the initial (or a different) window width is detected
    (0,react.useEffect)(function() {
        var // TODO: find better solution
        ref;
        if (!panoramaLoaded) return;
        var zoom = isDesktop ? 100 : 60;
        setZoomLevel(zoom);
        (0,dist/* setHfov */.CQ)(zoom);
        (ref = document.getElementById("first")) === null || ref === void 0 ? void 0 : ref.setAttribute("aria-labelledby", "panoramaLabel");
    }, [
        isDesktop,
        panoramaLoaded
    ]);
    // Update the image if the prop is changed and the initial image is loaded, to prevent multiple calls
    (0,react.useEffect)(function() {
        if (!panoramaLoaded) return;
        var currentScene = (0,dist/* getCurrentScene */.iA)();
        var ref = (0,dist/* getConfig */.iE)(), pitch = ref.pitch, yaw = ref.yaw;
        if (currentScene !== image) {
            (0,dist/* addScene */.PZ)(image, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, panoramaConfig), {
                imageSource: "".concat(image),
                hfov: zoomLevel
            }), function() {
                (0,dist/* loadScene */.ei)(image, pitch, yaw);
            });
        }
    }, [
        panoramaLoaded,
        image,
        zoomLevel
    ]);
    (0,react.useEffect)(function() {
        if (!panoramaLoaded) return;
        // Set loading to false initially when panorama is loaded
        setLoading(false);
        // Select the load box element
        var loadBox = document.querySelector(".pnlm-load-box");
        if (loadBox) {
            // Create a MutationObserver to watch for changes in the load box's attributes
            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.attributeName === "style") {
                        // Check the display style of the load box
                        var display = window.getComputedStyle(loadBox).display;
                        console.log(display);
                        // If the load box is visible, set loading to true, otherwise set it to false
                        if (display !== "none") {
                            setLoading(true);
                        } else {
                            setLoading(false);
                        }
                    }
                });
            });
            // Start observing the load box for attribute changes
            observer.observe(loadBox, {
                attributes: true
            });
            // Cleanup the observer when the component is unmounted or dependencies change
            return function() {
                observer.disconnect();
            };
        }
    }, [
        panoramaLoaded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPanoramaWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "srOnly",
                id: "panoramaLabel"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                id: "first",
                sceneId: image,
                imageSource: "".concat(image),
                config: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, panoramaConfig), {
                    pitch: -12,
                    yaw: -90
                }),
                style: {
                    width: "100%",
                    height: "100%"
                },
                onPanoramaLoaded: function() {
                    return setPanoramaLoaded(true);
                }
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShopLoader, {})
        ]
    });
};
/* harmony default export */ var upholstery_Panorama = (Panorama);

;// CONCATENATED MODULE: ./components/shopFeatures/upholstery/UpholsteryPage.tsx

function UpholsteryPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  margin: 0;\n  ",
        " {\n    // inset-block-start: 77px;\n    inset: 48px 0 315px 0;\n  }\n"
    ]);
    UpholsteryPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UpholsteryPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  top: calc(100% - 45px);\n  z-index: 1;\n  width: 100%;\n  pointer-events: none;\n"
    ]);
    UpholsteryPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UpholsteryPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 1;\n\n  ",
        " {\n    width: 50px;\n    top: 20px;\n    right: 5px;\n  }\n\n  ",
        " {\n    width: 67px;\n    bottom: 130px;\n    right: 27px;\n  }\n"
    ]);
    UpholsteryPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










// const StyledProgressContainer = styled.div`
//   width: 100%;
//   height: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `
// const Panorama = dynamic(() => import("./Panorama"), {
//   // eslint-disable-next-line react/display-name
//   loading: () => (
//     <StyledProgressContainer>
//       <CircularProgress size="50px" />
//     </StyledProgressContainer>
//   ),
// })
var StyledPageWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UpholsteryPage__StyledPageWrap",
    componentId: "sc-c4a9b15f-0"
})(UpholsteryPage_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledUpholsterySidebarWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UpholsteryPage__StyledUpholsterySidebarWrap",
    componentId: "sc-c4a9b15f-1"
})(UpholsteryPage_templateObject1());
var StyledPanoramaIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "UpholsteryPage__StyledPanoramaIcon",
    componentId: "sc-c4a9b15f-2"
})(UpholsteryPage_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var UpholsteryPage = function() {
    var ref;
    var selectedUpholstery = (0,store/* useTypedSelector */.ix)(upholsterySelectors/* selectedUpholsterySelector */._);
    var upholsteries = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.upholstery;
    }).upholsteries;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var dispatch = (0,store/* useAppDispatch */.TL)();
    // On mount, if there's no selected upholstery, select the first one
    (0,react.useEffect)(function() {
        if (selectedUpholstery || upholsteries.length === 0) return;
        dispatch((0,upholsterySlice/* setSelectedUpholstery */.Bv)(upholsteries[0].details.code));
    }, [
        selectedUpholstery,
        dispatch,
        upholsteries
    ]);
    if (!selectedUpholstery) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
                variant: "srOnly",
                id: "panoramaLabel",
                children: "רכיב פנורמה, ניתן לנווט עם חצי המקלדת"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(upholstery_Panorama, {
                image: (ref = selectedUpholstery.details.images[0]) === null || ref === void 0 ? void 0 : ref.imageUrl
            }),
            !isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUpholsterySidebarWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(upholstery_UpholsterySidebar, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPanoramaIcon, {
                        src: "/360-mobile.svg",
                        alt: "",
                        title: "רכיב 360, ניתן לסובב על ידי לחיצה ממושכת על המסך"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPanoramaIcon, {
                src: "/360-desktop.svg",
                alt: "",
                title: "רכיב 360, ניתן לסובב על ידי לחיצה ממושכת על המסך"
            })
        ]
    });
};
/* harmony default export */ var upholstery_UpholsteryPage = (UpholsteryPage);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/StepPage.tsx


function StepPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  height: 0;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  ",
        "\n\n  ",
        " {\n    background-color: ",
        ";\n    padding-bottom: 15px;\n    min-width: unset;\n    height: auto;\n    padding-bottom: 160px;\n  }\n\n  ",
        " {\n    min-width: 450px;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 10px;\n    padding-top: ",
        "px;\n    ",
        '\n\n    [role="tabpanel"] {\n      flex-grow: 0.9;\n      flex-basis: 0;\n    }\n  }\n'
    ]);
    StepPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StepPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n\n  ",
        " {\n    flex-grow: 1;\n    padding-top: 50px;\n  }\n\n  ",
        " {\n    ",
        "\n  }\n\n  &[hidden] {\n    display: none;\n  }\n"
    ]);
    StepPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





















var StepPage_obj;
var StepPage_routesToComponents = (StepPage_obj = {}, (0,_define_property/* default */.Z)(StepPage_obj, routes_0/* default.detailing.path */.Z.detailing.path, detailing_DetailingPage), (0,_define_property/* default */.Z)(StepPage_obj, routes_0/* default.color.path */.Z.color.path, color_ColorPage), (0,_define_property/* default */.Z)(StepPage_obj, routes_0/* default.upholstery.path */.Z.upholstery.path, upholstery_UpholsteryPage), (0,_define_property/* default */.Z)(StepPage_obj, routes_0/* default.accessories.path */.Z.accessories.path, accessories_AccessoriesPage), (0,_define_property/* default */.Z)(StepPage_obj, routes_0/* default.summary.path */.Z.summary.path, summary_SummarySidebar), (0,_define_property/* default */.Z)(StepPage_obj, routes_0/* default.order.path */.Z.order.path, function _OrderPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(order_OrderPage, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detailing_DetailingPage, {})
            })
        ]
    });
}), (0,_define_property/* default */.Z)(StepPage_obj, routes_0/* default.payment.path */.Z.payment.path, function _PaymentPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_PaymentPage, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detailing_DetailingPage, {})
            })
        ]
    });
}), StepPage_obj);
var StepPage_StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).attrs({
    maxWidth: false
}).withConfig({
    displayName: "StepPage__StyledContainer",
    componentId: "sc-52ab1627-0"
})(StepPage_templateObject(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) === constants/* STEPS_EN.color */.Ws.color && "padding-left: 0;\n  padding-right: 0;";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === constants/* STEPS_EN.summary */.Ws.summary ? "47" : "60";
}, function(p) {
    return p.$page === constants/* STEPS_EN.order */.Ws.order && "padding-top: 0;";
});
var StyledTabpanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StepPage__StyledTabpanel",
    componentId: "sc-52ab1627-1"
})(StepPage_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== constants/* STEPS_EN.summary */.Ws.summary && "align-items: center;";
});
var StepPage = function() {
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var model = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).model;
    var getShopFooter = function() {
        if (pathname === constants/* STEPS_EN.summary */.Ws.summary) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (pathname === constants/* STEPS_EN.order */.Ws.order || pathname === constants/* STEPS_EN.payment */.Ws.payment) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopFooter_ShopFooter, {
            hidePrice: true
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopFooter_ShopFooter, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepPage_StyledContainer, {
        $page: pathname,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router/* Route */.AW, {
                path: "/",
                exact: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
                    to: routes_0/* default.array.0.path */.Z.array[0].path
                })
            }),
            routes_0/* default.array.map */.Z.array.map(function(route, i) {
                var Component = StepPage_routesToComponents[route.path];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router/* Route */.AW, {
                    path: route.path,
                    children: function(param) {
                        var match = param.match;
                        return match && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabpanel, {
                            $page: pathname,
                            role: "tabpanel",
                            hidden: !match,
                            id: "steps-nav-tabpanel-".concat(i),
                            "aria-labelledby": "steps-nav-tab-".concat(i),
                            children: match && route.path === "/summary" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_SummarySidebar, {}) : route.path === "/order" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(order_OrderPage, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ModelTitleAndImage, {})
                                    })
                                ]
                            }) : route.path === "payment" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_PaymentPage, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(summary_SummaryPage, {})
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {})
                        });
                    }
                }, route.path);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaQueries/* Mobile */.ij, {
                children: [
                    (pathname === routes_0/* default.detailing.path */.Z.detailing.path || pathname === routes_0/* default.color.path */.Z.color.path || pathname === routes_0/* default.accessories.path */.Z.accessories.path) && /*#__PURE__*/ (0,jsx_runtime.jsx)(pollutionAndSafety_PollutionAndSafety, {
                        invertColor: pathname === routes_0/* default.upholstery.path */.Z.upholstery.path
                    }),
                    pathname !== constants/* STEPS_EN.upholstery */.Ws.upholstery && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                        modelName: model === null || model === void 0 ? void 0 : model.name,
                        id: model === null || model === void 0 ? void 0 : model.id,
                        page: "configurator",
                        pathname: pathname
                    })
                ]
            }),
            getShopFooter()
        ]
    });
};
/* harmony default export */ var wizard_StepPage = (StepPage);

;// CONCATENATED MODULE: ./components/shopFeatures/wizard/Wizard.tsx

function Wizard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: 0;\n\n  ",
        " {\n    flex-direction: row;\n    align-items: stretch;\n    position: relative;\n  }\n"
    ]);
    Wizard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Wizard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 116px;\n  height: 32px;\n  font-size: 16px;\n  border-radius: 3px;\n  border: 2px solid ",
        ";\n\n  z-index: 1;\n  background-color: ",
        ";\n  position: absolute;\n  top: 10px;\n  left: 10px;\n"
    ]);
    Wizard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Wizard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-top: 0;\n      "
    ]);
    Wizard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Wizard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n\n  ",
        " {\n    flex-grow: 1;\n    width: 0;\n    padding-top: ",
        "px;\n    ",
        "\n  }\n"
    ]);
    Wizard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


















var StyledContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Wizard__StyledContentWrap",
    componentId: "sc-5aaab092-0"
})(Wizard_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var Wizard_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
    displayName: "Wizard__StyledButton",
    componentId: "sc-5aaab092-1"
})(Wizard_templateObject1(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.lightGrey;
});
var StyledMainContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Wizard__StyledMainContent",
    componentId: "sc-5aaab092-2"
})(Wizard_templateObject3(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, constants/* STEPS_NAV_DESKTOP_HEIGHT */.xe, function(p) {
    return p.$isShowRoomsScreens && p.$page !== constants/* STEPS_EN.summary */.Ws.summary && (0,styled_components_browser_esm/* css */.iv)(Wizard_templateObject2());
});
var Wizard = function() {
    var model = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.wizard;
    }).model;
    var initialized = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }).initialized;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var shopUrl = (0,useShopUrl/* default */.Z)(model === null || model === void 0 ? void 0 : model.id);
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var isShowRoomsScreens = (0,LayoutContext/* useLayoutContext */.l)().isShowRoomsScreens;
    var history = (0,react_router/* useHistory */.k6)();
    var ref = (0,react.useState)(false), isClientSide = ref[0], setIsClientSide = ref[1];
    var goBackToStart = function() {
        history.push(routes_0/* default.detailing.path */.Z.detailing.path);
    };
    (0,react.useEffect)(function() {
        if (!shopUrl || !model) return;
        localStorage.setItem(constants/* CONTINUE_PURCHASE_LINK */.IW, shopUrl);
        localStorage.setItem(constants/* MODEL_NAME */.Pl, model === null || model === void 0 ? void 0 : model.name);
    }, [
        shopUrl,
        model
    ]);
    (0,react.useEffect)(function() {
        if (!model || !initialized) return;
        dispatch((0,wizardSlice/* initSelectedComponentsFromParams */.dz)(model.id.toString()));
        dispatch((0,wizardSlice/* fetchAdvancePaymentAmount */.r4)());
    }, [
        dispatch,
        model,
        initialized
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,wizardSlice/* setIsDesktop */.qm)(isDesktop));
    }, [
        isDesktop,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        setIsClientSide(true);
    }, []);
    if (!isClientSide) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
            theme: shopTheme/* default */.Z,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContentWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(wizard_Sidebar, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMainContent, {
                        $page: pathname,
                        $isShowRoomsScreens: isShowRoomsScreens,
                        children: [
                            pathname !== constants/* STEPS_EN.order */.Ws.order && isDesktop && !isShowRoomsScreens && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                                modelName: model === null || model === void 0 ? void 0 : model.name,
                                id: model === null || model === void 0 ? void 0 : model.id,
                                page: "configurator"
                            }),
                            isShowRoomsScreens && pathname !== constants/* STEPS_EN.detailing */.Ws.detailing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Wizard_StyledButton, {
                                onClick: goBackToStart,
                                children: "חזרה להתחלה"
                            }),
                            pathname !== constants/* STEPS_EN.order */.Ws.order && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stepsNav_Steps, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(wizard_StepPage, {})
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var wizard_Wizard = (Wizard);


/***/ }),

/***/ 31544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ selectedComponentsForAnalyticsSelector; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var components_shopFeatures_accessories_accessoriesSelectors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21933);
/* harmony import */ var components_shopFeatures_color_colorSelectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75222);
/* harmony import */ var components_shopFeatures_detailing_detailingSelectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78615);
/* harmony import */ var components_shopFeatures_upholstery_upholsterySelectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66402);





// export const selectedComponentsForAnalyticsSelector = createSelector<
//   RootState,
//   WizardState["model"],
//   WizardState["price"],
//   ReturnType<typeof selectedDetailingSelector>,
//   ReturnType<typeof selectedColorSelector>,
//   ReturnType<typeof selectedUpholsterySelector>,
//   ReturnType<typeof selectedAccessoriesSelector>,
//   SelectedComponentsForAnalytics | null
// >(
//   (state) => state.wizard.model,
//   (state) => state.wizard.price,
//   selectedDetailingSelector,
//   selectedColorSelector,
//   selectedUpholsterySelector,
//   selectedAccessoriesSelector,
//   (model, price, detailing, color, upholstery, accessories) => {
//     if (!model || !price || !detailing || !color || !upholstery) return null
//     return {
//       modelName: model.name,
//       modelId: model.id,
//       totalPrice: price.totalPrice,
//       detailingName: detailing.details.name,
//       colorName: color.details.name,
//       upholsteryName: upholstery.details.name,
//       accessories: accessories.map((accessory) => ({
//         name: accessory.details.name,
//         id: accessory.details.code,
//         price: accessory.price.totalPrice,
//       })),
//     }
//   }
// )
var selectedComponentsForAnalyticsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.wizard.model;
}, function(state) {
    return state.wizard.price;
}, components_shopFeatures_detailing_detailingSelectors__WEBPACK_IMPORTED_MODULE_2__/* .selectedDetailingSelector */ .YF, components_shopFeatures_color_colorSelectors__WEBPACK_IMPORTED_MODULE_1__/* .selectedColorSelector */ .Q, components_shopFeatures_upholstery_upholsterySelectors__WEBPACK_IMPORTED_MODULE_3__/* .selectedUpholsterySelector */ ._, components_shopFeatures_accessories_accessoriesSelectors__WEBPACK_IMPORTED_MODULE_0__/* .selectedAccessoriesSelector */ .q, function(model, price, detailing, color, upholstery, accessories) {
    if (!model || !price || !detailing || !color || !upholstery) return null;
    return {
        modelName: model.name,
        modelId: model.id,
        totalPrice: price.totalPrice,
        detailingName: detailing.details.name,
        colorName: color.details.name,
        upholsteryName: upholstery.details.name,
        accessories: accessories.map(function(accessory) {
            return {
                name: accessory.details.name,
                id: accessory.details.code,
                price: accessory.price.totalPrice
            };
        })
    };
});


/***/ }),

/***/ 32875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ LayoutProvider; },
/* harmony export */   "l": function() { return /* binding */ useLayoutContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var LayoutContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    focusMain: function() {},
    setMainRef: function() {},
    isShowRoomsScreens: false
});
var useLayoutContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(LayoutContext);
};
var LayoutProvider = function(param) {
    var children = param.children;
    var mainRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().pathname;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isShowRoomsScreens = ref[0], setIsShowRoomsScreens = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (pathname.includes("showroomsscreens")) {
            setIsShowRoomsScreens(true);
        } else {
            setIsShowRoomsScreens(false);
        }
    }, [
        pathname
    ]);
    var value = {
        focusMain: function() {
            var ref;
            return (ref = mainRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        },
        setMainRef: function(node) {
            return mainRef.current = node;
        },
        isShowRoomsScreens: isShowRoomsScreens
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LayoutContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 14682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShopLayout; }
});

// UNUSED EXPORTS: StyledMain

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(29525);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./common/CloseButton.tsx + 1 modules
var CloseButton = __webpack_require__(92217);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./store.ts + 2 modules
var store = __webpack_require__(13328);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./components/shopFeatures/auth/authSlice.ts
var authSlice = __webpack_require__(42210);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
;// CONCATENATED MODULE: ./components/shopFeatures/auth/otp/ChangeNumberAndSendAgainButtons.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 22px;\n  letter-spacing: 0em;\n  cursor: pointer;\n  text-decoration: underline;\n\n  ",
        "\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChangeNumberAndSendAgainButtons__StyledContainer",
    componentId: "sc-780c3b5c-0"
})(_templateObject(), function(p) {
    return p.theme.spacing(2);
});
var StyledButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChangeNumberAndSendAgainButtons__StyledButtonContainer",
    componentId: "sc-780c3b5c-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.black;
});
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "ChangeNumberAndSendAgainButtons__StyledLink",
    componentId: "sc-780c3b5c-2"
})(_templateObject2(), constants/* Font.OENaPro */.Zx.OENaPro, function(p) {
    return p.$disabled && "\n    color: ".concat(p.theme.colors.darkGrey, ";\n  ");
}, function(p) {
    return p.theme.colors.cherryRed;
});
var StyledOtherNumberLink = (0,styled_components_browser_esm/* default */.ZP)(StyledLink).withConfig({
    displayName: "ChangeNumberAndSendAgainButtons__StyledOtherNumberLink",
    componentId: "sc-780c3b5c-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.saphire;
});
var ChangeNumberAndSendAgainButtons = function(param) {
    var focusCodeInput = param.focusCodeInput;
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }), loading = ref.loading, allowSendingCodeAgain = ref.allowSendingCodeAgain;
    var dispatch = (0,store/* useAppDispatch */.TL)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonContainer, {
                children: [
                    "לא הגיע אלי,",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!allowSendingCodeAgain) return [
                                            2
                                        ];
                                        return [
                                            4,
                                            dispatch((0,authSlice/* generateVerificationCode */.SX)(undefined))
                                        ];
                                    case 1:
                                        _state.sent();
                                        focusCodeInput();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        "aria-pressed": loading || !allowSendingCodeAgain,
                        $disabled: loading || !allowSendingCodeAgain,
                        children: "שלחו שוב"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOtherNumberLink, {
                    onClick: function() {
                        return dispatch((0,authSlice/* backToPhoneStep */.wz)());
                    },
                    $disabled: loading,
                    children: "אני רוצה להתחבר עם נייד אחר"
                })
            })
        ]
    });
};
/* harmony default export */ var otp_ChangeNumberAndSendAgainButtons = (ChangeNumberAndSendAgainButtons);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
;// CONCATENATED MODULE: ./components/shopFeatures/auth/otp/CodeInput.tsx


function CodeInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  direction: ltr;\n  height: 45px;\n"
    ]);
    CodeInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CodeInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 45px;\n  margin: 0 10px;\n  max-width: calc(25% - ",
        "px);\n\n  input {\n    text-align: center;\n    height: 40px;\n    font-family: ",
        ";\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: 0em;\n    padding: 2px 0;\n  }\n"
    ]);
    CodeInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CodeInput_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CodeInput__StyledContainer",
    componentId: "sc-bbc30097-0"
})(CodeInput_templateObject());
var StyledTextField = (0,styled_components_browser_esm/* default */.ZP)(TextField/* default */.Z).withConfig({
    displayName: "CodeInput__StyledTextField",
    componentId: "sc-bbc30097-1"
})(CodeInput_templateObject1(), function(p) {
    return p.theme.spacing(1);
}, constants/* Font.MazdaType */.Zx.MazdaType);
var CodeInput = function(param, ref) {
    var length = param.length, disabled = param.disabled, onComplete = param.onComplete;
    var initialCode = (0,react.useMemo)(function() {
        return Array(length).fill("");
    }, [
        length
    ]);
    var _$ref = (0,react.useState)(initialCode), code = _$ref[0], setCode = _$ref[1];
    var inputsRef = (0,react.useRef)([]);
    var focusInputAt = function(index) {
        return inputsRef.current[index].focus();
    };
    var handleChange = function(value, index) {
        return setCode(function(code) {
            var newCode = (0,_to_consumable_array/* default */.Z)(code.slice(0, index)).concat([
                value
            ], (0,_to_consumable_array/* default */.Z)(code.slice(index + 1)));
            var codeStr = newCode.join("");
            // If the code is fully entered, then call the `onComplete` callback;
            // otherwise, if the changed input isn't empty and isn't the last one,
            // then focus the next one
            if (codeStr.length === length) {
                onComplete(codeStr);
            } else if (value && index < length - 1) {
                focusInputAt(index + 1);
            }
            return newCode;
        });
    };
    var handleBackspace = function(index) {
        // Do nothing for the first input and for non-empty inputs
        if (index === 0 || code[index] !== "") return;
        // Clear the previous digit/input
        setCode(function(code) {
            return (0,_to_consumable_array/* default */.Z)(code.slice(0, index - 1)).concat([
                ""
            ], (0,_to_consumable_array/* default */.Z)(code.slice(index)));
        });
        // Focus the previous input
        focusInputAt(index - 1);
    };
    (0,react.useImperativeHandle)(ref, function() {
        return {
            reset: function() {
                // Reset the code & clear the input
                setCode(initialCode);
                // Focus first input
                focusInputAt(0);
            },
            focus: function() {
                return focusInputAt(0);
            }
        };
    }, [
        initialCode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeInput_StyledContainer, {
        role: "group",
        "aria-label": "הזן קוד שנשלח אליך בסמס. הקוד בן 4 ספרות, תקף לדקה בלבד, בתום הדקה, באפשרותך ללחוץ על כפתור שליחה מחדש",
        "aria-describedby": errorId,
        children: code.map(function(digit, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextField, {
                type: "tel",
                inputProps: {
                    maxLength: 1,
                    "aria-label": "סיפרה ".concat(i + 1)
                },
                inputRef: function(el) {
                    return inputsRef.current[i] = el;
                },
                value: digit,
                onChange: function(event) {
                    return handleChange(event.target.value, i);
                },
                onKeyDown: function(event) {
                    return event.key === "Backspace" && handleBackspace(i);
                },
                onFocus: function(event) {
                    return event.target.select();
                },
                autoFocus: i === 0,
                disabled: disabled
            }, i);
        })
    });
};
/* harmony default export */ var otp_CodeInput = (/*#__PURE__*/(0,react.forwardRef)(CodeInput));

;// CONCATENATED MODULE: ./components/shopFeatures/auth/otp/CodeTimer.tsx

function CodeTimer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n  font-size: 1.125rem;\n\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: 0px;\n  text-align: center;\n"
    ]);
    CodeTimer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledTimer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CodeTimer__StyledTimer",
    componentId: "sc-a0524e67-0"
})(CodeTimer_templateObject(), function(p) {
    return p.theme.spacing(2);
}, constants/* Font.Heebo */.Zx.Heebo);
var CodeTimer = function(param) {
    var className = param.className;
    var ref = (0,react.useState)(-1), secondsLeft = ref[0], setSecondsLeft = ref[1];
    var codeExpirationInSeconds = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }).codeExpirationInSeconds;
    var dispatch = (0,store/* useAppDispatch */.TL)();
    // Update the seconds left when the code expiration changes (i.e when a new
    // code was sent)
    (0,react.useEffect)(function() {
        if (codeExpirationInSeconds) setSecondsLeft(codeExpirationInSeconds);
    }, [
        codeExpirationInSeconds
    ]);
    (0,react.useEffect)(function() {
        // If there are no seconds left then the user should be able to request to
        // send the code again
        if (secondsLeft === 0) {
            dispatch((0,authSlice/* setAllowSendingCodeAgain */.Ss)());
            return;
        }
        var timeout = setTimeout(function() {
            return setSecondsLeft(secondsLeft - 1);
        }, 1000);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        secondsLeft,
        dispatch
    ]);
    var minutes = "".concat(Math.floor(secondsLeft / 60)).padStart(2, "0");
    var seconds = "".concat(secondsLeft % 60).padStart(2, "0");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTimer, {
        className: className,
        children: [
            minutes,
            ":",
            seconds
        ]
    });
};
/* harmony default export */ var otp_CodeTimer = (CodeTimer);

;// CONCATENATED MODULE: ./components/shopFeatures/auth/otp/OTPForm.tsx



function OTPForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    OTPForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OTPForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center !important;\n  margin-top: 8px;\n"
    ]);
    OTPForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OTPForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 14px;\n"
    ]);
    OTPForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OTPForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 45px;\n  background: ",
        ";\n  color: ",
        " !important;\n  margin-top: 20px;\n  border: ",
        ";\n  :hover {\n    background: ",
        ";\n  }\n\n  &:active,\n  :focus {\n    background: black;\n    color: white;\n    border: none;\n    outline: none;\n  }\n"
    ]);
    OTPForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var OTPForm_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OTPForm__StyledContainer",
    componentId: "sc-aadac457-0"
})(OTPForm_templateObject());
var StyledError = (0,styled_components_browser_esm/* default */.ZP)(FormHelperText/* default */.Z).attrs({
    error: true
}).withConfig({
    displayName: "OTPForm__StyledError",
    componentId: "sc-aadac457-1"
})(OTPForm_templateObject1());
var StyledCodeTimer = (0,styled_components_browser_esm/* default */.ZP)(otp_CodeTimer).withConfig({
    displayName: "OTPForm__StyledCodeTimer",
    componentId: "sc-aadac457-2"
})(OTPForm_templateObject2());
var StyledSubmitButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "OTPForm__StyledSubmitButton",
    componentId: "sc-aadac457-3"
})(OTPForm_templateObject3(), function(p) {
    return p.$disabled ? "#999999" : "black";
}, function(p) {
    return p.$disabled ? "#101010" : "white";
}, function(p) {
    return p.$disabled && "none";
}, function(p) {
    return p.theme.colors.steel;
});
var errorId = "otp-error";
var OTPForm = function() {
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }), error = ref.error, loading = ref.loading;
    var ref1 = (0,react.useState)(true), isDisabled = ref1[0], setIsDisabled = ref1[1];
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var codeInputRef = (0,react.useRef)(null);
    // Reset the code when there's an error
    (0,react.useEffect)(function() {
        if (error) {
            var ref;
            (ref = codeInputRef.current) === null || ref === void 0 ? void 0 : ref.reset(), setIsDisabled(true);
        }
    }, [
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OTPForm_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(otp_CodeInput, {
                length: 4,
                onComplete: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setIsDisabled(false);
                                    return [
                                        4,
                                        dispatch((0,authSlice/* verifyUser */.A9)(code))
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(code) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                ref: codeInputRef,
                disabled: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledError, {
                role: "alert",
                id: errorId,
                children: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCodeTimer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(otp_ChangeNumberAndSendAgainButtons, {
                focusCodeInput: function() {
                    var ref, ref1;
                    return (ref = codeInputRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.focus) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubmitButton, {
                // onClick={() =>
                //   code.length === 0 && setEmptyError("אנא הזן את הקוד שנשלח")
                // }
                $disabled: isDisabled,
                disabled: isDisabled,
                children: "המשך"
            })
        ]
    });
};
/* harmony default export */ var otp_OTPForm = (OTPForm);

// EXTERNAL MODULE: ./common/UseFocusFirstInvalidField.tsx
var UseFocusFirstInvalidField = __webpack_require__(29267);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
// EXTERNAL MODULE: ./routes.ts
var routes = __webpack_require__(59086);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/shopFeatures/auth/phone/PhoneForm.tsx



function PhoneForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n  background: ",
        ";\n\n  height: 45px;\n  border-radius: 3px;\n  border: none;\n  color: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n    color: ",
        ";\n    border: none;\n  }\n\n  &:active,\n  :focus {\n    background: black;\n    color: white;\n    border: none;\n  }\n\n  &:disabled {\n    background: black;\n    outline: none;\n    border: none;\n    border-radius: 3px;\n  }\n"
    ]);
    PhoneForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PhoneForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > * input {\n    direction: rtl !important;\n    ::placeholder,\n    ::-webkit-input-placeholder {\n      color: rgba(97, 97, 97, 1);\n      opacity: 1;\n    }\n  }\n"
    ]);
    PhoneForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "PhoneForm__StyledButton",
    componentId: "sc-77e24db-0"
})(PhoneForm_templateObject(), function(p) {
    return p.theme.spacing(1);
}, function(p) {
    var ref, ref1;
    return p.$hasContent ? "black" : p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.darkGrey;
}, function(p) {
    return p.$hasContent ? "#fffff" : "#101010";
}, function(p) {
    return p.theme.colors.steel;
}, function(p) {
    return p.theme.colors.white;
});
var StyledField = (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
    displayName: "PhoneForm__StyledField",
    componentId: "sc-77e24db-1"
})(PhoneForm_templateObject1());
var schema = es/* object */.Ry({
    phone: es/* string */.Z_().required("יש להזין מספר נייד").matches(/^05\d?\d{7}$/, "מספר נייד שגוי")
}).defined();
var initialValues = {
    phone: ""
};
var PhoneForm = function() {
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }), loading = ref.loading, temporaryPhone = ref.temporaryPhone;
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var bagRef = (0,react.useRef)();
    var phoneRef = (0,react.useRef)(null);
    var fieldNameInputRefMap = (0,react.useMemo)(function() {
        return {
            phone: phoneRef
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if (temporaryPhone) (ref = bagRef.current) === null || ref === void 0 ? void 0 : ref.setFieldValue("phone", temporaryPhone);
    }, [
        temporaryPhone
    ]);
    (0,react.useEffect)(function() {
        if (location.hash === "#".concat(routes/* default.summary.path */.Z.summary.path)) (0,analytics/* trackCheckoutStep */.rT)("2");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.Formik, {
        validationSchema: schema,
        initialValues: initialValues,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                dispatch((0,authSlice/* generateVerificationCode */.SX)(values.phone))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }(),
        innerRef: bagRef,
        children: function(props) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UseFocusFirstInvalidField/* default */.Z, {
                        fieldNameInputRefMap: fieldNameInputRefMap
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm.Form, {
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledField, {
                                name: "phone",
                                id: "phone",
                                component: formik_material_ui_es6/* TextField */.nv,
                                type: "tel",
                                required: true,
                                autoComplete: "tel-national",
                                helperText: " " // prevent a "jump" when an error appears
                                ,
                                inputProps: {
                                    maxLength: 11,
                                    style: {
                                        direction: "ltr"
                                    }
                                },
                                inputRef: phoneRef,
                                placeholder: "טלפון נייד*",
                                onChange: function(e) {
                                    props.handleChange(e);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                fullWidth: true,
                                variant: "contained",
                                color: "primary",
                                type: "submit",
                                disabled: loading,
                                $hasContent: !!(props === null || props === void 0 ? void 0 : (ref = props.values) === null || ref === void 0 ? void 0 : ref.phone),
                                children: "שלחו לי קוד זיהוי בסמס"
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var phone_PhoneForm = (PhoneForm);

// EXTERNAL MODULE: ./common/FormikCheckboxField.tsx
var FormikCheckboxField = __webpack_require__(57123);
// EXTERNAL MODULE: ./common/bit/form/FormikSchema.ts
var FormikSchema = __webpack_require__(46363);
// EXTERNAL MODULE: ./reusable/formsComp/FormSelect.tsx + 1 modules
var FormSelect = __webpack_require__(83225);
;// CONCATENATED MODULE: ./components/shopFeatures/auth/register/RegisterForm.tsx

function RegisterForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        "px;\n  background: black;\n  height: 45px;\n  border-radius: 3px;\n\n  :hover {\n    background: ",
        ";\n    color: ",
        ";\n    outline: none;\n    border: none;\n  }\n"
    ]);
    RegisterForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegisterForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 16px;\n  letter-spacing: 0em;\n  color: ",
        ";\n"
    ]);
    RegisterForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RegisterForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 30px;\n\n  :first-child {\n    margin-top: 25px;\n  }\n"
    ]);
    RegisterForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RegisterForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiFormControlLabel-label {\n    font-family: ",
        ";\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: right;\n    padding-top: 6px;\n  }\n"
    ]);
    RegisterForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















var RegisterForm_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "RegisterForm__StyledButton",
    componentId: "sc-279ef24c-0"
})(RegisterForm_templateObject(), function(p) {
    return p.theme.spacing(3);
}, function(p) {
    return p.theme.colors.steel;
}, function(p) {
    return p.theme.colors.white;
});
var StyledInfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "RegisterForm__StyledInfoText",
    componentId: "sc-279ef24c-1"
})(RegisterForm_templateObject1(), constants/* Font.OENaPro */.Zx.OENaPro, function(p) {
    var ref, ref1;
    return p === null || p === void 0 ? void 0 : (ref = p.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.mazdaRed;
});
var RegisterForm_StyledField = (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
    displayName: "RegisterForm__StyledField",
    componentId: "sc-279ef24c-2"
})(RegisterForm_templateObject2());
var StyledFormikCheckboxField = (0,styled_components_browser_esm/* default */.ZP)(FormikCheckboxField/* default */.Z).withConfig({
    displayName: "RegisterForm__StyledFormikCheckboxField",
    componentId: "sc-279ef24c-3"
})(RegisterForm_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro);
var labelStyles = {
    fontFamily: "OENaPRo",
    fontSize: "12px",
    fontWeight: "300",
    lineHeight: "16px",
    letterSpacing: "0em",
    textAlign: "right"
};
var RegisterForm_initialValues = {
    firstName: "",
    lastName: "",
    showRoom: 0,
    agreeMarketingOffers: false
};
var RegisterForm_schema = es/* object */.Ry({
    firstName: es/* string */.Z_().required("יש להזין שם מלא").matches(FormikSchema/* regex.singleName */.Sz.singleName, "שם פרטי בבקשה"),
    lastName: es/* string */.Z_().required("יש להזין שם מלא").matches(FormikSchema/* regex.singleName */.Sz.singleName, "שם משפחה בבקשה"),
    showRoom: es/* number */.Rx().positive("יש לבחור אולם תצוגה").defined(),
    agreeMarketingOffers: es/* boolean */.O7().defined()
}).defined();
var RegisterForm = function() {
    var loading = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }).loading;
    var showRooms = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.showRooms;
    }).showRooms;
    var showRoomsOptions = (0,FormSelect/* toFormSelectOptions */.L)(showRooms, "id", "name");
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var firstNameRef = (0,react.useRef)(null);
    var lastNameRef = (0,react.useRef)(null);
    var showRoomRef = (0,react.useRef)(null);
    var fieldNameInputRefMap = (0,react.useMemo)(function() {
        return {
            firstName: firstNameRef,
            lastName: lastNameRef,
            showRoom: showRoomRef
        };
    }, []);
    (0,react.useEffect)(function() {
        if (location.hash === "#".concat(routes/* default.summary.path */.Z.summary.path)) (0,analytics/* trackCheckoutStep */.rT)("3");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.Formik, {
        validationSchema: RegisterForm_schema,
        initialValues: RegisterForm_initialValues,
        onSubmit: function(values) {
            return dispatch((0,authSlice/* register */.z2)({
                firstName: values.firstName,
                lastName: values.lastName,
                showRoom: values.showRoom,
                agreeMarketingOffers: values.agreeMarketingOffers
            }));
        },
        children: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UseFocusFirstInvalidField/* default */.Z, {
                        fieldNameInputRefMap: fieldNameInputRefMap
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInfoText, {
                        children: "*שדות חובה"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm.Form, {
                        noValidate: true,
                        "aria-label": "טופס הרשמה",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm_StyledField, {
                                name: "firstName",
                                id: "firstName",
                                component: formik_material_ui_es6/* TextField */.nv,
                                required: true,
                                autoComplete: "given-name",
                                helperText: " " // prevent a "jump" when an error appears
                                ,
                                inputRef: firstNameRef,
                                placeholder: "*שם פרטי",
                                placeholderTextColor: "red"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm_StyledField, {
                                name: "lastName",
                                id: "lastName",
                                component: formik_material_ui_es6/* TextField */.nv,
                                required: true,
                                autoComplete: "family-name",
                                helperText: " " // prevent a "jump" when an error appears
                                ,
                                inputRef: lastNameRef,
                                placeholder: "*שם משפחה"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                name: "showRoom",
                                id: "showRoom",
                                required: true,
                                label: "*אולם תצוגה מועדף",
                                placeholder: "*אולם תצוגה מועדף",
                                values: showRoomsOptions,
                                map: function(item) {
                                    return {
                                        id: item.id,
                                        name: item.name
                                    };
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormikCheckboxField, {
                                name: "agreeMarketingOffers",
                                label: "אני רוצה לקבל פניות ועדכונים במייל ו/או בווטסאפ ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד. ולהיכלל במאגר המידע של הקבוצה.",
                                labelStyles: labelStyles
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm_StyledButton, {
                                fullWidth: true,
                                variant: "contained",
                                color: "primary",
                                type: "submit",
                                disabled: loading,
                                title: "לחץ להרשמה או לחץ על מקש ESC לסגירת החלונית",
                                children: "סיום הרשמה"
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var register_RegisterForm = (RegisterForm);

;// CONCATENATED MODULE: ./components/shopFeatures/auth/AuthDialog.tsx

function AuthDialog_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: ",
        "px;\n  width: 328px;\n\n  :first-child {\n    padding-top: ",
        "px;\n  }\n\n  padding: 20px;\n"
    ]);
    AuthDialog_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AuthDialog_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 0;\n  margin-bottom: ",
        "px;\n\n  font-family: ",
        ";\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n"
    ]);
    AuthDialog_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AuthDialog_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 150%;\n  text-align: center;\n  margin-bottom: 20px;\n"
    ]);
    AuthDialog_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AuthDialog_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 22px;\n  letter-spacing: 0em;\n  text-align: center;\n"
    ]);
    AuthDialog_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 140%;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    .MuiDialog-paperWidthXs {\n      max-height: 100%;\n    }\n  }\n\n  ",
        " {\n    .MuiDialog-paperWidthXs {\n      max-height: 100%;\n      max-width: 328px;\n    }\n\n    .MuiDialog-scrollPaper {\n      align-items: flex-start;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











var StyledDialogContent = (0,styled_components_browser_esm/* default */.ZP)(DialogContent/* default */.Z).withConfig({
    displayName: "AuthDialog__StyledDialogContent",
    componentId: "sc-a3ae0001-0"
})(AuthDialog_templateObject(), function(p) {
    return p.theme.spacing(3);
}, function(p) {
    return p.theme.spacing(3);
});
var StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "AuthDialog__StyledHeading",
    componentId: "sc-a3ae0001-1"
})(AuthDialog_templateObject1(), function(p) {
    return p.theme.spacing(3.5);
}, constants/* Font.OENaPro */.Zx.OENaPro);
var StyledOTPMainText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "AuthDialog__StyledOTPMainText",
    componentId: "sc-a3ae0001-2"
})(AuthDialog_templateObject2(), constants/* Font.OENaPro */.Zx.OENaPro);
var StyledPhoneText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "AuthDialog__StyledPhoneText",
    componentId: "sc-a3ae0001-3"
})(AuthDialog_templateObject3(), constants/* Font.OENaPro */.Zx.OENaPro);
var StyledOTPSubText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "AuthDialog__StyledOTPSubText",
    componentId: "sc-a3ae0001-4"
})(_templateObject4(), constants/* Font.OENaPro */.Zx.OENaPro);
var StyledDialog = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z).withConfig({
    displayName: "AuthDialog__StyledDialog",
    componentId: "sc-a3ae0001-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.down("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var stepTitleMap = {
    Phone: "התחברות",
    OTP: "התחברות",
    Register: "הרשמה"
};
var formMap = {
    Phone: phone_PhoneForm,
    OTP: otp_OTPForm,
    Register: register_RegisterForm
};
var AuthDialog = function() {
    var ref = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.auth;
    }), open = ref.open, step = ref.step, temporaryPhone = ref.temporaryPhone;
    var dispatch = (0,store/* useAppDispatch */.TL)();
    var Content = formMap[step];
    var stepContentMap = {
        Phone: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPhoneText, {
            children: "כדי לצפות בהטבות ולהמשיך לרכישה אנחנו צריכים לזהות אותך באמצעות התחברות"
        }),
        OTP: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOTPMainText, {
                    children: [
                        "קוד הזדהות נשלח לנייד ",
                        temporaryPhone.slice(-4),
                        "•••••••"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOTPSubText, {
                    children: "הזינו כאן את הקוד שקיבלתם לנייד"
                })
            ]
        }),
        Register: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPhoneText, {
            children: "נראה שזו פעם ראשונה שלך אצלינו, טוב שבאת! צריכים כמה פרטים להרשמה."
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDialog, {
        open: open,
        onClose: function() {
            return dispatch((0,authSlice/* setOpen */.A_)(false));
        },
        "aria-label": "התחברות",
        maxWidth: "xs",
        disableRestoreFocus: true,
        classes: {
            paper: "authDialog"
        },
        style: {
            padding: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDialogContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                    onClick: function() {
                        return dispatch((0,authSlice/* setOpen */.A_)(false));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                    children: stepTitleMap[step]
                }),
                stepContentMap[step],
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {})
            ]
        })
    });
};
/* harmony default export */ var auth_AuthDialog = (AuthDialog);

// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./layout/oldLayout/LayoutContext.tsx
var LayoutContext = __webpack_require__(32875);
;// CONCATENATED MODULE: ./layout/oldLayout/ShopLayout.tsx


function ShopLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :root,\n  body,\n  #__next {\n    height: 100%;\n  }\n\n  #__next {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    ShopLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShopLayout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: -999px;\n  position: absolute;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  z-index: -999;\n\n  :focus,\n  :active {\n    color: ",
        ";\n    background-color: ",
        ";\n    left: auto;\n    top: auto;\n    width: 30%;\n    height: auto;\n    overflow: auto;\n    margin: 10px 35%;\n    padding: 5px;\n    border-radius: 15px;\n    border: 4px solid ",
        ";\n    text-align: center;\n    font-size: 1.2em;\n    z-index: 1200;\n  }\n"
    ]);
    ShopLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShopLayout_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  margin-top: ",
        "px;\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    ShopLayout_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(ShopLayout_templateObject());
var SkipMainLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "ShopLayout__SkipMainLink",
    componentId: "sc-ef2c8dba-0"
})(ShopLayout_templateObject1(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkBlack;
}, function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopLayout__StyledMain",
    componentId: "sc-ef2c8dba-1"
})(ShopLayout_templateObject2(), shared/* HEADER_ANIME_M */.yv, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$isShowRoomsScreens ? "0px" : "".concat(shared/* HEADER_ANIME_D */.oe, "px");
});
var Layout = function(param) {
    var children = param.children;
    var ref = (0,LayoutContext/* useLayoutContext */.l)(), focusMain = ref.focusMain, setMainRef = ref.setMainRef, isShowRoomsScreens = ref.isShowRoomsScreens;
    var mainRef = (0,react.useCallback)(function(node) {
        return setMainRef(node);
    }, [
        setMainRef
    ]);
    var selectedDetailingCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.detailing;
    }).selectedDetailingCode;
    var selectedColorCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipMainLink, {
                href: "",
                onClick: function(event) {
                    event.preventDefault();
                    focusMain();
                },
                children: "דלג לתוכן המרכזי"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMain, {
                $isShowRoomsScreens: isShowRoomsScreens,
                id: "mainTwo",
                tabIndex: -1,
                ref: mainRef,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_AuthDialog, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "product-id",
                "data-id": "".concat(selectedDetailingCode, "_").concat(selectedColorCode),
                style: {
                    display: "none"
                }
            })
        ]
    });
};
var _Layout = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContext/* LayoutProvider */.a, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var ShopLayout = (_Layout);


/***/ }),

/***/ 98105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(282);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var reusable_popups_PopUp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24184);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 150%;\n  text-align: center;\n  color: ",
        ";\n  margin: 0;\n\n  ",
        " {\n    font-size: 18px;\n    width: 75%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: black;\n  color: white;\n  border-radius: 3px;\n\n  &:hover {\n    color: white;\n    box-shadow: none;\n    background-color: #3a3d46;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var StyledCopyText = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "CopyPopup__StyledCopyText",
    componentId: "sc-4288eac1-0"
})(_templateObject(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledTextContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CopyPopup__StyledTextContainer",
    componentId: "sc-4288eac1-1"
})(_templateObject1());
var StyledCopyContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CopyPopup__StyledCopyContainer",
    componentId: "sc-4288eac1-2"
})(_templateObject2());
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "CopyPopup__StyledButton",
    componentId: "sc-4288eac1-3"
})(_templateObject3());
function CopyPopup(param) {
    var setCopyPopupOpen = param.setCopyPopupOpen, customClose = param.customClose, copyPopupOpen = param.copyPopupOpen, copyText = param.copyText, link = param.link, title = param.title, buttonText = param.buttonText;
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), success = ref[0], setSuccess = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(reusable_popups_PopUp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        header: title || "שיתוף ההצעה",
        setOpen: setCopyPopupOpen,
        customClose: function() {
            customClose();
            setSuccess(false);
        },
        open: copyPopupOpen,
        maxWidth: "sm",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCopyContainer, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTextContainer, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCopyText, {
                        children: copyText
                    })
                }),
                success ? "הקישור הועתק בהצלחה" : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                    size: "large",
                    onClick: function() {
                        if (isDesktop && (navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
                            navigator === null || navigator === void 0 ? void 0 : navigator.clipboard.writeText("".concat(link));
                            setSuccess(true);
                            return;
                        }
                    // Not needed anymore cause we added share on outside for mobile
                    // if (!isDesktop && navigator?.share) {
                    //   navigator?.share({ text: copyText, url: link })
                    //   setSuccess(true)
                    // }
                    },
                    startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: "/copyIcon.svg",
                        width: 12,
                        height: 13.3
                    }),
                    children: buttonText
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (CopyPopup);


/***/ }),

/***/ 24312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22038);






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].black */ .Z.black : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    var w = 24;
    var h = 24;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "22",
                    height: "22",
                    rx: "2",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "22",
                    height: "22",
                    rx: "2",
                    stroke: color,
                    strokeWidth: "2"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 70612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22038);






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].black */ .Z.black : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    var w = 24;
    var h = 24;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "23.5",
                height: "23.5",
                rx: "2.75",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.5 8L10.1667 16L6.5 12",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "23.5",
                height: "23.5",
                rx: "2.75",
                stroke: color,
                strokeWidth: "0.5"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 59086:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var detailing = {
    path: "/detailing",
    title: "רמת גימור",
    showStep: true
};
var color = {
    path: "/color",
    title: "צבע",
    showStep: true
};
var upholstery = {
    path: "/upholstery",
    title: "ריפוד",
    showStep: true
};
var accessories = {
    path: "/accessories",
    title: "אביזרים",
    showStep: true
};
var summary = {
    path: "/summary",
    title: "סיכום ההזמנה",
    showStep: true
};
var order = {
    path: "/order",
    title: "יצירת הזמנה",
    showStep: false
};
var payment = {
    path: "/payment",
    title: "תשלום מקדמה",
    showStep: false
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    detailing: detailing,
    color: color,
    upholstery: upholstery,
    accessories: accessories,
    summary: summary,
    order: order,
    payment: payment,
    array: [
        detailing,
        color,
        upholstery,
        accessories,
        summary,
        order,
        payment
    ]
});


/***/ }),

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _material_ui_core_locale__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6159);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89413);
/* harmony import */ var _material_ui_core_styles_createBreakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94811);
/* harmony import */ var components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45053);







var colors = {
    //
    black: "#000000",
    white: "#ffffff",
    chineseBlack: "#161616",
    charlestonGrey: "#2b2b2b",
    borderGrey: "#d5d5d5",
    lightGrey: "#f5f5f5",
    mazdaRed: "#920a2d",
    arsenic: "#414141",
    philippineGray: "#808080",
    cssYellow: "yellow"
};
var breakpoints = (0,_material_ui_core_styles_createBreakpoints__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({});
var muiThemeOptions = {
    direction: "rtl",
    palette: {
        primary: {
            main: colors.charlestonGrey,
            contrastText: colors.white
        },
        secondary: {
            main: colors.white,
            contrastText: colors.chineseBlack
        },
        text: {
            primary: colors.chineseBlack,
            secondary: colors.chineseBlack
        },
        error: {
            main: "#b50303"
        }
    },
    shadows: new Array(25).fill("none"),
    shape: {
        borderRadius: 2
    },
    typography: {
        fontFamily: "MazdaType, OENaPro, sans-serif;",
        h2: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            fontSize: "1.125rem",
            fontWeight: 300,
            letterSpacing: "0.72px",
            margin: "16px 0"
        }, breakpoints.up("md"), {
            fontSize: "1.25rem"
        }),
        h3: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            fontSize: "0.875rem",
            fontWeight: 600,
            letterSpacing: "0.56px",
            marginTop: "24px",
            marginBottom: "20px",
            borderBottom: "1px solid ".concat(colors.chineseBlack),
            paddingBottom: "8px"
        }, breakpoints.up("md"), {
            fontSize: "1rem"
        }),
        h4: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            fontSize: "0.875rem",
            fontWeight: 600,
            letterSpacing: "0.84px",
            marginTop: "20px",
            marginBottom: "8px",
            color: colors.chineseBlack
        }, breakpoints.up("md"), {
            fontSize: "1rem"
        }),
        body1: {
            fontSize: "1rem",
            fontWeight: 400,
            lineHeight: "1.43",
            letterSpacing: "0.1em",
            color: colors.black
        }
    },
    props: {
        MuiFormControl: {
            fullWidth: true
        },
        MuiTextField: {
            fullWidth: true
        },
        // Removed to make forms shrink labels
        // MuiInputLabel: {
        //   shrink: true,
        // },
        MuiInput: {
            disableUnderline: true
        },
        MuiLink: {
            underline: "always"
        }
    }
};
var muiTheme = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(muiThemeOptions, _material_ui_core_locale__WEBPACK_IMPORTED_MODULE_4__/* .heIL */ .Az);
muiThemeOptions.overrides = {
    MuiButton: {
        containedPrimary: {
            backgroundColor: colors.mazdaRed,
            color: colors.white,
            fontSize: "1rem",
            fontWeight: 600,
            letterSpacing: "0.64px",
            "&:hover": {
                backgroundColor: colors.mazdaRed
            },
            "@media (hover: none)": {
                "&&:hover": {
                    backgroundColor: colors.mazdaRed
                }
            },
            "&:focus": {
                backgroundColor: colors.white,
                color: colors.mazdaRed,
                outline: "2px solid ".concat(colors.mazdaRed)
            }
        },
        root: {
            "&:focus": {
                outline: "1px solid currentColor"
            }
        }
    },
    MuiIconButton: {
        colorSecondary: {
            backgroundColor: colors.philippineGray,
            "&:hover": colors.philippineGray
        },
        root: {
            "&:hover": colors.philippineGray
        }
    },
    MuiTouchRipple: {
        rippleVisible: {
            opacity: 0.15,
            animation: "$enter 550ms ".concat(muiTheme.transitions.easing.easeInOut)
        }
    },
    MuiOutlinedInput: {
        root: {
            borderRadius: "3px"
        }
    },
    MuiInputLabel: {
        outlined: {
            transform: "translate(12px, 34px) scale(1)"
        },
        formControl: {
            position: "static"
        },
        shrink: {
            transform: "none"
        }
    },
    MuiFormLabel: {
        root: {
            fontFamily: "".concat(components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_0__/* .Font.OENaPro */ .Zx.OENaPro),
            fontSize: "16px",
            fontWeight: 300,
            lineHeight: "22px",
            letterSpacing: "0em",
            color: colors.chineseBlack,
            "&$error": {
                color: colors.chineseBlack
            },
            "& + .MuiInput-formControl": {
                marginTop: "6px"
            }
        },
        asterisk: {
            color: muiTheme.palette.error.main
        }
    },
    MuiInput: {
        input: {
            border: "1px solid ".concat(colors.chineseBlack),
            borderRadius: muiTheme.shape.borderRadius,
            height: "40px",
            boxSizing: "border-box",
            padding: muiTheme.spacing(1)
        },
        root: {
            "&$disabled": {
                color: colors.chineseBlack
            }
        }
    },
    MuiFormControl: {
        root: {
            marginBottom: muiTheme.spacing(0.5)
        }
    },
    MuiFormHelperText: {
        root: {
            marginTop: 0
        }
    },
    MuiDialog: {
        paper: {
            margin: "12px",
            "&.authDialog": {
                width: "328px !important"
            },
            "&.leadForm": {
                width: "670px !important",
                maxWidth: "670px"
            },
            "&.summaryTestDrive": {
                width: "670px !important",
                maxWidth: "670px",
                padding: "0 30px"
            }
        },
        paperWidthMd: {
            width: "560px"
        }
    },
    MuiCheckbox: {
        colorPrimary: {
            "&$checked": {
                color: colors.black
            }
        },
        root: {
            "&.orderCheckbox + span": {
                fontFamily: "".concat(components_shopFeatures_wizard_constants__WEBPACK_IMPORTED_MODULE_0__/* .Font.OENaPro */ .Zx.OENaPro),
                fontSize: "12px",
                fontWeight: "300",
                lineHeight: "16px",
                letterSpacing: "0em"
            }
        }
    },
    MuiSelect: {
        select: {
            borderRadius: "3px",
            height: "45px !important",
            border: "1px solid #999",
            display: "flex",
            alignItems: "center",
            "&:focus": {
                borderRadius: "3px",
                height: "45px !important",
                border: "1px solid #999"
            }
        }
    },
    MuiInputBase: {
        root: {
            marginTop: "0 !important"
        },
        input: {
            height: "45px !important",
            padding: "0 10px !important"
        }
    },
    MuiPaper: {
        root: {
            width: "670px !important"
        }
    },
    MuiTextField: {
        root: {
            "&.orderField input": {
                direction: "ltr !important"
            }
        }
    }
};
var shopTheme = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(muiThemeOptions, _material_ui_core_locale__WEBPACK_IMPORTED_MODULE_4__/* .heIL */ .Az)), {
    colors: colors
});
/* harmony default export */ __webpack_exports__["Z"] = (shopTheme);


/***/ })

}]);